// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/catalog/resources/datatypes.proto
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Coordinates } from "../../common/coordinates";
import { DayOfWeek } from "../../common/day_of_week";
import { MeasurementUnit } from "../../common/measurement_units";
import { Money } from "../../common/money";
import { SortOrder } from "../../common/sort";
import { SourceApplication } from "../../common/source_application";
import { Address } from "../../resources/address";
import { AggregationStrategy, CatalogAttributeType, CatalogCategoryType, CatalogDiscountApplicationMethod, CatalogDiscountModifyTaxBasis, CatalogDiscountType, CatalogFloorPlanTileShape, CatalogItemProductType, CatalogItemVariationWeightUnit, CatalogModifierListModifierType, CatalogModifierListSelectionType, CatalogObjectType, CatalogPageLayout, CatalogPlaceholderType, CatalogPricingRuleApplicationMode, CatalogPricingSource, CatalogPricingType, CatalogProductName, CatalogProductSetLineItemType, CatalogQuickAmountsSettingsOption, CatalogQuickAmountType, CatalogSalePriceType, CatalogServiceChargeAutoEnableType, CatalogServiceChargeCalculationPhase, CatalogServiceChargeCalculationType, CatalogServiceChargeEcomFulfillmentType, CatalogServiceChargeTreatmentType, CatalogServiceChargeType, CatalogTagType, CatalogTicketGroupNamingMethod, CatalogTicketGroupPrefixTableNames, CatalogVisibility, CatalogVoidReasonAppointmentsType, CheckoutLinkType, CompositionType, DiscountTargetScope, EcomVisibility, EventLocationType, ExcludeStrategy, InventoryAlertType, PricingRulePaymentType, ServiceChargeTargetScope, ServiceCostType, SubscriptionCadence, SubscriptionPricingType, Subscriptions_Tenant, TaxCalculationPhase, TaxInclusionType, } from "./enums";
export const protobufPackage = "squareup.connect.v2.merchant_catalog.resources";
/**
 * Describes whether the object should always straight fire by default
 * or never straight fire by default.
 */
export var StraightFireType;
(function (StraightFireType) {
    /** UNKNOWN_STRAIGHT_FIRE - DO NOT USE */
    StraightFireType[StraightFireType["UNKNOWN_STRAIGHT_FIRE"] = 0] = "UNKNOWN_STRAIGHT_FIRE";
    /** NEVER_STRAIGHT_FIRE - Indicates that the object should never straight fire by default. */
    StraightFireType[StraightFireType["NEVER_STRAIGHT_FIRE"] = 1] = "NEVER_STRAIGHT_FIRE";
    /** ALWAYS_STRAIGHT_FIRE - Indicates that the object should always straight fire by default. */
    StraightFireType[StraightFireType["ALWAYS_STRAIGHT_FIRE"] = 2] = "ALWAYS_STRAIGHT_FIRE";
    StraightFireType[StraightFireType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StraightFireType || (StraightFireType = {}));
/** @desc Supported stock levels in the item inventory. */
export var CatalogQuery_FilteredItems_StockLevel;
(function (CatalogQuery_FilteredItems_StockLevel) {
    CatalogQuery_FilteredItems_StockLevel[CatalogQuery_FilteredItems_StockLevel["STOCK_LEVEL_DO_NOT_USE"] = 0] = "STOCK_LEVEL_DO_NOT_USE";
    /** OUT - @desc The item inventory is empty. */
    CatalogQuery_FilteredItems_StockLevel[CatalogQuery_FilteredItems_StockLevel["OUT"] = 1] = "OUT";
    /** LOW - @desc The item inventory is low. */
    CatalogQuery_FilteredItems_StockLevel[CatalogQuery_FilteredItems_StockLevel["LOW"] = 2] = "LOW";
    CatalogQuery_FilteredItems_StockLevel[CatalogQuery_FilteredItems_StockLevel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogQuery_FilteredItems_StockLevel || (CatalogQuery_FilteredItems_StockLevel = {}));
/**
 * @desc Supported nullable attributes that can be used in a query expression to return
 * items or item variations if values of the specified attribute on the items or item
 * variations match the associated query expression or the specified attribute do not exist
 * on the items or item variations.
 */
export var CatalogQuery_FilteredItems_NullableAttribute;
(function (CatalogQuery_FilteredItems_NullableAttribute) {
    /** VENDOR_TOKEN - @desc `VENDOR_TOKEN` is the nullable search attribute. */
    CatalogQuery_FilteredItems_NullableAttribute[CatalogQuery_FilteredItems_NullableAttribute["VENDOR_TOKEN"] = 1] = "VENDOR_TOKEN";
    CatalogQuery_FilteredItems_NullableAttribute[CatalogQuery_FilteredItems_NullableAttribute["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogQuery_FilteredItems_NullableAttribute || (CatalogQuery_FilteredItems_NullableAttribute = {}));
/** @desc Supported types of a custom attribute query expression. */
export var CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType;
(function (CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType) {
    CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType[CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType["CUSTOM_ATTRIBUTE_FILTER_TYPE_DO_NOT_USE"] = 0] = "CUSTOM_ATTRIBUTE_FILTER_TYPE_DO_NOT_USE";
    /** EXACT - @desc Match exactly corresponding custom attribute values against a specified query expression. */
    CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType[CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType["EXACT"] = 1] = "EXACT";
    /** PREFIX - @desc Match the start of corresponding custom attribute values against a specified query expression. */
    CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType[CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType["PREFIX"] = 2] = "PREFIX";
    /** RANGE - @desc Match the number values  of corresponding custom attribute values to fit into the specified range in a query expression. */
    CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType[CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType["RANGE"] = 3] = "RANGE";
    /** BOOLEAN - @desc Match the boolean values of corresponding custom attribute values against a specified query expression. */
    CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType[CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType["BOOLEAN"] = 4] = "BOOLEAN";
    CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType[CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType || (CatalogQuery_FilteredItems_CustomAttributeFilter_FilterType = {}));
/** @desc The type of dietary preference for the `FOOD_AND_BEV` type of items and integredients. */
export var CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType;
(function (CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType) {
    CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType[CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType["DIETARY_PREFERENCE_TYPE_DO_NOT_USE"] = 0] = "DIETARY_PREFERENCE_TYPE_DO_NOT_USE";
    /** STANDARD - @desc A standard value from a pre-determined list. */
    CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType[CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType["STANDARD"] = 1] = "STANDARD";
    /** CUSTOM - @desc A user-defined custom value. */
    CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType[CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType["CUSTOM"] = 2] = "CUSTOM";
    CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType[CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType || (CatalogItem_FoodAndBeverageDetails_DietaryPreferenceType = {}));
/** @desc Standard dietary preferences for food and beverage items that are recommended on item creation. */
export var CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference;
(function (CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference) {
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["STANDARD_DIETARY_PREFERENCE_DO_NOT_USE"] = 0] = "STANDARD_DIETARY_PREFERENCE_DO_NOT_USE";
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["DAIRY_FREE"] = 1] = "DAIRY_FREE";
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["GLUTEN_FREE"] = 2] = "GLUTEN_FREE";
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["HALAL"] = 3] = "HALAL";
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["KOSHER"] = 4] = "KOSHER";
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["NUT_FREE"] = 5] = "NUT_FREE";
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["VEGAN"] = 6] = "VEGAN";
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["VEGETARIAN"] = 7] = "VEGETARIAN";
    CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference[CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference || (CatalogItem_FoodAndBeverageDetails_DietaryPreference_StandardDietaryPreference = {}));
/** @desc Standard ingredients for food and beverage items that are recommended on item creation. */
export var CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient;
(function (CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient) {
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["STANDARD_INGREDIENT_DO_NOT_USE"] = 0] = "STANDARD_INGREDIENT_DO_NOT_USE";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["CELERY"] = 1] = "CELERY";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["CRUSTACEANS"] = 2] = "CRUSTACEANS";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["EGGS"] = 3] = "EGGS";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["FISH"] = 4] = "FISH";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["GLUTEN"] = 5] = "GLUTEN";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["LUPIN"] = 6] = "LUPIN";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["MILK"] = 7] = "MILK";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["MOLLUSCS"] = 8] = "MOLLUSCS";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["MUSTARD"] = 9] = "MUSTARD";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["PEANUTS"] = 10] = "PEANUTS";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["SESAME"] = 11] = "SESAME";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["SOY"] = 12] = "SOY";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["SULPHITES"] = 13] = "SULPHITES";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["TREE_NUTS"] = 14] = "TREE_NUTS";
    CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient[CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient || (CatalogItem_FoodAndBeverageDetails_Ingredient_StandardIngredient = {}));
/**
 * --
 * @desc Defines the possible types for a custom attribute.
 * --
 */
export var CatalogCustomAttributeDefinition_Type;
(function (CatalogCustomAttributeDefinition_Type) {
    /** ATTRIBUTE_TYPE_DO_NOT_USE - Hidden internal value. */
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["ATTRIBUTE_TYPE_DO_NOT_USE"] = 0] = "ATTRIBUTE_TYPE_DO_NOT_USE";
    /**
     * STRING - --
     * @desc A free-form string containing up to 255 characters.
     * --
     */
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["STRING"] = 1] = "STRING";
    /** INTEGER - A 64 bit integer */
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["INTEGER"] = 2] = "INTEGER";
    /**
     * BOOLEAN - --
     * @desc A `true` or `false` value.
     * --
     */
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["BOOLEAN"] = 3] = "BOOLEAN";
    /**
     * NUMBER - --
     * @desc A decimal string representation of a number. Can support up to 5 digits after the decimal point.
     * --
     */
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["NUMBER"] = 9] = "NUMBER";
    /**
     * SELECTION - --
     * @desc One or more choices from `allowed_selections`.
     * --
     */
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["SELECTION"] = 10] = "SELECTION";
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["STRING_INT"] = 11] = "STRING_INT";
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["TOKEN_INT"] = 12] = "TOKEN_INT";
    CatalogCustomAttributeDefinition_Type[CatalogCustomAttributeDefinition_Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogCustomAttributeDefinition_Type || (CatalogCustomAttributeDefinition_Type = {}));
/**
 * --
 * @desc Defines the visibility of a custom attribute to sellers in Square
 * client applications, Square APIs or in Square UIs (including Square Point
 * of Sale applications and Square Dashboard).
 * --
 */
export var CatalogCustomAttributeDefinition_SellerVisibility;
(function (CatalogCustomAttributeDefinition_SellerVisibility) {
    /** SELLER_VISIBILITY_DO_NOT_USE - Hidden internal value. */
    CatalogCustomAttributeDefinition_SellerVisibility[CatalogCustomAttributeDefinition_SellerVisibility["SELLER_VISIBILITY_DO_NOT_USE"] = 0] = "SELLER_VISIBILITY_DO_NOT_USE";
    /**
     * SELLER_VISIBILITY_HIDDEN - --
     * @desc Sellers cannot read this custom attribute in Square client
     * applications or Square APIs.
     * --
     */
    CatalogCustomAttributeDefinition_SellerVisibility[CatalogCustomAttributeDefinition_SellerVisibility["SELLER_VISIBILITY_HIDDEN"] = 1] = "SELLER_VISIBILITY_HIDDEN";
    /**
     * SELLER_VISIBILITY_READ_WRITE_VALUES - --
     * @desc Sellers can read and write this custom attribute value in catalog objects,
     * but cannot edit the custom attribute definition.
     * --
     */
    CatalogCustomAttributeDefinition_SellerVisibility[CatalogCustomAttributeDefinition_SellerVisibility["SELLER_VISIBILITY_READ_WRITE_VALUES"] = 2] = "SELLER_VISIBILITY_READ_WRITE_VALUES";
    CatalogCustomAttributeDefinition_SellerVisibility[CatalogCustomAttributeDefinition_SellerVisibility["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogCustomAttributeDefinition_SellerVisibility || (CatalogCustomAttributeDefinition_SellerVisibility = {}));
/**
 * --
 * @desc Defines the visibility of a custom attribute to applications other than their
 * creating application.
 * --
 */
export var CatalogCustomAttributeDefinition_AppVisibility;
(function (CatalogCustomAttributeDefinition_AppVisibility) {
    /** APP_VISIBILITY_DO_NOT_USE - Hidden internal value. */
    CatalogCustomAttributeDefinition_AppVisibility[CatalogCustomAttributeDefinition_AppVisibility["APP_VISIBILITY_DO_NOT_USE"] = 0] = "APP_VISIBILITY_DO_NOT_USE";
    /**
     * APP_VISIBILITY_HIDDEN - --
     * @desc Other applications cannot read this custom attribute.
     * --
     */
    CatalogCustomAttributeDefinition_AppVisibility[CatalogCustomAttributeDefinition_AppVisibility["APP_VISIBILITY_HIDDEN"] = 1] = "APP_VISIBILITY_HIDDEN";
    /**
     * APP_VISIBILITY_READ_ONLY - --
     * @desc Other applications can read this custom attribute definition and
     * values.
     * --
     */
    CatalogCustomAttributeDefinition_AppVisibility[CatalogCustomAttributeDefinition_AppVisibility["APP_VISIBILITY_READ_ONLY"] = 2] = "APP_VISIBILITY_READ_ONLY";
    /**
     * APP_VISIBILITY_READ_WRITE_VALUES - --
     * @desc Other applications can read and write custom attribute values on objects.
     * They can read but cannot edit the custom attribute definition.
     * --
     */
    CatalogCustomAttributeDefinition_AppVisibility[CatalogCustomAttributeDefinition_AppVisibility["APP_VISIBILITY_READ_WRITE_VALUES"] = 3] = "APP_VISIBILITY_READ_WRITE_VALUES";
    CatalogCustomAttributeDefinition_AppVisibility[CatalogCustomAttributeDefinition_AppVisibility["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CatalogCustomAttributeDefinition_AppVisibility || (CatalogCustomAttributeDefinition_AppVisibility = {}));
/** @desc Defines searchable attributes supported by MultiFieldTextFilter. */
export var MultiFieldTextFilter_SearchField;
(function (MultiFieldTextFilter_SearchField) {
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["SEARCH_FIELD_DO_NOT_USE"] = 0] = "SEARCH_FIELD_DO_NOT_USE";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_NAME"] = 1] = "ITEM_NAME";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_DESCRIPTION"] = 2] = "ITEM_DESCRIPTION";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_ABBREVIATION"] = 3] = "ITEM_ABBREVIATION";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_VARIATION_NAME"] = 4] = "ITEM_VARIATION_NAME";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_VARIATION_SKU"] = 5] = "ITEM_VARIATION_SKU";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_VARIATION_UPC"] = 6] = "ITEM_VARIATION_UPC";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_VARIATION_VENDOR_CODE"] = 7] = "ITEM_VARIATION_VENDOR_CODE";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_CUSTOM_ATTRIBUTES_STRING"] = 8] = "ITEM_CUSTOM_ATTRIBUTES_STRING";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_VARIATION_CUSTOM_ATTRIBUTES_STRING"] = 9] = "ITEM_VARIATION_CUSTOM_ATTRIBUTES_STRING";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_CUSTOM_ATTRIBUTES_NUMBER"] = 10] = "ITEM_CUSTOM_ATTRIBUTES_NUMBER";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_VARIATION_CUSTOM_ATTRIBUTES_NUMBER"] = 11] = "ITEM_VARIATION_CUSTOM_ATTRIBUTES_NUMBER";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_CUSTOM_ATTRIBUTES_SELECTION"] = 12] = "ITEM_CUSTOM_ATTRIBUTES_SELECTION";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["ITEM_VARIATION_CUSTOM_ATTRIBUTES_SELECTION"] = 13] = "ITEM_VARIATION_CUSTOM_ATTRIBUTES_SELECTION";
    MultiFieldTextFilter_SearchField[MultiFieldTextFilter_SearchField["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MultiFieldTextFilter_SearchField || (MultiFieldTextFilter_SearchField = {}));
function createBaseCatalogIdMapping() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogIdMapping",
        clientObjectId: undefined,
        objectId: undefined,
    };
}
export const CatalogIdMapping = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogIdMapping",
    encode(message, writer = _m0.Writer.create()) {
        if (message.clientObjectId !== undefined) {
            writer.uint32(10).string(message.clientObjectId);
        }
        if (message.objectId !== undefined) {
            writer.uint32(18).string(message.objectId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogIdMapping();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.clientObjectId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.objectId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogIdMapping.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogIdMapping();
        message.clientObjectId = object.clientObjectId ?? undefined;
        message.objectId = object.objectId ?? undefined;
        return message;
    },
};
function createBaseCatalogObjectBatch() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObjectBatch", objects: [] };
}
export const CatalogObjectBatch = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObjectBatch",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.objects) {
            CatalogObject.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogObjectBatch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.objects.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogObjectBatch.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogObjectBatch();
        message.objects = object.objects?.map((e) => CatalogObject.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogQuery() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery",
        sortedAttributeQuery: undefined,
        exactQuery: undefined,
        setQuery: undefined,
        prefixQuery: undefined,
        rangeQuery: undefined,
        textQuery: undefined,
        itemsForTaxQuery: undefined,
        itemsForModifierListQuery: undefined,
        itemsForItemOptionsQuery: undefined,
        itemVariationsForItemOptionValuesQuery: undefined,
        filteredItemsQuery: undefined,
        customAttributeUsage: undefined,
        pricingObjectsForProductsQuery: undefined,
        checkoutLinkForItems: undefined,
        legacyIdsQuery: undefined,
        sortedStringIntAttributeQuery: undefined,
        doesNotExistQuery: undefined,
        presentAtLocationsQuery: undefined,
        booleanAttributeQuery: [],
    };
}
export const CatalogQuery = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery",
    encode(message, writer = _m0.Writer.create()) {
        if (message.sortedAttributeQuery !== undefined) {
            CatalogQuery_SortedAttribute.encode(message.sortedAttributeQuery, writer.uint32(10).fork()).ldelim();
        }
        if (message.exactQuery !== undefined) {
            CatalogQuery_Exact.encode(message.exactQuery, writer.uint32(18).fork()).ldelim();
        }
        if (message.setQuery !== undefined) {
            CatalogQuery_Set.encode(message.setQuery, writer.uint32(106).fork()).ldelim();
        }
        if (message.prefixQuery !== undefined) {
            CatalogQuery_Prefix.encode(message.prefixQuery, writer.uint32(26).fork()).ldelim();
        }
        if (message.rangeQuery !== undefined) {
            CatalogQuery_Range.encode(message.rangeQuery, writer.uint32(34).fork()).ldelim();
        }
        if (message.textQuery !== undefined) {
            CatalogQuery_Text.encode(message.textQuery, writer.uint32(42).fork()).ldelim();
        }
        if (message.itemsForTaxQuery !== undefined) {
            CatalogQuery_ItemsForTax.encode(message.itemsForTaxQuery, writer.uint32(50).fork()).ldelim();
        }
        if (message.itemsForModifierListQuery !== undefined) {
            CatalogQuery_ItemsForModifierList.encode(message.itemsForModifierListQuery, writer.uint32(58).fork()).ldelim();
        }
        if (message.itemsForItemOptionsQuery !== undefined) {
            CatalogQuery_ItemsForItemOptions.encode(message.itemsForItemOptionsQuery, writer.uint32(66).fork()).ldelim();
        }
        if (message.itemVariationsForItemOptionValuesQuery !== undefined) {
            CatalogQuery_ItemVariationsForItemOptionValues.encode(message.itemVariationsForItemOptionValuesQuery, writer.uint32(74).fork()).ldelim();
        }
        if (message.filteredItemsQuery !== undefined) {
            CatalogQuery_FilteredItems.encode(message.filteredItemsQuery, writer.uint32(82).fork()).ldelim();
        }
        if (message.customAttributeUsage !== undefined) {
            CatalogQuery_CustomAttributeUsage.encode(message.customAttributeUsage, writer.uint32(90).fork()).ldelim();
        }
        if (message.pricingObjectsForProductsQuery !== undefined) {
            CatalogQuery_PricingObjectsForProducts.encode(message.pricingObjectsForProductsQuery, writer.uint32(114).fork())
                .ldelim();
        }
        if (message.checkoutLinkForItems !== undefined) {
            CatalogQuery_CheckoutLinksForItems.encode(message.checkoutLinkForItems, writer.uint32(122).fork()).ldelim();
        }
        if (message.legacyIdsQuery !== undefined) {
            CatalogQuery_LegacyIds.encode(message.legacyIdsQuery, writer.uint32(138).fork()).ldelim();
        }
        if (message.sortedStringIntAttributeQuery !== undefined) {
            CatalogQuery_SortedStringIntAttribute.encode(message.sortedStringIntAttributeQuery, writer.uint32(146).fork())
                .ldelim();
        }
        if (message.doesNotExistQuery !== undefined) {
            CatalogQuery_DoesNotExist.encode(message.doesNotExistQuery, writer.uint32(154).fork()).ldelim();
        }
        if (message.presentAtLocationsQuery !== undefined) {
            CatalogQuery_PresentAtLocations.encode(message.presentAtLocationsQuery, writer.uint32(162).fork()).ldelim();
        }
        for (const v of message.booleanAttributeQuery) {
            CatalogQuery_BooleanAttribute.encode(v, writer.uint32(170).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sortedAttributeQuery = CatalogQuery_SortedAttribute.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.exactQuery = CatalogQuery_Exact.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.setQuery = CatalogQuery_Set.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.prefixQuery = CatalogQuery_Prefix.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.rangeQuery = CatalogQuery_Range.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.textQuery = CatalogQuery_Text.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.itemsForTaxQuery = CatalogQuery_ItemsForTax.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.itemsForModifierListQuery = CatalogQuery_ItemsForModifierList.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.itemsForItemOptionsQuery = CatalogQuery_ItemsForItemOptions.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.itemVariationsForItemOptionValuesQuery = CatalogQuery_ItemVariationsForItemOptionValues.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.filteredItemsQuery = CatalogQuery_FilteredItems.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.customAttributeUsage = CatalogQuery_CustomAttributeUsage.decode(reader, reader.uint32());
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.pricingObjectsForProductsQuery = CatalogQuery_PricingObjectsForProducts.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.checkoutLinkForItems = CatalogQuery_CheckoutLinksForItems.decode(reader, reader.uint32());
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.legacyIdsQuery = CatalogQuery_LegacyIds.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.sortedStringIntAttributeQuery = CatalogQuery_SortedStringIntAttribute.decode(reader, reader.uint32());
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.doesNotExistQuery = CatalogQuery_DoesNotExist.decode(reader, reader.uint32());
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.presentAtLocationsQuery = CatalogQuery_PresentAtLocations.decode(reader, reader.uint32());
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.booleanAttributeQuery.push(CatalogQuery_BooleanAttribute.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery();
        message.sortedAttributeQuery = (object.sortedAttributeQuery !== undefined && object.sortedAttributeQuery !== null)
            ? CatalogQuery_SortedAttribute.fromPartial(object.sortedAttributeQuery)
            : undefined;
        message.exactQuery = (object.exactQuery !== undefined && object.exactQuery !== null)
            ? CatalogQuery_Exact.fromPartial(object.exactQuery)
            : undefined;
        message.setQuery = (object.setQuery !== undefined && object.setQuery !== null)
            ? CatalogQuery_Set.fromPartial(object.setQuery)
            : undefined;
        message.prefixQuery = (object.prefixQuery !== undefined && object.prefixQuery !== null)
            ? CatalogQuery_Prefix.fromPartial(object.prefixQuery)
            : undefined;
        message.rangeQuery = (object.rangeQuery !== undefined && object.rangeQuery !== null)
            ? CatalogQuery_Range.fromPartial(object.rangeQuery)
            : undefined;
        message.textQuery = (object.textQuery !== undefined && object.textQuery !== null)
            ? CatalogQuery_Text.fromPartial(object.textQuery)
            : undefined;
        message.itemsForTaxQuery = (object.itemsForTaxQuery !== undefined && object.itemsForTaxQuery !== null)
            ? CatalogQuery_ItemsForTax.fromPartial(object.itemsForTaxQuery)
            : undefined;
        message.itemsForModifierListQuery =
            (object.itemsForModifierListQuery !== undefined && object.itemsForModifierListQuery !== null)
                ? CatalogQuery_ItemsForModifierList.fromPartial(object.itemsForModifierListQuery)
                : undefined;
        message.itemsForItemOptionsQuery =
            (object.itemsForItemOptionsQuery !== undefined && object.itemsForItemOptionsQuery !== null)
                ? CatalogQuery_ItemsForItemOptions.fromPartial(object.itemsForItemOptionsQuery)
                : undefined;
        message.itemVariationsForItemOptionValuesQuery =
            (object.itemVariationsForItemOptionValuesQuery !== undefined &&
                object.itemVariationsForItemOptionValuesQuery !== null)
                ? CatalogQuery_ItemVariationsForItemOptionValues.fromPartial(object.itemVariationsForItemOptionValuesQuery)
                : undefined;
        message.filteredItemsQuery = (object.filteredItemsQuery !== undefined && object.filteredItemsQuery !== null)
            ? CatalogQuery_FilteredItems.fromPartial(object.filteredItemsQuery)
            : undefined;
        message.customAttributeUsage = (object.customAttributeUsage !== undefined && object.customAttributeUsage !== null)
            ? CatalogQuery_CustomAttributeUsage.fromPartial(object.customAttributeUsage)
            : undefined;
        message.pricingObjectsForProductsQuery =
            (object.pricingObjectsForProductsQuery !== undefined && object.pricingObjectsForProductsQuery !== null)
                ? CatalogQuery_PricingObjectsForProducts.fromPartial(object.pricingObjectsForProductsQuery)
                : undefined;
        message.checkoutLinkForItems = (object.checkoutLinkForItems !== undefined && object.checkoutLinkForItems !== null)
            ? CatalogQuery_CheckoutLinksForItems.fromPartial(object.checkoutLinkForItems)
            : undefined;
        message.legacyIdsQuery = (object.legacyIdsQuery !== undefined && object.legacyIdsQuery !== null)
            ? CatalogQuery_LegacyIds.fromPartial(object.legacyIdsQuery)
            : undefined;
        message.sortedStringIntAttributeQuery =
            (object.sortedStringIntAttributeQuery !== undefined && object.sortedStringIntAttributeQuery !== null)
                ? CatalogQuery_SortedStringIntAttribute.fromPartial(object.sortedStringIntAttributeQuery)
                : undefined;
        message.doesNotExistQuery = (object.doesNotExistQuery !== undefined && object.doesNotExistQuery !== null)
            ? CatalogQuery_DoesNotExist.fromPartial(object.doesNotExistQuery)
            : undefined;
        message.presentAtLocationsQuery =
            (object.presentAtLocationsQuery !== undefined && object.presentAtLocationsQuery !== null)
                ? CatalogQuery_PresentAtLocations.fromPartial(object.presentAtLocationsQuery)
                : undefined;
        message.booleanAttributeQuery =
            object.booleanAttributeQuery?.map((e) => CatalogQuery_BooleanAttribute.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogQuery_SortedAttribute() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.SortedAttribute",
        attributeName: undefined,
        initialAttributeValue: undefined,
        sortOrder: undefined,
        includeObjectsMissingAttribute: undefined,
    };
}
export const CatalogQuery_SortedAttribute = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.SortedAttribute",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeName !== undefined) {
            writer.uint32(10).string(message.attributeName);
        }
        if (message.initialAttributeValue !== undefined) {
            writer.uint32(18).string(message.initialAttributeValue);
        }
        if (message.sortOrder !== undefined) {
            writer.uint32(24).int32(message.sortOrder);
        }
        if (message.includeObjectsMissingAttribute !== undefined) {
            writer.uint32(32).bool(message.includeObjectsMissingAttribute);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_SortedAttribute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeName = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.initialAttributeValue = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.sortOrder = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.includeObjectsMissingAttribute = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_SortedAttribute.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_SortedAttribute();
        message.attributeName = object.attributeName ?? undefined;
        message.initialAttributeValue = object.initialAttributeValue ?? undefined;
        message.sortOrder = object.sortOrder ?? undefined;
        message.includeObjectsMissingAttribute = object.includeObjectsMissingAttribute ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_SortedStringIntAttribute() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.SortedStringIntAttribute",
        attributeName: undefined,
        attributeValue: undefined,
        sortOrder: undefined,
        initialIntValue: undefined,
    };
}
export const CatalogQuery_SortedStringIntAttribute = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.SortedStringIntAttribute",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeName !== undefined) {
            writer.uint32(10).string(message.attributeName);
        }
        if (message.attributeValue !== undefined) {
            writer.uint32(18).string(message.attributeValue);
        }
        if (message.sortOrder !== undefined) {
            writer.uint32(24).int32(message.sortOrder);
        }
        if (message.initialIntValue !== undefined) {
            writer.uint32(32).int64(message.initialIntValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_SortedStringIntAttribute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeName = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.attributeValue = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.sortOrder = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.initialIntValue = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_SortedStringIntAttribute.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_SortedStringIntAttribute();
        message.attributeName = object.attributeName ?? undefined;
        message.attributeValue = object.attributeValue ?? undefined;
        message.sortOrder = object.sortOrder ?? undefined;
        message.initialIntValue = object.initialIntValue ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_Exact() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Exact",
        attributeName: undefined,
        attributeValue: undefined,
    };
}
export const CatalogQuery_Exact = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Exact",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeName !== undefined) {
            writer.uint32(10).string(message.attributeName);
        }
        if (message.attributeValue !== undefined) {
            writer.uint32(18).string(message.attributeValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_Exact();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeName = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.attributeValue = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_Exact.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_Exact();
        message.attributeName = object.attributeName ?? undefined;
        message.attributeValue = object.attributeValue ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_Set() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Set",
        attributeName: undefined,
        attributeValues: [],
    };
}
export const CatalogQuery_Set = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Set",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeName !== undefined) {
            writer.uint32(10).string(message.attributeName);
        }
        for (const v of message.attributeValues) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_Set();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeName = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.attributeValues.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_Set.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_Set();
        message.attributeName = object.attributeName ?? undefined;
        message.attributeValues = object.attributeValues?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogQuery_Prefix() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Prefix",
        attributeName: undefined,
        attributePrefix: undefined,
    };
}
export const CatalogQuery_Prefix = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Prefix",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeName !== undefined) {
            writer.uint32(10).string(message.attributeName);
        }
        if (message.attributePrefix !== undefined) {
            writer.uint32(18).string(message.attributePrefix);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_Prefix();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeName = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.attributePrefix = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_Prefix.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_Prefix();
        message.attributeName = object.attributeName ?? undefined;
        message.attributePrefix = object.attributePrefix ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_Range() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Range",
        attributeName: undefined,
        attributeMinValue: undefined,
        attributeMaxValue: undefined,
    };
}
export const CatalogQuery_Range = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Range",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeName !== undefined) {
            writer.uint32(10).string(message.attributeName);
        }
        if (message.attributeMinValue !== undefined) {
            writer.uint32(16).int64(message.attributeMinValue);
        }
        if (message.attributeMaxValue !== undefined) {
            writer.uint32(24).int64(message.attributeMaxValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_Range();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeName = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.attributeMinValue = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.attributeMaxValue = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_Range.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_Range();
        message.attributeName = object.attributeName ?? undefined;
        message.attributeMinValue = object.attributeMinValue ?? undefined;
        message.attributeMaxValue = object.attributeMaxValue ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_BooleanAttribute() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.BooleanAttribute",
        attributeName: undefined,
        attributeValue: undefined,
    };
}
export const CatalogQuery_BooleanAttribute = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.BooleanAttribute",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeName !== undefined) {
            writer.uint32(10).string(message.attributeName);
        }
        if (message.attributeValue !== undefined) {
            writer.uint32(16).bool(message.attributeValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_BooleanAttribute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeName = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.attributeValue = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_BooleanAttribute.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_BooleanAttribute();
        message.attributeName = object.attributeName ?? undefined;
        message.attributeValue = object.attributeValue ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_Text() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Text", keywords: [] };
}
export const CatalogQuery_Text = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Text",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.keywords) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_Text();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.keywords.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_Text.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_Text();
        message.keywords = object.keywords?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogQuery_ItemsForTax() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForTax", taxIds: [] };
}
export const CatalogQuery_ItemsForTax = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForTax",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.taxIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_ItemsForTax();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.taxIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_ItemsForTax.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_ItemsForTax();
        message.taxIds = object.taxIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogQuery_ItemsForModifierList() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForModifierList",
        modifierListIds: [],
    };
}
export const CatalogQuery_ItemsForModifierList = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForModifierList",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.modifierListIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_ItemsForModifierList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.modifierListIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_ItemsForModifierList.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_ItemsForModifierList();
        message.modifierListIds = object.modifierListIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogQuery_ItemsForItemOptions() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForItemOptions",
        itemOptionIds: [],
    };
}
export const CatalogQuery_ItemsForItemOptions = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForItemOptions",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.itemOptionIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_ItemsForItemOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemOptionIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_ItemsForItemOptions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_ItemsForItemOptions();
        message.itemOptionIds = object.itemOptionIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogQuery_ItemVariationsForItemOptionValues() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemVariationsForItemOptionValues",
        itemOptionValueIds: [],
    };
}
export const CatalogQuery_ItemVariationsForItemOptionValues = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemVariationsForItemOptionValues",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.itemOptionValueIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_ItemVariationsForItemOptionValues();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemOptionValueIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_ItemVariationsForItemOptionValues.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_ItemVariationsForItemOptionValues();
        message.itemOptionValueIds = object.itemOptionValueIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogQuery_PricingObjectsForProducts() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.PricingObjectsForProducts",
        productIds: [],
        pricingRuleIds: [],
        includeProducts: undefined,
        includeDiscountObjects: undefined,
        includeTaxObjects: undefined,
        includeCustomAmountObjects: undefined,
        includeAllProductObjects: undefined,
        includeLineItemTypes: [],
        includeCategoryAncestors: undefined,
        enableProductIdRetrieval: undefined,
        unitToken: undefined,
    };
}
export const CatalogQuery_PricingObjectsForProducts = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.PricingObjectsForProducts",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.productIds) {
            writer.uint32(10).string(v);
        }
        for (const v of message.pricingRuleIds) {
            writer.uint32(18).string(v);
        }
        if (message.includeProducts !== undefined) {
            writer.uint32(24).bool(message.includeProducts);
        }
        if (message.includeDiscountObjects !== undefined) {
            writer.uint32(32).bool(message.includeDiscountObjects);
        }
        if (message.includeTaxObjects !== undefined) {
            writer.uint32(40).bool(message.includeTaxObjects);
        }
        if (message.includeCustomAmountObjects !== undefined) {
            writer.uint32(48).bool(message.includeCustomAmountObjects);
        }
        if (message.includeAllProductObjects !== undefined) {
            writer.uint32(56).bool(message.includeAllProductObjects);
        }
        writer.uint32(66).fork();
        for (const v of message.includeLineItemTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.includeCategoryAncestors !== undefined) {
            writer.uint32(72).bool(message.includeCategoryAncestors);
        }
        if (message.enableProductIdRetrieval !== undefined) {
            writer.uint32(80).bool(message.enableProductIdRetrieval);
        }
        if (message.unitToken !== undefined) {
            writer.uint32(90).string(message.unitToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_PricingObjectsForProducts();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.productIds.push(reader.string());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.pricingRuleIds.push(reader.string());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.includeProducts = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.includeDiscountObjects = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.includeTaxObjects = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.includeCustomAmountObjects = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.includeAllProductObjects = reader.bool();
                    continue;
                case 8:
                    if (tag === 64) {
                        message.includeLineItemTypes.push(reader.int32());
                        continue;
                    }
                    if (tag === 66) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.includeLineItemTypes.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.includeCategoryAncestors = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.enableProductIdRetrieval = reader.bool();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.unitToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_PricingObjectsForProducts.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_PricingObjectsForProducts();
        message.productIds = object.productIds?.map((e) => e) || [];
        message.pricingRuleIds = object.pricingRuleIds?.map((e) => e) || [];
        message.includeProducts = object.includeProducts ?? undefined;
        message.includeDiscountObjects = object.includeDiscountObjects ?? undefined;
        message.includeTaxObjects = object.includeTaxObjects ?? undefined;
        message.includeCustomAmountObjects = object.includeCustomAmountObjects ?? undefined;
        message.includeAllProductObjects = object.includeAllProductObjects ?? undefined;
        message.includeLineItemTypes = object.includeLineItemTypes?.map((e) => e) || [];
        message.includeCategoryAncestors = object.includeCategoryAncestors ?? undefined;
        message.enableProductIdRetrieval = object.enableProductIdRetrieval ?? undefined;
        message.unitToken = object.unitToken ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_CheckoutLinksForItems() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.CheckoutLinksForItems", itemIds: [] };
}
export const CatalogQuery_CheckoutLinksForItems = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.CheckoutLinksForItems",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.itemIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_CheckoutLinksForItems();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_CheckoutLinksForItems.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_CheckoutLinksForItems();
        message.itemIds = object.itemIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogQuery_FilteredItems() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems",
        textFilter: undefined,
        searchVendorCode: undefined,
        categoryIds: [],
        stockLevels: [],
        enabledLocationIds: [],
        vendorIds: [],
        productTypes: [],
        customAttributeFilters: [],
        doesNotExist: [],
        sortOrder: undefined,
    };
}
export const CatalogQuery_FilteredItems = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems",
    encode(message, writer = _m0.Writer.create()) {
        if (message.textFilter !== undefined) {
            writer.uint32(10).string(message.textFilter);
        }
        if (message.searchVendorCode !== undefined) {
            writer.uint32(72).bool(message.searchVendorCode);
        }
        for (const v of message.categoryIds) {
            writer.uint32(18).string(v);
        }
        writer.uint32(26).fork();
        for (const v of message.stockLevels) {
            writer.int32(v);
        }
        writer.ldelim();
        for (const v of message.enabledLocationIds) {
            writer.uint32(34).string(v);
        }
        for (const v of message.vendorIds) {
            writer.uint32(42).string(v);
        }
        writer.uint32(50).fork();
        for (const v of message.productTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        for (const v of message.customAttributeFilters) {
            CatalogQuery_FilteredItems_CustomAttributeFilter.encode(v, writer.uint32(58).fork()).ldelim();
        }
        writer.uint32(66).fork();
        for (const v of message.doesNotExist) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.sortOrder !== undefined) {
            writer.uint32(80).int32(message.sortOrder);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_FilteredItems();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.textFilter = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.searchVendorCode = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.categoryIds.push(reader.string());
                    continue;
                case 3:
                    if (tag === 24) {
                        message.stockLevels.push(reader.int32());
                        continue;
                    }
                    if (tag === 26) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.stockLevels.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.enabledLocationIds.push(reader.string());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.vendorIds.push(reader.string());
                    continue;
                case 6:
                    if (tag === 48) {
                        message.productTypes.push(reader.int32());
                        continue;
                    }
                    if (tag === 50) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.productTypes.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.customAttributeFilters.push(CatalogQuery_FilteredItems_CustomAttributeFilter.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag === 64) {
                        message.doesNotExist.push(reader.int32());
                        continue;
                    }
                    if (tag === 66) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.doesNotExist.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.sortOrder = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_FilteredItems.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_FilteredItems();
        message.textFilter = object.textFilter ?? undefined;
        message.searchVendorCode = object.searchVendorCode ?? undefined;
        message.categoryIds = object.categoryIds?.map((e) => e) || [];
        message.stockLevels = object.stockLevels?.map((e) => e) || [];
        message.enabledLocationIds = object.enabledLocationIds?.map((e) => e) || [];
        message.vendorIds = object.vendorIds?.map((e) => e) || [];
        message.productTypes = object.productTypes?.map((e) => e) || [];
        message.customAttributeFilters =
            object.customAttributeFilters?.map((e) => CatalogQuery_FilteredItems_CustomAttributeFilter.fromPartial(e)) || [];
        message.doesNotExist = object.doesNotExist?.map((e) => e) || [];
        message.sortOrder = object.sortOrder ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_FilteredItems_CustomAttributeFilter() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.CustomAttributeFilter",
        filterType: undefined,
        customAttributeDefinitionIds: [],
        customAttributeValueExact: undefined,
        customAttributeValuePrefix: undefined,
        customAttributeMinValue: undefined,
        customAttributeMaxValue: undefined,
    };
}
export const CatalogQuery_FilteredItems_CustomAttributeFilter = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.CustomAttributeFilter",
    encode(message, writer = _m0.Writer.create()) {
        if (message.filterType !== undefined) {
            writer.uint32(8).int32(message.filterType);
        }
        for (const v of message.customAttributeDefinitionIds) {
            writer.uint32(18).string(v);
        }
        if (message.customAttributeValueExact !== undefined) {
            writer.uint32(26).string(message.customAttributeValueExact);
        }
        if (message.customAttributeValuePrefix !== undefined) {
            writer.uint32(34).string(message.customAttributeValuePrefix);
        }
        if (message.customAttributeMinValue !== undefined) {
            writer.uint32(42).string(message.customAttributeMinValue);
        }
        if (message.customAttributeMaxValue !== undefined) {
            writer.uint32(50).string(message.customAttributeMaxValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_FilteredItems_CustomAttributeFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.filterType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.customAttributeDefinitionIds.push(reader.string());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.customAttributeValueExact = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.customAttributeValuePrefix = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.customAttributeMinValue = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.customAttributeMaxValue = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_FilteredItems_CustomAttributeFilter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_FilteredItems_CustomAttributeFilter();
        message.filterType = object.filterType ?? undefined;
        message.customAttributeDefinitionIds = object.customAttributeDefinitionIds?.map((e) => e) || [];
        message.customAttributeValueExact = object.customAttributeValueExact ?? undefined;
        message.customAttributeValuePrefix = object.customAttributeValuePrefix ?? undefined;
        message.customAttributeMinValue = object.customAttributeMinValue ?? undefined;
        message.customAttributeMaxValue = object.customAttributeMaxValue ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_CustomAttributeUsage() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.CustomAttributeUsage",
        customAttributeDefinitionIds: [],
        hasValue: undefined,
    };
}
export const CatalogQuery_CustomAttributeUsage = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.CustomAttributeUsage",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.customAttributeDefinitionIds) {
            writer.uint32(10).string(v);
        }
        if (message.hasValue !== undefined) {
            writer.uint32(16).bool(message.hasValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_CustomAttributeUsage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.customAttributeDefinitionIds.push(reader.string());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.hasValue = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_CustomAttributeUsage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_CustomAttributeUsage();
        message.customAttributeDefinitionIds = object.customAttributeDefinitionIds?.map((e) => e) || [];
        message.hasValue = object.hasValue ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_LegacyIdsAtLocation() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.LegacyIdsAtLocation",
        locationId: undefined,
        legacyIds: [],
    };
}
export const CatalogQuery_LegacyIdsAtLocation = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.LegacyIdsAtLocation",
    encode(message, writer = _m0.Writer.create()) {
        if (message.locationId !== undefined) {
            writer.uint32(10).string(message.locationId);
        }
        for (const v of message.legacyIds) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_LegacyIdsAtLocation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.legacyIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_LegacyIdsAtLocation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_LegacyIdsAtLocation();
        message.locationId = object.locationId ?? undefined;
        message.legacyIds = object.legacyIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogQuery_LegacyIds() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.LegacyIds", legacyIdsAtLocation: [] };
}
export const CatalogQuery_LegacyIds = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.LegacyIds",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.legacyIdsAtLocation) {
            CatalogQuery_LegacyIdsAtLocation.encode(v, writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_LegacyIds();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.legacyIdsAtLocation.push(CatalogQuery_LegacyIdsAtLocation.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_LegacyIds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_LegacyIds();
        message.legacyIdsAtLocation =
            object.legacyIdsAtLocation?.map((e) => CatalogQuery_LegacyIdsAtLocation.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogQuery_DoesNotExist() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.DoesNotExist",
        attributeName: undefined,
    };
}
export const CatalogQuery_DoesNotExist = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.DoesNotExist",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeName !== undefined) {
            writer.uint32(10).string(message.attributeName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_DoesNotExist();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_DoesNotExist.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_DoesNotExist();
        message.attributeName = object.attributeName ?? undefined;
        return message;
    },
};
function createBaseCatalogQuery_PresentAtLocations() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.PresentAtLocations", locationIds: [] };
}
export const CatalogQuery_PresentAtLocations = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.PresentAtLocations",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.locationIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuery_PresentAtLocations();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locationIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuery_PresentAtLocations.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuery_PresentAtLocations();
        message.locationIds = object.locationIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogModifierOverride() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogModifierOverride",
        modifierId: undefined,
        onByDefault: undefined,
        hiddenOnline: undefined,
    };
}
export const CatalogModifierOverride = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogModifierOverride",
    encode(message, writer = _m0.Writer.create()) {
        if (message.modifierId !== undefined) {
            writer.uint32(10).string(message.modifierId);
        }
        if (message.onByDefault !== undefined) {
            writer.uint32(16).bool(message.onByDefault);
        }
        if (message.hiddenOnline !== undefined) {
            writer.uint32(24).bool(message.hiddenOnline);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogModifierOverride();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.modifierId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.onByDefault = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.hiddenOnline = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogModifierOverride.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogModifierOverride();
        message.modifierId = object.modifierId ?? undefined;
        message.onByDefault = object.onByDefault ?? undefined;
        message.hiddenOnline = object.hiddenOnline ?? undefined;
        return message;
    },
};
function createBaseCatalogItemModifierListInfo() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemModifierListInfo",
        modifierListId: undefined,
        visibility: undefined,
        modifierOverrides: [],
        minSelectedModifiers: undefined,
        maxSelectedModifiers: undefined,
        enabled: undefined,
        hiddenFromCustomer: undefined,
        ordinal: undefined,
    };
}
export const CatalogItemModifierListInfo = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemModifierListInfo",
    encode(message, writer = _m0.Writer.create()) {
        if (message.modifierListId !== undefined) {
            writer.uint32(10).string(message.modifierListId);
        }
        if (message.visibility !== undefined) {
            writer.uint32(16).int32(message.visibility);
        }
        for (const v of message.modifierOverrides) {
            CatalogModifierOverride.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.minSelectedModifiers !== undefined) {
            writer.uint32(32).int32(message.minSelectedModifiers);
        }
        if (message.maxSelectedModifiers !== undefined) {
            writer.uint32(40).int32(message.maxSelectedModifiers);
        }
        if (message.enabled !== undefined) {
            writer.uint32(48).bool(message.enabled);
        }
        if (message.hiddenFromCustomer !== undefined) {
            writer.uint32(56).bool(message.hiddenFromCustomer);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(64).int32(message.ordinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItemModifierListInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.modifierListId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.visibility = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.modifierOverrides.push(CatalogModifierOverride.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.minSelectedModifiers = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.maxSelectedModifiers = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.hiddenFromCustomer = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItemModifierListInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItemModifierListInfo();
        message.modifierListId = object.modifierListId ?? undefined;
        message.visibility = object.visibility ?? undefined;
        message.modifierOverrides = object.modifierOverrides?.map((e) => CatalogModifierOverride.fromPartial(e)) || [];
        message.minSelectedModifiers = object.minSelectedModifiers ?? undefined;
        message.maxSelectedModifiers = object.maxSelectedModifiers ?? undefined;
        message.enabled = object.enabled ?? undefined;
        message.hiddenFromCustomer = object.hiddenFromCustomer ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseCatalogItemOptionForItem() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionForItem", itemOptionId: undefined };
}
export const CatalogItemOptionForItem = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionForItem",
    encode(message, writer = _m0.Writer.create()) {
        if (message.itemOptionId !== undefined) {
            writer.uint32(10).string(message.itemOptionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItemOptionForItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemOptionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItemOptionForItem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItemOptionForItem();
        message.itemOptionId = object.itemOptionId ?? undefined;
        return message;
    },
};
function createBaseCatalogObjectCategory() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObjectCategory",
        id: undefined,
        ordinal: undefined,
    };
}
export const CatalogObjectCategory = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObjectCategory",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== undefined) {
            writer.uint32(10).string(message.id);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int64(message.ordinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogObjectCategory();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogObjectCategory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogObjectCategory();
        message.id = object.id ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseCatalogEcomSeoData() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogEcomSeoData",
        pageTitle: undefined,
        pageDescription: undefined,
        permalink: undefined,
    };
}
export const CatalogEcomSeoData = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogEcomSeoData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.pageTitle !== undefined) {
            writer.uint32(10).string(message.pageTitle);
        }
        if (message.pageDescription !== undefined) {
            writer.uint32(18).string(message.pageDescription);
        }
        if (message.permalink !== undefined) {
            writer.uint32(26).string(message.permalink);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogEcomSeoData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.pageTitle = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.pageDescription = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.permalink = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogEcomSeoData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogEcomSeoData();
        message.pageTitle = object.pageTitle ?? undefined;
        message.pageDescription = object.pageDescription ?? undefined;
        message.permalink = object.permalink ?? undefined;
        return message;
    },
};
function createBaseCatalogOpenGraphData() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogOpenGraphData",
        linkTitle: undefined,
        linkDescription: undefined,
    };
}
export const CatalogOpenGraphData = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogOpenGraphData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.linkTitle !== undefined) {
            writer.uint32(10).string(message.linkTitle);
        }
        if (message.linkDescription !== undefined) {
            writer.uint32(18).string(message.linkDescription);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogOpenGraphData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.linkTitle = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.linkDescription = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogOpenGraphData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogOpenGraphData();
        message.linkTitle = object.linkTitle ?? undefined;
        message.linkDescription = object.linkDescription ?? undefined;
        return message;
    },
};
function createBaseCatalogItem() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem",
        name: undefined,
        description: undefined,
        abbreviation: undefined,
        labelColor: undefined,
        isTaxable: undefined,
        visibility: undefined,
        availableOnline: undefined,
        availableForPickup: undefined,
        availableElectronically: undefined,
        categoryId: undefined,
        buyerFacingName: undefined,
        ordinal: undefined,
        taxIds: [],
        modifierListInfo: [],
        imageUrl: undefined,
        variations: [],
        productType: undefined,
        skipModifierScreen: undefined,
        itemOptions: [],
        ecomUri: undefined,
        ecomImageUris: [],
        ecomAvailable: undefined,
        onlineStoreData: undefined,
        ecomBuyButtonText: undefined,
        ecomVisibility: undefined,
        imageIds: [],
        legacyTaxIds: [],
        sortName: undefined,
        event: undefined,
        categories: [],
        pickupFulfillmentPreferencesId: undefined,
        deliveryFulfillmentPreferencesId: undefined,
        descriptionHtml: undefined,
        descriptionPlaintext: undefined,
        kitchenName: undefined,
        ecomAllowOrderItemQuantities: undefined,
        ecomOrderItemMaxQuantity: undefined,
        channels: [],
        locationOverrides: [],
        shippingFulfillmentPreferencesId: undefined,
        dineInFulfillmentPreferencesId: undefined,
        isArchived: undefined,
        requiresSubscriptionToSell: undefined,
        ageRestrictionId: undefined,
        ecomSeoData: undefined,
        posDisplayName: undefined,
        foodAndBeverageDetails: undefined,
        comboTypeDetails: undefined,
        reportingCategory: undefined,
        openGraphData: undefined,
        customShippingBoxId: undefined,
        taxCategoryId: undefined,
    };
}
export const CatalogItem = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.description !== undefined) {
            writer.uint32(18).string(message.description);
        }
        if (message.abbreviation !== undefined) {
            writer.uint32(26).string(message.abbreviation);
        }
        if (message.labelColor !== undefined) {
            writer.uint32(34).string(message.labelColor);
        }
        if (message.isTaxable !== undefined) {
            writer.uint32(40).bool(message.isTaxable);
        }
        if (message.visibility !== undefined) {
            writer.uint32(48).int32(message.visibility);
        }
        if (message.availableOnline !== undefined) {
            writer.uint32(56).bool(message.availableOnline);
        }
        if (message.availableForPickup !== undefined) {
            writer.uint32(64).bool(message.availableForPickup);
        }
        if (message.availableElectronically !== undefined) {
            writer.uint32(72).bool(message.availableElectronically);
        }
        if (message.categoryId !== undefined) {
            writer.uint32(82).string(message.categoryId);
        }
        if (message.buyerFacingName !== undefined) {
            writer.uint32(90).string(message.buyerFacingName);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(96).int32(message.ordinal);
        }
        for (const v of message.taxIds) {
            writer.uint32(106).string(v);
        }
        for (const v of message.modifierListInfo) {
            CatalogItemModifierListInfo.encode(v, writer.uint32(114).fork()).ldelim();
        }
        if (message.imageUrl !== undefined) {
            writer.uint32(122).string(message.imageUrl);
        }
        for (const v of message.variations) {
            CatalogObject.encode(v, writer.uint32(130).fork()).ldelim();
        }
        if (message.productType !== undefined) {
            writer.uint32(136).int32(message.productType);
        }
        if (message.skipModifierScreen !== undefined) {
            writer.uint32(144).bool(message.skipModifierScreen);
        }
        for (const v of message.itemOptions) {
            CatalogItemOptionForItem.encode(v, writer.uint32(154).fork()).ldelim();
        }
        if (message.ecomUri !== undefined) {
            writer.uint32(162).string(message.ecomUri);
        }
        for (const v of message.ecomImageUris) {
            writer.uint32(170).string(v);
        }
        if (message.ecomAvailable !== undefined) {
            writer.uint32(176).bool(message.ecomAvailable);
        }
        if (message.onlineStoreData !== undefined) {
            writer.uint32(186).string(message.onlineStoreData);
        }
        if (message.ecomBuyButtonText !== undefined) {
            writer.uint32(194).string(message.ecomBuyButtonText);
        }
        if (message.ecomVisibility !== undefined) {
            writer.uint32(200).int32(message.ecomVisibility);
        }
        for (const v of message.imageIds) {
            writer.uint32(210).string(v);
        }
        for (const v of message.legacyTaxIds) {
            writer.uint32(218).string(v);
        }
        if (message.sortName !== undefined) {
            writer.uint32(226).string(message.sortName);
        }
        if (message.event !== undefined) {
            Event.encode(message.event, writer.uint32(242).fork()).ldelim();
        }
        for (const v of message.categories) {
            CatalogObjectCategory.encode(v, writer.uint32(250).fork()).ldelim();
        }
        if (message.pickupFulfillmentPreferencesId !== undefined) {
            writer.uint32(266).string(message.pickupFulfillmentPreferencesId);
        }
        if (message.deliveryFulfillmentPreferencesId !== undefined) {
            writer.uint32(274).string(message.deliveryFulfillmentPreferencesId);
        }
        if (message.descriptionHtml !== undefined) {
            writer.uint32(282).string(message.descriptionHtml);
        }
        if (message.descriptionPlaintext !== undefined) {
            writer.uint32(290).string(message.descriptionPlaintext);
        }
        if (message.kitchenName !== undefined) {
            writer.uint32(298).string(message.kitchenName);
        }
        if (message.ecomAllowOrderItemQuantities !== undefined) {
            writer.uint32(304).bool(message.ecomAllowOrderItemQuantities);
        }
        if (message.ecomOrderItemMaxQuantity !== undefined) {
            writer.uint32(312).int32(message.ecomOrderItemMaxQuantity);
        }
        for (const v of message.channels) {
            writer.uint32(322).string(v);
        }
        for (const v of message.locationOverrides) {
            ItemLocationOverrides.encode(v, writer.uint32(330).fork()).ldelim();
        }
        if (message.shippingFulfillmentPreferencesId !== undefined) {
            writer.uint32(338).string(message.shippingFulfillmentPreferencesId);
        }
        if (message.dineInFulfillmentPreferencesId !== undefined) {
            writer.uint32(346).string(message.dineInFulfillmentPreferencesId);
        }
        if (message.isArchived !== undefined) {
            writer.uint32(352).bool(message.isArchived);
        }
        if (message.requiresSubscriptionToSell !== undefined) {
            writer.uint32(360).bool(message.requiresSubscriptionToSell);
        }
        if (message.ageRestrictionId !== undefined) {
            writer.uint32(370).string(message.ageRestrictionId);
        }
        if (message.ecomSeoData !== undefined) {
            CatalogEcomSeoData.encode(message.ecomSeoData, writer.uint32(378).fork()).ldelim();
        }
        if (message.posDisplayName !== undefined) {
            writer.uint32(386).string(message.posDisplayName);
        }
        if (message.foodAndBeverageDetails !== undefined) {
            CatalogItem_FoodAndBeverageDetails.encode(message.foodAndBeverageDetails, writer.uint32(394).fork()).ldelim();
        }
        if (message.comboTypeDetails !== undefined) {
            CatalogItem_CatalogItemComboTypeDetails.encode(message.comboTypeDetails, writer.uint32(402).fork()).ldelim();
        }
        if (message.reportingCategory !== undefined) {
            CatalogObjectCategory.encode(message.reportingCategory, writer.uint32(410).fork()).ldelim();
        }
        if (message.openGraphData !== undefined) {
            CatalogOpenGraphData.encode(message.openGraphData, writer.uint32(418).fork()).ldelim();
        }
        if (message.customShippingBoxId !== undefined) {
            writer.uint32(426).string(message.customShippingBoxId);
        }
        if (message.taxCategoryId !== undefined) {
            writer.uint32(434).string(message.taxCategoryId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.abbreviation = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.labelColor = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.isTaxable = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.visibility = reader.int32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.availableOnline = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.availableForPickup = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.availableElectronically = reader.bool();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.categoryId = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.buyerFacingName = reader.string();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.taxIds.push(reader.string());
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.modifierListInfo.push(CatalogItemModifierListInfo.decode(reader, reader.uint32()));
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.imageUrl = reader.string();
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.variations.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.productType = reader.int32();
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.skipModifierScreen = reader.bool();
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.itemOptions.push(CatalogItemOptionForItem.decode(reader, reader.uint32()));
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.ecomUri = reader.string();
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.ecomImageUris.push(reader.string());
                    continue;
                case 22:
                    if (tag !== 176) {
                        break;
                    }
                    message.ecomAvailable = reader.bool();
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.onlineStoreData = reader.string();
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.ecomBuyButtonText = reader.string();
                    continue;
                case 25:
                    if (tag !== 200) {
                        break;
                    }
                    message.ecomVisibility = reader.int32();
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.imageIds.push(reader.string());
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.legacyTaxIds.push(reader.string());
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.sortName = reader.string();
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.event = Event.decode(reader, reader.uint32());
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.categories.push(CatalogObjectCategory.decode(reader, reader.uint32()));
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.pickupFulfillmentPreferencesId = reader.string();
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.deliveryFulfillmentPreferencesId = reader.string();
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.descriptionHtml = reader.string();
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.descriptionPlaintext = reader.string();
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.kitchenName = reader.string();
                    continue;
                case 38:
                    if (tag !== 304) {
                        break;
                    }
                    message.ecomAllowOrderItemQuantities = reader.bool();
                    continue;
                case 39:
                    if (tag !== 312) {
                        break;
                    }
                    message.ecomOrderItemMaxQuantity = reader.int32();
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.channels.push(reader.string());
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.locationOverrides.push(ItemLocationOverrides.decode(reader, reader.uint32()));
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.shippingFulfillmentPreferencesId = reader.string();
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.dineInFulfillmentPreferencesId = reader.string();
                    continue;
                case 44:
                    if (tag !== 352) {
                        break;
                    }
                    message.isArchived = reader.bool();
                    continue;
                case 45:
                    if (tag !== 360) {
                        break;
                    }
                    message.requiresSubscriptionToSell = reader.bool();
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.ageRestrictionId = reader.string();
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.ecomSeoData = CatalogEcomSeoData.decode(reader, reader.uint32());
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.posDisplayName = reader.string();
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.foodAndBeverageDetails = CatalogItem_FoodAndBeverageDetails.decode(reader, reader.uint32());
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.comboTypeDetails = CatalogItem_CatalogItemComboTypeDetails.decode(reader, reader.uint32());
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.reportingCategory = CatalogObjectCategory.decode(reader, reader.uint32());
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.openGraphData = CatalogOpenGraphData.decode(reader, reader.uint32());
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.customShippingBoxId = reader.string();
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.taxCategoryId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItem();
        message.name = object.name ?? undefined;
        message.description = object.description ?? undefined;
        message.abbreviation = object.abbreviation ?? undefined;
        message.labelColor = object.labelColor ?? undefined;
        message.isTaxable = object.isTaxable ?? undefined;
        message.visibility = object.visibility ?? undefined;
        message.availableOnline = object.availableOnline ?? undefined;
        message.availableForPickup = object.availableForPickup ?? undefined;
        message.availableElectronically = object.availableElectronically ?? undefined;
        message.categoryId = object.categoryId ?? undefined;
        message.buyerFacingName = object.buyerFacingName ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.taxIds = object.taxIds?.map((e) => e) || [];
        message.modifierListInfo = object.modifierListInfo?.map((e) => CatalogItemModifierListInfo.fromPartial(e)) || [];
        message.imageUrl = object.imageUrl ?? undefined;
        message.variations = object.variations?.map((e) => CatalogObject.fromPartial(e)) || [];
        message.productType = object.productType ?? undefined;
        message.skipModifierScreen = object.skipModifierScreen ?? undefined;
        message.itemOptions = object.itemOptions?.map((e) => CatalogItemOptionForItem.fromPartial(e)) || [];
        message.ecomUri = object.ecomUri ?? undefined;
        message.ecomImageUris = object.ecomImageUris?.map((e) => e) || [];
        message.ecomAvailable = object.ecomAvailable ?? undefined;
        message.onlineStoreData = object.onlineStoreData ?? undefined;
        message.ecomBuyButtonText = object.ecomBuyButtonText ?? undefined;
        message.ecomVisibility = object.ecomVisibility ?? undefined;
        message.imageIds = object.imageIds?.map((e) => e) || [];
        message.legacyTaxIds = object.legacyTaxIds?.map((e) => e) || [];
        message.sortName = object.sortName ?? undefined;
        message.event = (object.event !== undefined && object.event !== null) ? Event.fromPartial(object.event) : undefined;
        message.categories = object.categories?.map((e) => CatalogObjectCategory.fromPartial(e)) || [];
        message.pickupFulfillmentPreferencesId = object.pickupFulfillmentPreferencesId ?? undefined;
        message.deliveryFulfillmentPreferencesId = object.deliveryFulfillmentPreferencesId ?? undefined;
        message.descriptionHtml = object.descriptionHtml ?? undefined;
        message.descriptionPlaintext = object.descriptionPlaintext ?? undefined;
        message.kitchenName = object.kitchenName ?? undefined;
        message.ecomAllowOrderItemQuantities = object.ecomAllowOrderItemQuantities ?? undefined;
        message.ecomOrderItemMaxQuantity = object.ecomOrderItemMaxQuantity ?? undefined;
        message.channels = object.channels?.map((e) => e) || [];
        message.locationOverrides = object.locationOverrides?.map((e) => ItemLocationOverrides.fromPartial(e)) || [];
        message.shippingFulfillmentPreferencesId = object.shippingFulfillmentPreferencesId ?? undefined;
        message.dineInFulfillmentPreferencesId = object.dineInFulfillmentPreferencesId ?? undefined;
        message.isArchived = object.isArchived ?? undefined;
        message.requiresSubscriptionToSell = object.requiresSubscriptionToSell ?? undefined;
        message.ageRestrictionId = object.ageRestrictionId ?? undefined;
        message.ecomSeoData = (object.ecomSeoData !== undefined && object.ecomSeoData !== null)
            ? CatalogEcomSeoData.fromPartial(object.ecomSeoData)
            : undefined;
        message.posDisplayName = object.posDisplayName ?? undefined;
        message.foodAndBeverageDetails =
            (object.foodAndBeverageDetails !== undefined && object.foodAndBeverageDetails !== null)
                ? CatalogItem_FoodAndBeverageDetails.fromPartial(object.foodAndBeverageDetails)
                : undefined;
        message.comboTypeDetails = (object.comboTypeDetails !== undefined && object.comboTypeDetails !== null)
            ? CatalogItem_CatalogItemComboTypeDetails.fromPartial(object.comboTypeDetails)
            : undefined;
        message.reportingCategory = (object.reportingCategory !== undefined && object.reportingCategory !== null)
            ? CatalogObjectCategory.fromPartial(object.reportingCategory)
            : undefined;
        message.openGraphData = (object.openGraphData !== undefined && object.openGraphData !== null)
            ? CatalogOpenGraphData.fromPartial(object.openGraphData)
            : undefined;
        message.customShippingBoxId = object.customShippingBoxId ?? undefined;
        message.taxCategoryId = object.taxCategoryId ?? undefined;
        return message;
    },
};
function createBaseCatalogItem_FoodAndBeverageDetails() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails",
        calorieCount: undefined,
        dietaryPreferences: [],
        ingredients: [],
    };
}
export const CatalogItem_FoodAndBeverageDetails = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails",
    encode(message, writer = _m0.Writer.create()) {
        if (message.calorieCount !== undefined) {
            writer.uint32(8).int32(message.calorieCount);
        }
        for (const v of message.dietaryPreferences) {
            CatalogItem_FoodAndBeverageDetails_DietaryPreference.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.ingredients) {
            CatalogItem_FoodAndBeverageDetails_Ingredient.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItem_FoodAndBeverageDetails();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.calorieCount = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.dietaryPreferences.push(CatalogItem_FoodAndBeverageDetails_DietaryPreference.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.ingredients.push(CatalogItem_FoodAndBeverageDetails_Ingredient.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItem_FoodAndBeverageDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItem_FoodAndBeverageDetails();
        message.calorieCount = object.calorieCount ?? undefined;
        message.dietaryPreferences =
            object.dietaryPreferences?.map((e) => CatalogItem_FoodAndBeverageDetails_DietaryPreference.fromPartial(e)) || [];
        message.ingredients =
            object.ingredients?.map((e) => CatalogItem_FoodAndBeverageDetails_Ingredient.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogItem_FoodAndBeverageDetails_DietaryPreference() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreference",
        type: undefined,
        standardName: undefined,
        customName: undefined,
    };
}
export const CatalogItem_FoodAndBeverageDetails_DietaryPreference = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreference",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.standardName !== undefined) {
            writer.uint32(16).int32(message.standardName);
        }
        if (message.customName !== undefined) {
            writer.uint32(26).string(message.customName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItem_FoodAndBeverageDetails_DietaryPreference();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.standardName = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.customName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItem_FoodAndBeverageDetails_DietaryPreference.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItem_FoodAndBeverageDetails_DietaryPreference();
        message.type = object.type ?? undefined;
        message.standardName = object.standardName ?? undefined;
        message.customName = object.customName ?? undefined;
        return message;
    },
};
function createBaseCatalogItem_FoodAndBeverageDetails_Ingredient() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.Ingredient",
        type: undefined,
        standardName: undefined,
        customName: undefined,
    };
}
export const CatalogItem_FoodAndBeverageDetails_Ingredient = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.Ingredient",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.standardName !== undefined) {
            writer.uint32(16).int32(message.standardName);
        }
        if (message.customName !== undefined) {
            writer.uint32(26).string(message.customName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItem_FoodAndBeverageDetails_Ingredient();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.standardName = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.customName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItem_FoodAndBeverageDetails_Ingredient.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItem_FoodAndBeverageDetails_Ingredient();
        message.type = object.type ?? undefined;
        message.standardName = object.standardName ?? undefined;
        message.customName = object.customName ?? undefined;
        return message;
    },
};
function createBaseCatalogItem_CatalogItemComboTypeDetails() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.CatalogItemComboTypeDetails", slots: [] };
}
export const CatalogItem_CatalogItemComboTypeDetails = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.CatalogItemComboTypeDetails",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.slots) {
            CatalogItem_CatalogItemComboTypeDetails_CatalogComboSlot.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItem_CatalogItemComboTypeDetails();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.slots.push(CatalogItem_CatalogItemComboTypeDetails_CatalogComboSlot.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItem_CatalogItemComboTypeDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItem_CatalogItemComboTypeDetails();
        message.slots = object.slots?.map((e) => CatalogItem_CatalogItemComboTypeDetails_CatalogComboSlot.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseCatalogItem_CatalogItemComboTypeDetails_CatalogComboSlot() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.CatalogItemComboTypeDetails.CatalogComboSlot",
        uid: undefined,
        name: undefined,
        numSelections: undefined,
        itemId: undefined,
        categoryId: undefined,
        defaultItemVariationId: undefined,
    };
}
export const CatalogItem_CatalogItemComboTypeDetails_CatalogComboSlot = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItem.CatalogItemComboTypeDetails.CatalogComboSlot",
    encode(message, writer = _m0.Writer.create()) {
        if (message.uid !== undefined) {
            writer.uint32(10).string(message.uid);
        }
        if (message.name !== undefined) {
            writer.uint32(18).string(message.name);
        }
        if (message.numSelections !== undefined) {
            writer.uint32(24).uint32(message.numSelections);
        }
        if (message.itemId !== undefined) {
            writer.uint32(34).string(message.itemId);
        }
        if (message.categoryId !== undefined) {
            writer.uint32(42).string(message.categoryId);
        }
        if (message.defaultItemVariationId !== undefined) {
            writer.uint32(50).string(message.defaultItemVariationId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItem_CatalogItemComboTypeDetails_CatalogComboSlot();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.uid = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.numSelections = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.categoryId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.defaultItemVariationId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItem_CatalogItemComboTypeDetails_CatalogComboSlot.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItem_CatalogItemComboTypeDetails_CatalogComboSlot();
        message.uid = object.uid ?? undefined;
        message.name = object.name ?? undefined;
        message.numSelections = object.numSelections ?? undefined;
        message.itemId = object.itemId ?? undefined;
        message.categoryId = object.categoryId ?? undefined;
        message.defaultItemVariationId = object.defaultItemVariationId ?? undefined;
        return message;
    },
};
function createBaseItemLocationOverrides() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.ItemLocationOverrides",
        locationId: undefined,
        ordinal: undefined,
    };
}
export const ItemLocationOverrides = {
    $type: "squareup.connect.v2.merchant_catalog.resources.ItemLocationOverrides",
    encode(message, writer = _m0.Writer.create()) {
        if (message.locationId !== undefined) {
            writer.uint32(10).string(message.locationId);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int32(message.ordinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseItemLocationOverrides();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ItemLocationOverrides.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseItemLocationOverrides();
        message.locationId = object.locationId ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseItemVariationLocationOverrides() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.ItemVariationLocationOverrides",
        locationId: undefined,
        priceMoney: undefined,
        pricingType: undefined,
        trackInventory: undefined,
        inventoryAlertType: undefined,
        inventoryAlertThreshold: undefined,
        priceDescription: undefined,
        resourceTokens: [],
        soldOut: undefined,
        soldOutValidUntil: undefined,
        contractTemplateTokens: [],
    };
}
export const ItemVariationLocationOverrides = {
    $type: "squareup.connect.v2.merchant_catalog.resources.ItemVariationLocationOverrides",
    encode(message, writer = _m0.Writer.create()) {
        if (message.locationId !== undefined) {
            writer.uint32(10).string(message.locationId);
        }
        if (message.priceMoney !== undefined) {
            Money.encode(message.priceMoney, writer.uint32(18).fork()).ldelim();
        }
        if (message.pricingType !== undefined) {
            writer.uint32(24).int32(message.pricingType);
        }
        if (message.trackInventory !== undefined) {
            writer.uint32(32).bool(message.trackInventory);
        }
        if (message.inventoryAlertType !== undefined) {
            writer.uint32(40).int32(message.inventoryAlertType);
        }
        if (message.inventoryAlertThreshold !== undefined) {
            writer.uint32(48).int64(message.inventoryAlertThreshold);
        }
        if (message.priceDescription !== undefined) {
            writer.uint32(58).string(message.priceDescription);
        }
        for (const v of message.resourceTokens) {
            writer.uint32(66).string(v);
        }
        if (message.soldOut !== undefined) {
            writer.uint32(72).bool(message.soldOut);
        }
        if (message.soldOutValidUntil !== undefined) {
            writer.uint32(82).string(message.soldOutValidUntil);
        }
        for (const v of message.contractTemplateTokens) {
            writer.uint32(90).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseItemVariationLocationOverrides();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.priceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.pricingType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.trackInventory = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.inventoryAlertType = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.inventoryAlertThreshold = longToNumber(reader.int64());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.priceDescription = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.resourceTokens.push(reader.string());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.soldOut = reader.bool();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.soldOutValidUntil = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.contractTemplateTokens.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ItemVariationLocationOverrides.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseItemVariationLocationOverrides();
        message.locationId = object.locationId ?? undefined;
        message.priceMoney = (object.priceMoney !== undefined && object.priceMoney !== null)
            ? Money.fromPartial(object.priceMoney)
            : undefined;
        message.pricingType = object.pricingType ?? undefined;
        message.trackInventory = object.trackInventory ?? undefined;
        message.inventoryAlertType = object.inventoryAlertType ?? undefined;
        message.inventoryAlertThreshold = object.inventoryAlertThreshold ?? undefined;
        message.priceDescription = object.priceDescription ?? undefined;
        message.resourceTokens = object.resourceTokens?.map((e) => e) || [];
        message.soldOut = object.soldOut ?? undefined;
        message.soldOutValidUntil = object.soldOutValidUntil ?? undefined;
        message.contractTemplateTokens = object.contractTemplateTokens?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogItemOptionValueForItemVariation() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionValueForItemVariation",
        itemOptionId: undefined,
        itemOptionValueId: undefined,
    };
}
export const CatalogItemOptionValueForItemVariation = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionValueForItemVariation",
    encode(message, writer = _m0.Writer.create()) {
        if (message.itemOptionId !== undefined) {
            writer.uint32(10).string(message.itemOptionId);
        }
        if (message.itemOptionValueId !== undefined) {
            writer.uint32(18).string(message.itemOptionValueId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItemOptionValueForItemVariation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemOptionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.itemOptionValueId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItemOptionValueForItemVariation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItemOptionValueForItemVariation();
        message.itemOptionId = object.itemOptionId ?? undefined;
        message.itemOptionValueId = object.itemOptionValueId ?? undefined;
        return message;
    },
};
function createBaseIntermission() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.Intermission",
        startOffset: undefined,
        endOffset: undefined,
    };
}
export const Intermission = {
    $type: "squareup.connect.v2.merchant_catalog.resources.Intermission",
    encode(message, writer = _m0.Writer.create()) {
        if (message.startOffset !== undefined) {
            writer.uint32(8).uint32(message.startOffset);
        }
        if (message.endOffset !== undefined) {
            writer.uint32(16).uint32(message.endOffset);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIntermission();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.startOffset = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.endOffset = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Intermission.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIntermission();
        message.startOffset = object.startOffset ?? undefined;
        message.endOffset = object.endOffset ?? undefined;
        return message;
    },
};
function createBaseCatalogStockConversion() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogStockConversion",
        stockableItemVariationId: undefined,
        stockableQuantity: undefined,
        nonstockableQuantity: undefined,
    };
}
export const CatalogStockConversion = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogStockConversion",
    encode(message, writer = _m0.Writer.create()) {
        if (message.stockableItemVariationId !== undefined) {
            writer.uint32(10).string(message.stockableItemVariationId);
        }
        if (message.stockableQuantity !== undefined) {
            writer.uint32(18).string(message.stockableQuantity);
        }
        if (message.nonstockableQuantity !== undefined) {
            writer.uint32(26).string(message.nonstockableQuantity);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogStockConversion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.stockableItemVariationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.stockableQuantity = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.nonstockableQuantity = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogStockConversion.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogStockConversion();
        message.stockableItemVariationId = object.stockableItemVariationId ?? undefined;
        message.stockableQuantity = object.stockableQuantity ?? undefined;
        message.nonstockableQuantity = object.nonstockableQuantity ?? undefined;
        return message;
    },
};
function createBaseItemVariationWeight() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.ItemVariationWeight",
        amount: undefined,
        weightUnit: undefined,
    };
}
export const ItemVariationWeight = {
    $type: "squareup.connect.v2.merchant_catalog.resources.ItemVariationWeight",
    encode(message, writer = _m0.Writer.create()) {
        if (message.amount !== undefined) {
            writer.uint32(10).string(message.amount);
        }
        if (message.weightUnit !== undefined) {
            writer.uint32(16).int32(message.weightUnit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseItemVariationWeight();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.amount = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.weightUnit = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ItemVariationWeight.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseItemVariationWeight();
        message.amount = object.amount ?? undefined;
        message.weightUnit = object.weightUnit ?? undefined;
        return message;
    },
};
function createBaseCatalogBundle() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogBundle",
        quantityRatio: undefined,
        components: [],
    };
}
export const CatalogBundle = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogBundle",
    encode(message, writer = _m0.Writer.create()) {
        if (message.quantityRatio !== undefined) {
            QuantityRatio.encode(message.quantityRatio, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.components) {
            CatalogBundleComponent.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogBundle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.quantityRatio = QuantityRatio.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.components.push(CatalogBundleComponent.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogBundle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogBundle();
        message.quantityRatio = (object.quantityRatio !== undefined && object.quantityRatio !== null)
            ? QuantityRatio.fromPartial(object.quantityRatio)
            : undefined;
        message.components = object.components?.map((e) => CatalogBundleComponent.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogBundleComponent() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogBundleComponent",
        uid: undefined,
        quantityRatio: undefined,
        variationId: undefined,
    };
}
export const CatalogBundleComponent = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogBundleComponent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.uid !== undefined) {
            writer.uint32(10).string(message.uid);
        }
        if (message.quantityRatio !== undefined) {
            QuantityRatio.encode(message.quantityRatio, writer.uint32(18).fork()).ldelim();
        }
        if (message.variationId !== undefined) {
            writer.uint32(26).string(message.variationId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogBundleComponent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.uid = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.quantityRatio = QuantityRatio.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.variationId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogBundleComponent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogBundleComponent();
        message.uid = object.uid ?? undefined;
        message.quantityRatio = (object.quantityRatio !== undefined && object.quantityRatio !== null)
            ? QuantityRatio.fromPartial(object.quantityRatio)
            : undefined;
        message.variationId = object.variationId ?? undefined;
        return message;
    },
};
function createBaseServiceCost() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.ServiceCost",
        pricingType: undefined,
        amountFlat: undefined,
        amountPercent: undefined,
    };
}
export const ServiceCost = {
    $type: "squareup.connect.v2.merchant_catalog.resources.ServiceCost",
    encode(message, writer = _m0.Writer.create()) {
        if (message.pricingType !== undefined) {
            writer.uint32(8).int32(message.pricingType);
        }
        if (message.amountFlat !== undefined) {
            Money.encode(message.amountFlat, writer.uint32(18).fork()).ldelim();
        }
        if (message.amountPercent !== undefined) {
            writer.uint32(26).string(message.amountPercent);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseServiceCost();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.pricingType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.amountFlat = Money.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.amountPercent = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ServiceCost.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseServiceCost();
        message.pricingType = object.pricingType ?? undefined;
        message.amountFlat = (object.amountFlat !== undefined && object.amountFlat !== null)
            ? Money.fromPartial(object.amountFlat)
            : undefined;
        message.amountPercent = object.amountPercent ?? undefined;
        return message;
    },
};
function createBaseCatalogItemVariation() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariation",
        itemId: undefined,
        name: undefined,
        sku: undefined,
        upc: undefined,
        ordinal: undefined,
        pricingType: undefined,
        priceMoney: undefined,
        locationOverrides: [],
        trackInventory: undefined,
        inventoryAlertType: undefined,
        inventoryAlertThreshold: undefined,
        buyerFacingName: undefined,
        userData: undefined,
        serviceDuration: undefined,
        priceDescription: undefined,
        availableForBooking: undefined,
        noShowFee: undefined,
        transitionTime: undefined,
        itemOptionValues: [],
        measurementUnitId: undefined,
        intermissions: [],
        sellable: undefined,
        stockable: undefined,
        imageIds: [],
        teamMemberIds: [],
        compositionId: undefined,
        stockableConversion: undefined,
        subscriptionPlanIds: [],
        kitchenName: undefined,
        contractTemplateTokens: [],
        defaultUnitCost: undefined,
        channels: [],
        itemVariationVendorInfoIds: [],
        itemVariationVendorInfos: [],
        bundle: undefined,
        weight: undefined,
        creditPackageInfo: undefined,
        salePrices: [],
        serviceCost: undefined,
        vendorInformation: [],
        noShowFeePercentage: undefined,
    };
}
export const CatalogItemVariation = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariation",
    encode(message, writer = _m0.Writer.create()) {
        if (message.itemId !== undefined) {
            writer.uint32(10).string(message.itemId);
        }
        if (message.name !== undefined) {
            writer.uint32(18).string(message.name);
        }
        if (message.sku !== undefined) {
            writer.uint32(26).string(message.sku);
        }
        if (message.upc !== undefined) {
            writer.uint32(106).string(message.upc);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(32).int32(message.ordinal);
        }
        if (message.pricingType !== undefined) {
            writer.uint32(40).int32(message.pricingType);
        }
        if (message.priceMoney !== undefined) {
            Money.encode(message.priceMoney, writer.uint32(50).fork()).ldelim();
        }
        for (const v of message.locationOverrides) {
            ItemVariationLocationOverrides.encode(v, writer.uint32(98).fork()).ldelim();
        }
        if (message.trackInventory !== undefined) {
            writer.uint32(56).bool(message.trackInventory);
        }
        if (message.inventoryAlertType !== undefined) {
            writer.uint32(64).int32(message.inventoryAlertType);
        }
        if (message.inventoryAlertThreshold !== undefined) {
            writer.uint32(72).int64(message.inventoryAlertThreshold);
        }
        if (message.buyerFacingName !== undefined) {
            writer.uint32(82).string(message.buyerFacingName);
        }
        if (message.userData !== undefined) {
            writer.uint32(90).string(message.userData);
        }
        if (message.serviceDuration !== undefined) {
            writer.uint32(112).int64(message.serviceDuration);
        }
        if (message.priceDescription !== undefined) {
            writer.uint32(122).string(message.priceDescription);
        }
        if (message.availableForBooking !== undefined) {
            writer.uint32(128).bool(message.availableForBooking);
        }
        if (message.noShowFee !== undefined) {
            Money.encode(message.noShowFee, writer.uint32(138).fork()).ldelim();
        }
        if (message.transitionTime !== undefined) {
            writer.uint32(144).int64(message.transitionTime);
        }
        for (const v of message.itemOptionValues) {
            CatalogItemOptionValueForItemVariation.encode(v, writer.uint32(178).fork()).ldelim();
        }
        if (message.measurementUnitId !== undefined) {
            writer.uint32(170).string(message.measurementUnitId);
        }
        for (const v of message.intermissions) {
            Intermission.encode(v, writer.uint32(186).fork()).ldelim();
        }
        if (message.sellable !== undefined) {
            writer.uint32(192).bool(message.sellable);
        }
        if (message.stockable !== undefined) {
            writer.uint32(200).bool(message.stockable);
        }
        for (const v of message.imageIds) {
            writer.uint32(218).string(v);
        }
        for (const v of message.teamMemberIds) {
            writer.uint32(226).string(v);
        }
        if (message.compositionId !== undefined) {
            writer.uint32(210).string(message.compositionId);
        }
        if (message.stockableConversion !== undefined) {
            CatalogStockConversion.encode(message.stockableConversion, writer.uint32(234).fork()).ldelim();
        }
        for (const v of message.subscriptionPlanIds) {
            writer.uint32(242).string(v);
        }
        if (message.kitchenName !== undefined) {
            writer.uint32(250).string(message.kitchenName);
        }
        for (const v of message.contractTemplateTokens) {
            writer.uint32(258).string(v);
        }
        if (message.defaultUnitCost !== undefined) {
            Money.encode(message.defaultUnitCost, writer.uint32(266).fork()).ldelim();
        }
        for (const v of message.channels) {
            writer.uint32(274).string(v);
        }
        for (const v of message.itemVariationVendorInfoIds) {
            writer.uint32(282).string(v);
        }
        for (const v of message.itemVariationVendorInfos) {
            CatalogObject.encode(v, writer.uint32(306).fork()).ldelim();
        }
        if (message.bundle !== undefined) {
            CatalogBundle.encode(message.bundle, writer.uint32(290).fork()).ldelim();
        }
        if (message.weight !== undefined) {
            ItemVariationWeight.encode(message.weight, writer.uint32(298).fork()).ldelim();
        }
        if (message.creditPackageInfo !== undefined) {
            CreditPackageInfo.encode(message.creditPackageInfo, writer.uint32(322).fork()).ldelim();
        }
        for (const v of message.salePrices) {
            CatalogObject.encode(v, writer.uint32(338).fork()).ldelim();
        }
        if (message.serviceCost !== undefined) {
            ServiceCost.encode(message.serviceCost, writer.uint32(346).fork()).ldelim();
        }
        for (const v of message.vendorInformation) {
            CatalogItemVariationVendorInformation.encode(v, writer.uint32(354).fork()).ldelim();
        }
        if (message.noShowFeePercentage !== undefined) {
            writer.uint32(360).int32(message.noShowFeePercentage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItemVariation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.sku = reader.string();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.upc = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.pricingType = reader.int32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.priceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.locationOverrides.push(ItemVariationLocationOverrides.decode(reader, reader.uint32()));
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.trackInventory = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.inventoryAlertType = reader.int32();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.inventoryAlertThreshold = longToNumber(reader.int64());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.buyerFacingName = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.userData = reader.string();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.serviceDuration = longToNumber(reader.int64());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.priceDescription = reader.string();
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.availableForBooking = reader.bool();
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.noShowFee = Money.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.transitionTime = longToNumber(reader.int64());
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.itemOptionValues.push(CatalogItemOptionValueForItemVariation.decode(reader, reader.uint32()));
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.measurementUnitId = reader.string();
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.intermissions.push(Intermission.decode(reader, reader.uint32()));
                    continue;
                case 24:
                    if (tag !== 192) {
                        break;
                    }
                    message.sellable = reader.bool();
                    continue;
                case 25:
                    if (tag !== 200) {
                        break;
                    }
                    message.stockable = reader.bool();
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.imageIds.push(reader.string());
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.teamMemberIds.push(reader.string());
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.compositionId = reader.string();
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.stockableConversion = CatalogStockConversion.decode(reader, reader.uint32());
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.subscriptionPlanIds.push(reader.string());
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.kitchenName = reader.string();
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.contractTemplateTokens.push(reader.string());
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.defaultUnitCost = Money.decode(reader, reader.uint32());
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.channels.push(reader.string());
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.itemVariationVendorInfoIds.push(reader.string());
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.itemVariationVendorInfos.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.bundle = CatalogBundle.decode(reader, reader.uint32());
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.weight = ItemVariationWeight.decode(reader, reader.uint32());
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.creditPackageInfo = CreditPackageInfo.decode(reader, reader.uint32());
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.salePrices.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.serviceCost = ServiceCost.decode(reader, reader.uint32());
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.vendorInformation.push(CatalogItemVariationVendorInformation.decode(reader, reader.uint32()));
                    continue;
                case 45:
                    if (tag !== 360) {
                        break;
                    }
                    message.noShowFeePercentage = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItemVariation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItemVariation();
        message.itemId = object.itemId ?? undefined;
        message.name = object.name ?? undefined;
        message.sku = object.sku ?? undefined;
        message.upc = object.upc ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.pricingType = object.pricingType ?? undefined;
        message.priceMoney = (object.priceMoney !== undefined && object.priceMoney !== null)
            ? Money.fromPartial(object.priceMoney)
            : undefined;
        message.locationOverrides = object.locationOverrides?.map((e) => ItemVariationLocationOverrides.fromPartial(e)) ||
            [];
        message.trackInventory = object.trackInventory ?? undefined;
        message.inventoryAlertType = object.inventoryAlertType ?? undefined;
        message.inventoryAlertThreshold = object.inventoryAlertThreshold ?? undefined;
        message.buyerFacingName = object.buyerFacingName ?? undefined;
        message.userData = object.userData ?? undefined;
        message.serviceDuration = object.serviceDuration ?? undefined;
        message.priceDescription = object.priceDescription ?? undefined;
        message.availableForBooking = object.availableForBooking ?? undefined;
        message.noShowFee = (object.noShowFee !== undefined && object.noShowFee !== null)
            ? Money.fromPartial(object.noShowFee)
            : undefined;
        message.transitionTime = object.transitionTime ?? undefined;
        message.itemOptionValues =
            object.itemOptionValues?.map((e) => CatalogItemOptionValueForItemVariation.fromPartial(e)) || [];
        message.measurementUnitId = object.measurementUnitId ?? undefined;
        message.intermissions = object.intermissions?.map((e) => Intermission.fromPartial(e)) || [];
        message.sellable = object.sellable ?? undefined;
        message.stockable = object.stockable ?? undefined;
        message.imageIds = object.imageIds?.map((e) => e) || [];
        message.teamMemberIds = object.teamMemberIds?.map((e) => e) || [];
        message.compositionId = object.compositionId ?? undefined;
        message.stockableConversion = (object.stockableConversion !== undefined && object.stockableConversion !== null)
            ? CatalogStockConversion.fromPartial(object.stockableConversion)
            : undefined;
        message.subscriptionPlanIds = object.subscriptionPlanIds?.map((e) => e) || [];
        message.kitchenName = object.kitchenName ?? undefined;
        message.contractTemplateTokens = object.contractTemplateTokens?.map((e) => e) || [];
        message.defaultUnitCost = (object.defaultUnitCost !== undefined && object.defaultUnitCost !== null)
            ? Money.fromPartial(object.defaultUnitCost)
            : undefined;
        message.channels = object.channels?.map((e) => e) || [];
        message.itemVariationVendorInfoIds = object.itemVariationVendorInfoIds?.map((e) => e) || [];
        message.itemVariationVendorInfos = object.itemVariationVendorInfos?.map((e) => CatalogObject.fromPartial(e)) || [];
        message.bundle = (object.bundle !== undefined && object.bundle !== null)
            ? CatalogBundle.fromPartial(object.bundle)
            : undefined;
        message.weight = (object.weight !== undefined && object.weight !== null)
            ? ItemVariationWeight.fromPartial(object.weight)
            : undefined;
        message.creditPackageInfo = (object.creditPackageInfo !== undefined && object.creditPackageInfo !== null)
            ? CreditPackageInfo.fromPartial(object.creditPackageInfo)
            : undefined;
        message.salePrices = object.salePrices?.map((e) => CatalogObject.fromPartial(e)) || [];
        message.serviceCost = (object.serviceCost !== undefined && object.serviceCost !== null)
            ? ServiceCost.fromPartial(object.serviceCost)
            : undefined;
        message.vendorInformation =
            object.vendorInformation?.map((e) => CatalogItemVariationVendorInformation.fromPartial(e)) || [];
        message.noShowFeePercentage = object.noShowFeePercentage ?? undefined;
        return message;
    },
};
function createBaseCatalogItemVariationVendorInformation() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationVendorInformation",
        vendorId: undefined,
        vendorCode: undefined,
        unitCostMoney: undefined,
    };
}
export const CatalogItemVariationVendorInformation = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationVendorInformation",
    encode(message, writer = _m0.Writer.create()) {
        if (message.vendorId !== undefined) {
            writer.uint32(10).string(message.vendorId);
        }
        if (message.vendorCode !== undefined) {
            writer.uint32(18).string(message.vendorCode);
        }
        if (message.unitCostMoney !== undefined) {
            Money.encode(message.unitCostMoney, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItemVariationVendorInformation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.vendorId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.vendorCode = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.unitCostMoney = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItemVariationVendorInformation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItemVariationVendorInformation();
        message.vendorId = object.vendorId ?? undefined;
        message.vendorCode = object.vendorCode ?? undefined;
        message.unitCostMoney = (object.unitCostMoney !== undefined && object.unitCostMoney !== null)
            ? Money.fromPartial(object.unitCostMoney)
            : undefined;
        return message;
    },
};
function createBaseCreditPackageInfo() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CreditPackageInfo",
        validityDuration: undefined,
        redemptionPolicies: [],
    };
}
export const CreditPackageInfo = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CreditPackageInfo",
    encode(message, writer = _m0.Writer.create()) {
        if (message.validityDuration !== undefined) {
            writer.uint32(314).string(message.validityDuration);
        }
        for (const v of message.redemptionPolicies) {
            CatalogObject.encode(v, writer.uint32(322).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreditPackageInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.validityDuration = reader.string();
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.redemptionPolicies.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CreditPackageInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditPackageInfo();
        message.validityDuration = object.validityDuration ?? undefined;
        message.redemptionPolicies = object.redemptionPolicies?.map((e) => CatalogObject.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogItemVariationVendorInfo() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationVendorInfo",
        name: undefined,
        ordinal: undefined,
        sku: undefined,
        priceMoney: undefined,
        itemVariationId: undefined,
        vendorId: undefined,
    };
}
export const CatalogItemVariationVendorInfo = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationVendorInfo",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int32(message.ordinal);
        }
        if (message.sku !== undefined) {
            writer.uint32(26).string(message.sku);
        }
        if (message.priceMoney !== undefined) {
            Money.encode(message.priceMoney, writer.uint32(34).fork()).ldelim();
        }
        if (message.itemVariationId !== undefined) {
            writer.uint32(42).string(message.itemVariationId);
        }
        if (message.vendorId !== undefined) {
            writer.uint32(50).string(message.vendorId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItemVariationVendorInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.sku = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.priceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.itemVariationId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.vendorId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItemVariationVendorInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItemVariationVendorInfo();
        message.name = object.name ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.sku = object.sku ?? undefined;
        message.priceMoney = (object.priceMoney !== undefined && object.priceMoney !== null)
            ? Money.fromPartial(object.priceMoney)
            : undefined;
        message.itemVariationId = object.itemVariationId ?? undefined;
        message.vendorId = object.vendorId ?? undefined;
        return message;
    },
};
function createBaseQuantityRatio() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
        quantity: undefined,
        quantityDenominator: undefined,
    };
}
export const QuantityRatio = {
    $type: "squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
    encode(message, writer = _m0.Writer.create()) {
        if (message.quantity !== undefined) {
            writer.uint32(8).uint32(message.quantity);
        }
        if (message.quantityDenominator !== undefined) {
            writer.uint32(16).uint32(message.quantityDenominator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuantityRatio();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.quantity = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.quantityDenominator = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return QuantityRatio.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuantityRatio();
        message.quantity = object.quantity ?? undefined;
        message.quantityDenominator = object.quantityDenominator ?? undefined;
        return message;
    },
};
function createBaseCatalogComposition() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogComposition",
        quantity: undefined,
        components: [],
        compositionType: undefined,
    };
}
export const CatalogComposition = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogComposition",
    encode(message, writer = _m0.Writer.create()) {
        if (message.quantity !== undefined) {
            QuantityRatio.encode(message.quantity, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.components) {
            CatalogObject.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.compositionType !== undefined) {
            writer.uint32(24).int32(message.compositionType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogComposition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.quantity = QuantityRatio.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.components.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.compositionType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogComposition.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogComposition();
        message.quantity = (object.quantity !== undefined && object.quantity !== null)
            ? QuantityRatio.fromPartial(object.quantity)
            : undefined;
        message.components = object.components?.map((e) => CatalogObject.fromPartial(e)) || [];
        message.compositionType = object.compositionType ?? undefined;
        return message;
    },
};
function createBaseCatalogComponent() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogComponent",
        quantity: undefined,
        variationId: undefined,
        compositionId: undefined,
    };
}
export const CatalogComponent = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogComponent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.quantity !== undefined) {
            QuantityRatio.encode(message.quantity, writer.uint32(10).fork()).ldelim();
        }
        if (message.variationId !== undefined) {
            writer.uint32(18).string(message.variationId);
        }
        if (message.compositionId !== undefined) {
            writer.uint32(26).string(message.compositionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogComponent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.quantity = QuantityRatio.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.variationId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.compositionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogComponent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogComponent();
        message.quantity = (object.quantity !== undefined && object.quantity !== null)
            ? QuantityRatio.fromPartial(object.quantity)
            : undefined;
        message.variationId = object.variationId ?? undefined;
        message.compositionId = object.compositionId ?? undefined;
        return message;
    },
};
function createBaseCategoryLocationOverrides() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CategoryLocationOverrides",
        locationId: undefined,
        straightfire: undefined,
        ordinal: undefined,
    };
}
export const CategoryLocationOverrides = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CategoryLocationOverrides",
    encode(message, writer = _m0.Writer.create()) {
        if (message.locationId !== undefined) {
            writer.uint32(10).string(message.locationId);
        }
        if (message.straightfire !== undefined) {
            writer.uint32(16).int32(message.straightfire);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(24).int32(message.ordinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCategoryLocationOverrides();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.straightfire = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CategoryLocationOverrides.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCategoryLocationOverrides();
        message.locationId = object.locationId ?? undefined;
        message.straightfire = object.straightfire ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseCatalogCategory() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCategory",
        name: undefined,
        ordinal: undefined,
        abbreviation: undefined,
        labelColor: undefined,
        imageIds: [],
        locationOverrides: [],
        categoryType: undefined,
        parentCategory: undefined,
        isTopLevel: undefined,
        channels: [],
        itemCount: undefined,
        categoryCount: undefined,
        availabilityPeriodIds: [],
        onlineVisibility: undefined,
        rootCategory: undefined,
        ecomSeoData: undefined,
        pathToRoot: [],
        openGraphData: undefined,
        migratedFromSquareOnline: undefined,
    };
}
export const CatalogCategory = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCategory",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int32(message.ordinal);
        }
        if (message.abbreviation !== undefined) {
            writer.uint32(26).string(message.abbreviation);
        }
        if (message.labelColor !== undefined) {
            writer.uint32(34).string(message.labelColor);
        }
        for (const v of message.imageIds) {
            writer.uint32(42).string(v);
        }
        for (const v of message.locationOverrides) {
            CategoryLocationOverrides.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.categoryType !== undefined) {
            writer.uint32(56).int32(message.categoryType);
        }
        if (message.parentCategory !== undefined) {
            CatalogObjectCategory.encode(message.parentCategory, writer.uint32(66).fork()).ldelim();
        }
        if (message.isTopLevel !== undefined) {
            writer.uint32(72).bool(message.isTopLevel);
        }
        for (const v of message.channels) {
            writer.uint32(90).string(v);
        }
        if (message.itemCount !== undefined) {
            writer.uint32(104).int64(message.itemCount);
        }
        if (message.categoryCount !== undefined) {
            writer.uint32(112).int64(message.categoryCount);
        }
        for (const v of message.availabilityPeriodIds) {
            writer.uint32(122).string(v);
        }
        if (message.onlineVisibility !== undefined) {
            writer.uint32(128).bool(message.onlineVisibility);
        }
        if (message.rootCategory !== undefined) {
            writer.uint32(146).string(message.rootCategory);
        }
        if (message.ecomSeoData !== undefined) {
            CatalogEcomSeoData.encode(message.ecomSeoData, writer.uint32(154).fork()).ldelim();
        }
        for (const v of message.pathToRoot) {
            CategoryPathToRootNode.encode(v, writer.uint32(162).fork()).ldelim();
        }
        if (message.openGraphData !== undefined) {
            CatalogOpenGraphData.encode(message.openGraphData, writer.uint32(170).fork()).ldelim();
        }
        if (message.migratedFromSquareOnline !== undefined) {
            writer.uint32(176).bool(message.migratedFromSquareOnline);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCategory();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.abbreviation = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.labelColor = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.imageIds.push(reader.string());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.locationOverrides.push(CategoryLocationOverrides.decode(reader, reader.uint32()));
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.categoryType = reader.int32();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.parentCategory = CatalogObjectCategory.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.isTopLevel = reader.bool();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.channels.push(reader.string());
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.itemCount = longToNumber(reader.int64());
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.categoryCount = longToNumber(reader.int64());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.availabilityPeriodIds.push(reader.string());
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.onlineVisibility = reader.bool();
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.rootCategory = reader.string();
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.ecomSeoData = CatalogEcomSeoData.decode(reader, reader.uint32());
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.pathToRoot.push(CategoryPathToRootNode.decode(reader, reader.uint32()));
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.openGraphData = CatalogOpenGraphData.decode(reader, reader.uint32());
                    continue;
                case 22:
                    if (tag !== 176) {
                        break;
                    }
                    message.migratedFromSquareOnline = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCategory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCategory();
        message.name = object.name ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.abbreviation = object.abbreviation ?? undefined;
        message.labelColor = object.labelColor ?? undefined;
        message.imageIds = object.imageIds?.map((e) => e) || [];
        message.locationOverrides = object.locationOverrides?.map((e) => CategoryLocationOverrides.fromPartial(e)) || [];
        message.categoryType = object.categoryType ?? undefined;
        message.parentCategory = (object.parentCategory !== undefined && object.parentCategory !== null)
            ? CatalogObjectCategory.fromPartial(object.parentCategory)
            : undefined;
        message.isTopLevel = object.isTopLevel ?? undefined;
        message.channels = object.channels?.map((e) => e) || [];
        message.itemCount = object.itemCount ?? undefined;
        message.categoryCount = object.categoryCount ?? undefined;
        message.availabilityPeriodIds = object.availabilityPeriodIds?.map((e) => e) || [];
        message.onlineVisibility = object.onlineVisibility ?? undefined;
        message.rootCategory = object.rootCategory ?? undefined;
        message.ecomSeoData = (object.ecomSeoData !== undefined && object.ecomSeoData !== null)
            ? CatalogEcomSeoData.fromPartial(object.ecomSeoData)
            : undefined;
        message.pathToRoot = object.pathToRoot?.map((e) => CategoryPathToRootNode.fromPartial(e)) || [];
        message.openGraphData = (object.openGraphData !== undefined && object.openGraphData !== null)
            ? CatalogOpenGraphData.fromPartial(object.openGraphData)
            : undefined;
        message.migratedFromSquareOnline = object.migratedFromSquareOnline ?? undefined;
        return message;
    },
};
function createBaseCategoryPathToRootNode() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CategoryPathToRootNode",
        categoryId: undefined,
        categoryName: undefined,
    };
}
export const CategoryPathToRootNode = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CategoryPathToRootNode",
    encode(message, writer = _m0.Writer.create()) {
        if (message.categoryId !== undefined) {
            writer.uint32(10).string(message.categoryId);
        }
        if (message.categoryName !== undefined) {
            writer.uint32(18).string(message.categoryName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCategoryPathToRootNode();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.categoryId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.categoryName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CategoryPathToRootNode.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCategoryPathToRootNode();
        message.categoryId = object.categoryId ?? undefined;
        message.categoryName = object.categoryName ?? undefined;
        return message;
    },
};
function createBaseCatalogTax() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTax",
        name: undefined,
        calculationPhase: undefined,
        inclusionType: undefined,
        percentage: undefined,
        appliesToCustomAmounts: undefined,
        enabled: undefined,
        taxTypeId: undefined,
        taxTypeName: undefined,
        amount: undefined,
        appliesToProductSetId: undefined,
    };
}
export const CatalogTax = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTax",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.calculationPhase !== undefined) {
            writer.uint32(16).int32(message.calculationPhase);
        }
        if (message.inclusionType !== undefined) {
            writer.uint32(24).int32(message.inclusionType);
        }
        if (message.percentage !== undefined) {
            writer.uint32(42).string(message.percentage);
        }
        if (message.appliesToCustomAmounts !== undefined) {
            writer.uint32(48).bool(message.appliesToCustomAmounts);
        }
        if (message.enabled !== undefined) {
            writer.uint32(56).bool(message.enabled);
        }
        if (message.taxTypeId !== undefined) {
            writer.uint32(66).string(message.taxTypeId);
        }
        if (message.taxTypeName !== undefined) {
            writer.uint32(74).string(message.taxTypeName);
        }
        if (message.amount !== undefined) {
            Money.encode(message.amount, writer.uint32(82).fork()).ldelim();
        }
        if (message.appliesToProductSetId !== undefined) {
            writer.uint32(90).string(message.appliesToProductSetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogTax();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.calculationPhase = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.inclusionType = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.percentage = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.appliesToCustomAmounts = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.taxTypeId = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.taxTypeName = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.amount = Money.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.appliesToProductSetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogTax.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogTax();
        message.name = object.name ?? undefined;
        message.calculationPhase = object.calculationPhase ?? undefined;
        message.inclusionType = object.inclusionType ?? undefined;
        message.percentage = object.percentage ?? undefined;
        message.appliesToCustomAmounts = object.appliesToCustomAmounts ?? undefined;
        message.enabled = object.enabled ?? undefined;
        message.taxTypeId = object.taxTypeId ?? undefined;
        message.taxTypeName = object.taxTypeName ?? undefined;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? Money.fromPartial(object.amount)
            : undefined;
        message.appliesToProductSetId = object.appliesToProductSetId ?? undefined;
        return message;
    },
};
function createBaseCatalogTaxExemption() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTaxExemption",
        name: undefined,
        diningOptionIds: [],
        maxTotalAmountMoney: undefined,
        minItemPriceMoney: undefined,
        maxItemPriceMoney: undefined,
        taxId: undefined,
        exemptProductSetId: undefined,
        legacyItemConfigurationMatchAll: undefined,
        legacyItemIds: [],
        appliesToCustomAmounts: undefined,
        hasDiningOptionPredicate: undefined,
    };
}
export const CatalogTaxExemption = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTaxExemption",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        for (const v of message.diningOptionIds) {
            writer.uint32(18).string(v);
        }
        if (message.maxTotalAmountMoney !== undefined) {
            Money.encode(message.maxTotalAmountMoney, writer.uint32(26).fork()).ldelim();
        }
        if (message.minItemPriceMoney !== undefined) {
            Money.encode(message.minItemPriceMoney, writer.uint32(34).fork()).ldelim();
        }
        if (message.maxItemPriceMoney !== undefined) {
            Money.encode(message.maxItemPriceMoney, writer.uint32(42).fork()).ldelim();
        }
        if (message.taxId !== undefined) {
            writer.uint32(50).string(message.taxId);
        }
        if (message.exemptProductSetId !== undefined) {
            writer.uint32(58).string(message.exemptProductSetId);
        }
        if (message.legacyItemConfigurationMatchAll !== undefined) {
            writer.uint32(64).bool(message.legacyItemConfigurationMatchAll);
        }
        for (const v of message.legacyItemIds) {
            writer.uint32(74).string(v);
        }
        if (message.appliesToCustomAmounts !== undefined) {
            writer.uint32(80).bool(message.appliesToCustomAmounts);
        }
        if (message.hasDiningOptionPredicate !== undefined) {
            writer.uint32(88).bool(message.hasDiningOptionPredicate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogTaxExemption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.diningOptionIds.push(reader.string());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.maxTotalAmountMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.minItemPriceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.maxItemPriceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.taxId = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.exemptProductSetId = reader.string();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.legacyItemConfigurationMatchAll = reader.bool();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.legacyItemIds.push(reader.string());
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.appliesToCustomAmounts = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.hasDiningOptionPredicate = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogTaxExemption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogTaxExemption();
        message.name = object.name ?? undefined;
        message.diningOptionIds = object.diningOptionIds?.map((e) => e) || [];
        message.maxTotalAmountMoney = (object.maxTotalAmountMoney !== undefined && object.maxTotalAmountMoney !== null)
            ? Money.fromPartial(object.maxTotalAmountMoney)
            : undefined;
        message.minItemPriceMoney = (object.minItemPriceMoney !== undefined && object.minItemPriceMoney !== null)
            ? Money.fromPartial(object.minItemPriceMoney)
            : undefined;
        message.maxItemPriceMoney = (object.maxItemPriceMoney !== undefined && object.maxItemPriceMoney !== null)
            ? Money.fromPartial(object.maxItemPriceMoney)
            : undefined;
        message.taxId = object.taxId ?? undefined;
        message.exemptProductSetId = object.exemptProductSetId ?? undefined;
        message.legacyItemConfigurationMatchAll = object.legacyItemConfigurationMatchAll ?? undefined;
        message.legacyItemIds = object.legacyItemIds?.map((e) => e) || [];
        message.appliesToCustomAmounts = object.appliesToCustomAmounts ?? undefined;
        message.hasDiningOptionPredicate = object.hasDiningOptionPredicate ?? undefined;
        return message;
    },
};
function createBaseCatalogTaxCategory() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTaxCategory", name: undefined };
}
export const CatalogTaxCategory = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTaxCategory",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogTaxCategory();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogTaxCategory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogTaxCategory();
        message.name = object.name ?? undefined;
        return message;
    },
};
function createBaseDiningOptionLocationOverrides() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.DiningOptionLocationOverrides",
        locationId: undefined,
        ordinal: undefined,
    };
}
export const DiningOptionLocationOverrides = {
    $type: "squareup.connect.v2.merchant_catalog.resources.DiningOptionLocationOverrides",
    encode(message, writer = _m0.Writer.create()) {
        if (message.locationId !== undefined) {
            writer.uint32(10).string(message.locationId);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int32(message.ordinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDiningOptionLocationOverrides();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return DiningOptionLocationOverrides.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDiningOptionLocationOverrides();
        message.locationId = object.locationId ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseCatalogDiningOption() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogDiningOption",
        name: undefined,
        ordinal: undefined,
        locationOverrides: [],
    };
}
export const CatalogDiningOption = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogDiningOption",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int32(message.ordinal);
        }
        for (const v of message.locationOverrides) {
            DiningOptionLocationOverrides.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogDiningOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.locationOverrides.push(DiningOptionLocationOverrides.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogDiningOption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogDiningOption();
        message.name = object.name ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.locationOverrides = object.locationOverrides?.map((e) => DiningOptionLocationOverrides.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseCatalogDiscount() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogDiscount",
        name: undefined,
        discountType: undefined,
        percentage: undefined,
        amountMoney: undefined,
        pinRequired: undefined,
        labelColor: undefined,
        applicationMethod: undefined,
        compOrdinal: undefined,
        modifyTaxBasis: undefined,
        maximumAmountMoney: undefined,
    };
}
export const CatalogDiscount = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogDiscount",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.discountType !== undefined) {
            writer.uint32(16).int32(message.discountType);
        }
        if (message.percentage !== undefined) {
            writer.uint32(26).string(message.percentage);
        }
        if (message.amountMoney !== undefined) {
            Money.encode(message.amountMoney, writer.uint32(34).fork()).ldelim();
        }
        if (message.pinRequired !== undefined) {
            writer.uint32(40).bool(message.pinRequired);
        }
        if (message.labelColor !== undefined) {
            writer.uint32(50).string(message.labelColor);
        }
        if (message.applicationMethod !== undefined) {
            writer.uint32(56).int32(message.applicationMethod);
        }
        if (message.compOrdinal !== undefined) {
            writer.uint32(64).int32(message.compOrdinal);
        }
        if (message.modifyTaxBasis !== undefined) {
            writer.uint32(72).int32(message.modifyTaxBasis);
        }
        if (message.maximumAmountMoney !== undefined) {
            Money.encode(message.maximumAmountMoney, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogDiscount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.discountType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.percentage = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.amountMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.pinRequired = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.labelColor = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.applicationMethod = reader.int32();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.compOrdinal = reader.int32();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.modifyTaxBasis = reader.int32();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.maximumAmountMoney = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogDiscount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogDiscount();
        message.name = object.name ?? undefined;
        message.discountType = object.discountType ?? undefined;
        message.percentage = object.percentage ?? undefined;
        message.amountMoney = (object.amountMoney !== undefined && object.amountMoney !== null)
            ? Money.fromPartial(object.amountMoney)
            : undefined;
        message.pinRequired = object.pinRequired ?? undefined;
        message.labelColor = object.labelColor ?? undefined;
        message.applicationMethod = object.applicationMethod ?? undefined;
        message.compOrdinal = object.compOrdinal ?? undefined;
        message.modifyTaxBasis = object.modifyTaxBasis ?? undefined;
        message.maximumAmountMoney = (object.maximumAmountMoney !== undefined && object.maximumAmountMoney !== null)
            ? Money.fromPartial(object.maximumAmountMoney)
            : undefined;
        return message;
    },
};
function createBaseCatalogSalePrice() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogSalePrice",
        itemVariationId: undefined,
        salePriceType: undefined,
        percentage: undefined,
        amountMoney: undefined,
        validFromDate: undefined,
        validUntilDate: undefined,
    };
}
export const CatalogSalePrice = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogSalePrice",
    encode(message, writer = _m0.Writer.create()) {
        if (message.itemVariationId !== undefined) {
            writer.uint32(18).string(message.itemVariationId);
        }
        if (message.salePriceType !== undefined) {
            writer.uint32(24).int32(message.salePriceType);
        }
        if (message.percentage !== undefined) {
            writer.uint32(34).string(message.percentage);
        }
        if (message.amountMoney !== undefined) {
            Money.encode(message.amountMoney, writer.uint32(42).fork()).ldelim();
        }
        if (message.validFromDate !== undefined) {
            writer.uint32(50).string(message.validFromDate);
        }
        if (message.validUntilDate !== undefined) {
            writer.uint32(58).string(message.validUntilDate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogSalePrice();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.itemVariationId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.salePriceType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.percentage = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.amountMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.validFromDate = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.validUntilDate = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogSalePrice.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogSalePrice();
        message.itemVariationId = object.itemVariationId ?? undefined;
        message.salePriceType = object.salePriceType ?? undefined;
        message.percentage = object.percentage ?? undefined;
        message.amountMoney = (object.amountMoney !== undefined && object.amountMoney !== null)
            ? Money.fromPartial(object.amountMoney)
            : undefined;
        message.validFromDate = object.validFromDate ?? undefined;
        message.validUntilDate = object.validUntilDate ?? undefined;
        return message;
    },
};
function createBaseCatalogModifier() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogModifier",
        name: undefined,
        priceMoney: undefined,
        onByDefault: undefined,
        ordinal: undefined,
        modifierListId: undefined,
        locationOverrides: [],
        kitchenName: undefined,
        imageId: undefined,
    };
}
export const CatalogModifier = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogModifier",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.priceMoney !== undefined) {
            Money.encode(message.priceMoney, writer.uint32(18).fork()).ldelim();
        }
        if (message.onByDefault !== undefined) {
            writer.uint32(24).bool(message.onByDefault);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(32).int32(message.ordinal);
        }
        if (message.modifierListId !== undefined) {
            writer.uint32(42).string(message.modifierListId);
        }
        for (const v of message.locationOverrides) {
            ModifierLocationOverrides.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.kitchenName !== undefined) {
            writer.uint32(66).string(message.kitchenName);
        }
        if (message.imageId !== undefined) {
            writer.uint32(74).string(message.imageId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogModifier();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.priceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.onByDefault = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.modifierListId = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.locationOverrides.push(ModifierLocationOverrides.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.kitchenName = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.imageId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogModifier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogModifier();
        message.name = object.name ?? undefined;
        message.priceMoney = (object.priceMoney !== undefined && object.priceMoney !== null)
            ? Money.fromPartial(object.priceMoney)
            : undefined;
        message.onByDefault = object.onByDefault ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.modifierListId = object.modifierListId ?? undefined;
        message.locationOverrides = object.locationOverrides?.map((e) => ModifierLocationOverrides.fromPartial(e)) || [];
        message.kitchenName = object.kitchenName ?? undefined;
        message.imageId = object.imageId ?? undefined;
        return message;
    },
};
function createBaseModifierLocationOverrides() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.ModifierLocationOverrides",
        locationId: undefined,
        priceMoney: undefined,
        soldOut: undefined,
        soldOutValidUntil: undefined,
    };
}
export const ModifierLocationOverrides = {
    $type: "squareup.connect.v2.merchant_catalog.resources.ModifierLocationOverrides",
    encode(message, writer = _m0.Writer.create()) {
        if (message.locationId !== undefined) {
            writer.uint32(10).string(message.locationId);
        }
        if (message.priceMoney !== undefined) {
            Money.encode(message.priceMoney, writer.uint32(18).fork()).ldelim();
        }
        if (message.soldOut !== undefined) {
            writer.uint32(72).bool(message.soldOut);
        }
        if (message.soldOutValidUntil !== undefined) {
            writer.uint32(82).string(message.soldOutValidUntil);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModifierLocationOverrides();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.priceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.soldOut = reader.bool();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.soldOutValidUntil = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ModifierLocationOverrides.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseModifierLocationOverrides();
        message.locationId = object.locationId ?? undefined;
        message.priceMoney = (object.priceMoney !== undefined && object.priceMoney !== null)
            ? Money.fromPartial(object.priceMoney)
            : undefined;
        message.soldOut = object.soldOut ?? undefined;
        message.soldOutValidUntil = object.soldOutValidUntil ?? undefined;
        return message;
    },
};
function createBaseCatalogModifierList() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogModifierList",
        name: undefined,
        ordinal: undefined,
        selectionType: undefined,
        modifiers: [],
        imageIds: [],
        allowQuantities: undefined,
        maxQuantity: undefined,
        isConversational: undefined,
        modifierType: undefined,
        maxLength: undefined,
        textRequired: undefined,
        internalName: undefined,
    };
}
export const CatalogModifierList = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogModifierList",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(18).string(message.name);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(24).int32(message.ordinal);
        }
        if (message.selectionType !== undefined) {
            writer.uint32(32).int32(message.selectionType);
        }
        for (const v of message.modifiers) {
            CatalogObject.encode(v, writer.uint32(42).fork()).ldelim();
        }
        for (const v of message.imageIds) {
            writer.uint32(50).string(v);
        }
        if (message.allowQuantities !== undefined) {
            writer.uint32(56).bool(message.allowQuantities);
        }
        if (message.maxQuantity !== undefined) {
            writer.uint32(64).int32(message.maxQuantity);
        }
        if (message.isConversational !== undefined) {
            writer.uint32(72).bool(message.isConversational);
        }
        if (message.modifierType !== undefined) {
            writer.uint32(80).int32(message.modifierType);
        }
        if (message.maxLength !== undefined) {
            writer.uint32(88).int32(message.maxLength);
        }
        if (message.textRequired !== undefined) {
            writer.uint32(96).bool(message.textRequired);
        }
        if (message.internalName !== undefined) {
            writer.uint32(106).string(message.internalName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogModifierList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.selectionType = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.modifiers.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.imageIds.push(reader.string());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.allowQuantities = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.maxQuantity = reader.int32();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.isConversational = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.modifierType = reader.int32();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.maxLength = reader.int32();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.textRequired = reader.bool();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.internalName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogModifierList.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogModifierList();
        message.name = object.name ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.selectionType = object.selectionType ?? undefined;
        message.modifiers = object.modifiers?.map((e) => CatalogObject.fromPartial(e)) || [];
        message.imageIds = object.imageIds?.map((e) => e) || [];
        message.allowQuantities = object.allowQuantities ?? undefined;
        message.maxQuantity = object.maxQuantity ?? undefined;
        message.isConversational = object.isConversational ?? undefined;
        message.modifierType = object.modifierType ?? undefined;
        message.maxLength = object.maxLength ?? undefined;
        message.textRequired = object.textRequired ?? undefined;
        message.internalName = object.internalName ?? undefined;
        return message;
    },
};
function createBaseCatalogImage() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogImage",
        name: undefined,
        url: undefined,
        caption: undefined,
        photoStudioOrderId: undefined,
    };
}
export const CatalogImage = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogImage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.url !== undefined) {
            writer.uint32(18).string(message.url);
        }
        if (message.caption !== undefined) {
            writer.uint32(26).string(message.caption);
        }
        if (message.photoStudioOrderId !== undefined) {
            writer.uint32(34).string(message.photoStudioOrderId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogImage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.caption = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.photoStudioOrderId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogImage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogImage();
        message.name = object.name ?? undefined;
        message.url = object.url ?? undefined;
        message.caption = object.caption ?? undefined;
        message.photoStudioOrderId = object.photoStudioOrderId ?? undefined;
        return message;
    },
};
function createBaseImageFileData() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.ImageFileData",
        body: undefined,
        contentType: undefined,
    };
}
export const ImageFileData = {
    $type: "squareup.connect.v2.merchant_catalog.resources.ImageFileData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.body !== undefined) {
            writer.uint32(10).bytes(message.body);
        }
        if (message.contentType !== undefined) {
            writer.uint32(18).string(message.contentType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseImageFileData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.body = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.contentType = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ImageFileData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseImageFileData();
        message.body = object.body ?? undefined;
        message.contentType = object.contentType ?? undefined;
        return message;
    },
};
function createBaseCatalogV1Id() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogV1Id",
        catalogV1Id: undefined,
        locationId: undefined,
    };
}
export const CatalogV1Id = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogV1Id",
    encode(message, writer = _m0.Writer.create()) {
        if (message.catalogV1Id !== undefined) {
            writer.uint32(10).string(message.catalogV1Id);
        }
        if (message.locationId !== undefined) {
            writer.uint32(18).string(message.locationId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogV1Id();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.catalogV1Id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogV1Id.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogV1Id();
        message.catalogV1Id = object.catalogV1Id ?? undefined;
        message.locationId = object.locationId ?? undefined;
        return message;
    },
};
function createBaseCatalogCustomAttributeValue() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeValue",
        name: undefined,
        stringValue: undefined,
        intValue: undefined,
        customAttributeDefinitionId: undefined,
        type: undefined,
        numberValue: undefined,
        booleanValue: undefined,
        selectionUidValues: [],
        key: undefined,
    };
}
export const CatalogCustomAttributeValue = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeValue",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.stringValue !== undefined) {
            writer.uint32(18).string(message.stringValue);
        }
        if (message.intValue !== undefined) {
            writer.uint32(24).int64(message.intValue);
        }
        if (message.customAttributeDefinitionId !== undefined) {
            writer.uint32(34).string(message.customAttributeDefinitionId);
        }
        if (message.type !== undefined) {
            writer.uint32(40).int32(message.type);
        }
        if (message.numberValue !== undefined) {
            writer.uint32(50).string(message.numberValue);
        }
        if (message.booleanValue !== undefined) {
            writer.uint32(56).bool(message.booleanValue);
        }
        for (const v of message.selectionUidValues) {
            writer.uint32(66).string(v);
        }
        if (message.key !== undefined) {
            writer.uint32(74).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCustomAttributeValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.stringValue = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.intValue = longToNumber(reader.int64());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.customAttributeDefinitionId = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.numberValue = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.booleanValue = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.selectionUidValues.push(reader.string());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCustomAttributeValue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCustomAttributeValue();
        message.name = object.name ?? undefined;
        message.stringValue = object.stringValue ?? undefined;
        message.intValue = object.intValue ?? undefined;
        message.customAttributeDefinitionId = object.customAttributeDefinitionId ?? undefined;
        message.type = object.type ?? undefined;
        message.numberValue = object.numberValue ?? undefined;
        message.booleanValue = object.booleanValue ?? undefined;
        message.selectionUidValues = object.selectionUidValues?.map((e) => e) || [];
        message.key = object.key ?? undefined;
        return message;
    },
};
function createBaseCatalogTimePeriod() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTimePeriod",
        event: undefined,
        almanacEventId: undefined,
    };
}
export const CatalogTimePeriod = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTimePeriod",
    encode(message, writer = _m0.Writer.create()) {
        if (message.event !== undefined) {
            writer.uint32(10).string(message.event);
        }
        if (message.almanacEventId !== undefined) {
            writer.uint32(18).string(message.almanacEventId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogTimePeriod();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.event = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.almanacEventId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogTimePeriod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogTimePeriod();
        message.event = object.event ?? undefined;
        message.almanacEventId = object.almanacEventId ?? undefined;
        return message;
    },
};
function createBaseCatalogProductSet() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogProductSet",
        name: undefined,
        productIdsAny: [],
        productIdsAll: [],
        quantityExact: undefined,
        quantityMin: undefined,
        quantityMax: undefined,
        allProducts: undefined,
        matchCustomAmounts: undefined,
        isProductAllTokensBeenCascadeDelete: undefined,
        lineItemTypes: [],
    };
}
export const CatalogProductSet = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogProductSet",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        for (const v of message.productIdsAny) {
            writer.uint32(18).string(v);
        }
        for (const v of message.productIdsAll) {
            writer.uint32(26).string(v);
        }
        if (message.quantityExact !== undefined) {
            writer.uint32(32).int64(message.quantityExact);
        }
        if (message.quantityMin !== undefined) {
            writer.uint32(40).int64(message.quantityMin);
        }
        if (message.quantityMax !== undefined) {
            writer.uint32(48).int64(message.quantityMax);
        }
        if (message.allProducts !== undefined) {
            writer.uint32(56).bool(message.allProducts);
        }
        if (message.matchCustomAmounts !== undefined) {
            writer.uint32(64).bool(message.matchCustomAmounts);
        }
        if (message.isProductAllTokensBeenCascadeDelete !== undefined) {
            writer.uint32(72).bool(message.isProductAllTokensBeenCascadeDelete);
        }
        writer.uint32(82).fork();
        for (const v of message.lineItemTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogProductSet();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.productIdsAny.push(reader.string());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.productIdsAll.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.quantityExact = longToNumber(reader.int64());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.quantityMin = longToNumber(reader.int64());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.quantityMax = longToNumber(reader.int64());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.allProducts = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.matchCustomAmounts = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.isProductAllTokensBeenCascadeDelete = reader.bool();
                    continue;
                case 10:
                    if (tag === 80) {
                        message.lineItemTypes.push(reader.int32());
                        continue;
                    }
                    if (tag === 82) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.lineItemTypes.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogProductSet.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogProductSet();
        message.name = object.name ?? undefined;
        message.productIdsAny = object.productIdsAny?.map((e) => e) || [];
        message.productIdsAll = object.productIdsAll?.map((e) => e) || [];
        message.quantityExact = object.quantityExact ?? undefined;
        message.quantityMin = object.quantityMin ?? undefined;
        message.quantityMax = object.quantityMax ?? undefined;
        message.allProducts = object.allProducts ?? undefined;
        message.matchCustomAmounts = object.matchCustomAmounts ?? undefined;
        message.isProductAllTokensBeenCascadeDelete = object.isProductAllTokensBeenCascadeDelete ?? undefined;
        message.lineItemTypes = object.lineItemTypes?.map((e) => e) || [];
        return message;
    },
};
function createBaseCatalogPricingRule() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogPricingRule",
        name: undefined,
        timePeriodIds: [],
        discountId: undefined,
        matchProductsId: undefined,
        applyProductsId: undefined,
        stackable: undefined,
        excludeProductsId: undefined,
        validFromDate: undefined,
        validFromLocalTime: undefined,
        validUntilDate: undefined,
        validUntilLocalTime: undefined,
        excludeStrategy: undefined,
        applicationMode: undefined,
        discountTargetScope: undefined,
        maxApplicationsPerAttachment: undefined,
        minimumOrderSubtotalMoney: undefined,
        customerGroupIdsAny: [],
        serviceChargeTargetScope: undefined,
        serviceChargeId: undefined,
        enabledPricingSources: [],
        disabledPricingSources: [],
        paymentTypes: [],
        minimumLineItemSubtotalMoney: undefined,
        ecomApplyToFulfillmentTypeServiceCharges: [],
    };
}
export const CatalogPricingRule = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogPricingRule",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        for (const v of message.timePeriodIds) {
            writer.uint32(18).string(v);
        }
        if (message.discountId !== undefined) {
            writer.uint32(42).string(message.discountId);
        }
        if (message.matchProductsId !== undefined) {
            writer.uint32(50).string(message.matchProductsId);
        }
        if (message.applyProductsId !== undefined) {
            writer.uint32(58).string(message.applyProductsId);
        }
        if (message.stackable !== undefined) {
            writer.uint32(64).int32(message.stackable);
        }
        if (message.excludeProductsId !== undefined) {
            writer.uint32(74).string(message.excludeProductsId);
        }
        if (message.validFromDate !== undefined) {
            writer.uint32(82).string(message.validFromDate);
        }
        if (message.validFromLocalTime !== undefined) {
            writer.uint32(90).string(message.validFromLocalTime);
        }
        if (message.validUntilDate !== undefined) {
            writer.uint32(98).string(message.validUntilDate);
        }
        if (message.validUntilLocalTime !== undefined) {
            writer.uint32(106).string(message.validUntilLocalTime);
        }
        if (message.excludeStrategy !== undefined) {
            writer.uint32(112).int32(message.excludeStrategy);
        }
        if (message.applicationMode !== undefined) {
            writer.uint32(120).int32(message.applicationMode);
        }
        if (message.discountTargetScope !== undefined) {
            writer.uint32(128).int32(message.discountTargetScope);
        }
        if (message.maxApplicationsPerAttachment !== undefined) {
            writer.uint32(136).int32(message.maxApplicationsPerAttachment);
        }
        if (message.minimumOrderSubtotalMoney !== undefined) {
            Money.encode(message.minimumOrderSubtotalMoney, writer.uint32(146).fork()).ldelim();
        }
        for (const v of message.customerGroupIdsAny) {
            writer.uint32(154).string(v);
        }
        if (message.serviceChargeTargetScope !== undefined) {
            writer.uint32(160).int32(message.serviceChargeTargetScope);
        }
        if (message.serviceChargeId !== undefined) {
            writer.uint32(170).string(message.serviceChargeId);
        }
        writer.uint32(178).fork();
        for (const v of message.enabledPricingSources) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(186).fork();
        for (const v of message.disabledPricingSources) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(194).fork();
        for (const v of message.paymentTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.minimumLineItemSubtotalMoney !== undefined) {
            Money.encode(message.minimumLineItemSubtotalMoney, writer.uint32(202).fork()).ldelim();
        }
        writer.uint32(210).fork();
        for (const v of message.ecomApplyToFulfillmentTypeServiceCharges) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogPricingRule();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.timePeriodIds.push(reader.string());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.discountId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.matchProductsId = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.applyProductsId = reader.string();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.stackable = reader.int32();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.excludeProductsId = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.validFromDate = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.validFromLocalTime = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.validUntilDate = reader.string();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.validUntilLocalTime = reader.string();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.excludeStrategy = reader.int32();
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.applicationMode = reader.int32();
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.discountTargetScope = reader.int32();
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.maxApplicationsPerAttachment = reader.int32();
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.minimumOrderSubtotalMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.customerGroupIdsAny.push(reader.string());
                    continue;
                case 20:
                    if (tag !== 160) {
                        break;
                    }
                    message.serviceChargeTargetScope = reader.int32();
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.serviceChargeId = reader.string();
                    continue;
                case 22:
                    if (tag === 176) {
                        message.enabledPricingSources.push(reader.int32());
                        continue;
                    }
                    if (tag === 178) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.enabledPricingSources.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 23:
                    if (tag === 184) {
                        message.disabledPricingSources.push(reader.int32());
                        continue;
                    }
                    if (tag === 186) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.disabledPricingSources.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 24:
                    if (tag === 192) {
                        message.paymentTypes.push(reader.int32());
                        continue;
                    }
                    if (tag === 194) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.paymentTypes.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.minimumLineItemSubtotalMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 26:
                    if (tag === 208) {
                        message.ecomApplyToFulfillmentTypeServiceCharges.push(reader.int32());
                        continue;
                    }
                    if (tag === 210) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.ecomApplyToFulfillmentTypeServiceCharges.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogPricingRule.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogPricingRule();
        message.name = object.name ?? undefined;
        message.timePeriodIds = object.timePeriodIds?.map((e) => e) || [];
        message.discountId = object.discountId ?? undefined;
        message.matchProductsId = object.matchProductsId ?? undefined;
        message.applyProductsId = object.applyProductsId ?? undefined;
        message.stackable = object.stackable ?? undefined;
        message.excludeProductsId = object.excludeProductsId ?? undefined;
        message.validFromDate = object.validFromDate ?? undefined;
        message.validFromLocalTime = object.validFromLocalTime ?? undefined;
        message.validUntilDate = object.validUntilDate ?? undefined;
        message.validUntilLocalTime = object.validUntilLocalTime ?? undefined;
        message.excludeStrategy = object.excludeStrategy ?? undefined;
        message.applicationMode = object.applicationMode ?? undefined;
        message.discountTargetScope = object.discountTargetScope ?? undefined;
        message.maxApplicationsPerAttachment = object.maxApplicationsPerAttachment ?? undefined;
        message.minimumOrderSubtotalMoney =
            (object.minimumOrderSubtotalMoney !== undefined && object.minimumOrderSubtotalMoney !== null)
                ? Money.fromPartial(object.minimumOrderSubtotalMoney)
                : undefined;
        message.customerGroupIdsAny = object.customerGroupIdsAny?.map((e) => e) || [];
        message.serviceChargeTargetScope = object.serviceChargeTargetScope ?? undefined;
        message.serviceChargeId = object.serviceChargeId ?? undefined;
        message.enabledPricingSources = object.enabledPricingSources?.map((e) => e) || [];
        message.disabledPricingSources = object.disabledPricingSources?.map((e) => e) || [];
        message.paymentTypes = object.paymentTypes?.map((e) => e) || [];
        message.minimumLineItemSubtotalMoney =
            (object.minimumLineItemSubtotalMoney !== undefined && object.minimumLineItemSubtotalMoney !== null)
                ? Money.fromPartial(object.minimumLineItemSubtotalMoney)
                : undefined;
        message.ecomApplyToFulfillmentTypeServiceCharges = object.ecomApplyToFulfillmentTypeServiceCharges?.map((e) => e) ||
            [];
        return message;
    },
};
function createBaseCatalogServiceCharge() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogServiceCharge",
        name: undefined,
        percentage: undefined,
        type: undefined,
        taxable: undefined,
        calculationPhase: undefined,
        minimumSeatCount: undefined,
        autoEnableType: undefined,
        amountMoney: undefined,
        labelColor: undefined,
        legacyTaxIds: [],
        calculationType: undefined,
        ecomApplyToFulfillmentTypes: [],
        treatmentType: undefined,
    };
}
export const CatalogServiceCharge = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogServiceCharge",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.percentage !== undefined) {
            writer.uint32(18).string(message.percentage);
        }
        if (message.type !== undefined) {
            writer.uint32(24).int32(message.type);
        }
        if (message.taxable !== undefined) {
            writer.uint32(32).bool(message.taxable);
        }
        if (message.calculationPhase !== undefined) {
            writer.uint32(40).int32(message.calculationPhase);
        }
        if (message.minimumSeatCount !== undefined) {
            writer.uint32(48).uint64(message.minimumSeatCount);
        }
        if (message.autoEnableType !== undefined) {
            writer.uint32(56).int32(message.autoEnableType);
        }
        if (message.amountMoney !== undefined) {
            Money.encode(message.amountMoney, writer.uint32(66).fork()).ldelim();
        }
        if (message.labelColor !== undefined) {
            writer.uint32(74).string(message.labelColor);
        }
        for (const v of message.legacyTaxIds) {
            writer.uint32(82).string(v);
        }
        if (message.calculationType !== undefined) {
            writer.uint32(88).int32(message.calculationType);
        }
        writer.uint32(98).fork();
        for (const v of message.ecomApplyToFulfillmentTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.treatmentType !== undefined) {
            writer.uint32(104).int32(message.treatmentType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogServiceCharge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.percentage = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.taxable = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.calculationPhase = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.minimumSeatCount = longToNumber(reader.uint64());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.autoEnableType = reader.int32();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.amountMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.labelColor = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.legacyTaxIds.push(reader.string());
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.calculationType = reader.int32();
                    continue;
                case 12:
                    if (tag === 96) {
                        message.ecomApplyToFulfillmentTypes.push(reader.int32());
                        continue;
                    }
                    if (tag === 98) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.ecomApplyToFulfillmentTypes.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.treatmentType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogServiceCharge.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogServiceCharge();
        message.name = object.name ?? undefined;
        message.percentage = object.percentage ?? undefined;
        message.type = object.type ?? undefined;
        message.taxable = object.taxable ?? undefined;
        message.calculationPhase = object.calculationPhase ?? undefined;
        message.minimumSeatCount = object.minimumSeatCount ?? undefined;
        message.autoEnableType = object.autoEnableType ?? undefined;
        message.amountMoney = (object.amountMoney !== undefined && object.amountMoney !== null)
            ? Money.fromPartial(object.amountMoney)
            : undefined;
        message.labelColor = object.labelColor ?? undefined;
        message.legacyTaxIds = object.legacyTaxIds?.map((e) => e) || [];
        message.calculationType = object.calculationType ?? undefined;
        message.ecomApplyToFulfillmentTypes = object.ecomApplyToFulfillmentTypes?.map((e) => e) || [];
        message.treatmentType = object.treatmentType ?? undefined;
        return message;
    },
};
function createBaseCatalogSubscriptionPlan() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogSubscriptionPlan",
        name: undefined,
        phases: [],
        taxInfo: undefined,
        configuration: undefined,
        monthlyBillingAnchorDate: undefined,
        canProrate: undefined,
        subscriptionPlanVariations: [],
        eligibleItemIds: [],
        eligibleCategoryIds: [],
        allItems: undefined,
        tenant: undefined,
    };
}
export const CatalogSubscriptionPlan = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogSubscriptionPlan",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        for (const v of message.phases) {
            SubscriptionPhase.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.taxInfo !== undefined) {
            SubscriptionTaxInfo.encode(message.taxInfo, writer.uint32(50).fork()).ldelim();
        }
        if (message.configuration !== undefined) {
            SubscriptionConfiguration.encode(message.configuration, writer.uint32(58).fork()).ldelim();
        }
        if (message.monthlyBillingAnchorDate !== undefined) {
            writer.uint32(144).int64(message.monthlyBillingAnchorDate);
        }
        if (message.canProrate !== undefined) {
            writer.uint32(72).bool(message.canProrate);
        }
        for (const v of message.subscriptionPlanVariations) {
            CatalogObject.encode(v, writer.uint32(82).fork()).ldelim();
        }
        for (const v of message.eligibleItemIds) {
            writer.uint32(90).string(v);
        }
        for (const v of message.eligibleCategoryIds) {
            writer.uint32(98).string(v);
        }
        if (message.allItems !== undefined) {
            writer.uint32(104).bool(message.allItems);
        }
        if (message.tenant !== undefined) {
            writer.uint32(112).int32(message.tenant);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogSubscriptionPlan();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.phases.push(SubscriptionPhase.decode(reader, reader.uint32()));
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.taxInfo = SubscriptionTaxInfo.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.configuration = SubscriptionConfiguration.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.monthlyBillingAnchorDate = longToNumber(reader.int64());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.canProrate = reader.bool();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.subscriptionPlanVariations.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.eligibleItemIds.push(reader.string());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.eligibleCategoryIds.push(reader.string());
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.allItems = reader.bool();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.tenant = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogSubscriptionPlan.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogSubscriptionPlan();
        message.name = object.name ?? undefined;
        message.phases = object.phases?.map((e) => SubscriptionPhase.fromPartial(e)) || [];
        message.taxInfo = (object.taxInfo !== undefined && object.taxInfo !== null)
            ? SubscriptionTaxInfo.fromPartial(object.taxInfo)
            : undefined;
        message.configuration = (object.configuration !== undefined && object.configuration !== null)
            ? SubscriptionConfiguration.fromPartial(object.configuration)
            : undefined;
        message.monthlyBillingAnchorDate = object.monthlyBillingAnchorDate ?? undefined;
        message.canProrate = object.canProrate ?? undefined;
        message.subscriptionPlanVariations = object.subscriptionPlanVariations?.map((e) => CatalogObject.fromPartial(e)) ||
            [];
        message.eligibleItemIds = object.eligibleItemIds?.map((e) => e) || [];
        message.eligibleCategoryIds = object.eligibleCategoryIds?.map((e) => e) || [];
        message.allItems = object.allItems ?? undefined;
        message.tenant = object.tenant ?? undefined;
        return message;
    },
};
function createBaseCatalogSubscriptionPlanVariation() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogSubscriptionPlanVariation",
        name: undefined,
        phases: [],
        taxInfo: undefined,
        configuration: undefined,
        subscriptionPlanId: undefined,
        monthlyBillingAnchorDate: undefined,
        canProrate: undefined,
        successorPlanVariationId: undefined,
        tenant: undefined,
    };
}
export const CatalogSubscriptionPlanVariation = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogSubscriptionPlanVariation",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        for (const v of message.phases) {
            SubscriptionPhase.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.taxInfo !== undefined) {
            SubscriptionTaxInfo.encode(message.taxInfo, writer.uint32(26).fork()).ldelim();
        }
        if (message.configuration !== undefined) {
            SubscriptionConfiguration.encode(message.configuration, writer.uint32(34).fork()).ldelim();
        }
        if (message.subscriptionPlanId !== undefined) {
            writer.uint32(42).string(message.subscriptionPlanId);
        }
        if (message.monthlyBillingAnchorDate !== undefined) {
            writer.uint32(48).int64(message.monthlyBillingAnchorDate);
        }
        if (message.canProrate !== undefined) {
            writer.uint32(56).bool(message.canProrate);
        }
        if (message.successorPlanVariationId !== undefined) {
            writer.uint32(66).string(message.successorPlanVariationId);
        }
        if (message.tenant !== undefined) {
            writer.uint32(112).int32(message.tenant);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogSubscriptionPlanVariation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.phases.push(SubscriptionPhase.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.taxInfo = SubscriptionTaxInfo.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.configuration = SubscriptionConfiguration.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.subscriptionPlanId = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.monthlyBillingAnchorDate = longToNumber(reader.int64());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.canProrate = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.successorPlanVariationId = reader.string();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.tenant = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogSubscriptionPlanVariation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogSubscriptionPlanVariation();
        message.name = object.name ?? undefined;
        message.phases = object.phases?.map((e) => SubscriptionPhase.fromPartial(e)) || [];
        message.taxInfo = (object.taxInfo !== undefined && object.taxInfo !== null)
            ? SubscriptionTaxInfo.fromPartial(object.taxInfo)
            : undefined;
        message.configuration = (object.configuration !== undefined && object.configuration !== null)
            ? SubscriptionConfiguration.fromPartial(object.configuration)
            : undefined;
        message.subscriptionPlanId = object.subscriptionPlanId ?? undefined;
        message.monthlyBillingAnchorDate = object.monthlyBillingAnchorDate ?? undefined;
        message.canProrate = object.canProrate ?? undefined;
        message.successorPlanVariationId = object.successorPlanVariationId ?? undefined;
        message.tenant = object.tenant ?? undefined;
        return message;
    },
};
function createBaseSubscriptionPhase() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.SubscriptionPhase",
        uid: undefined,
        cadence: undefined,
        periods: undefined,
        recurringPriceMoney: undefined,
        ordinal: undefined,
        oneTimeFee: undefined,
        pricing: undefined,
    };
}
export const SubscriptionPhase = {
    $type: "squareup.connect.v2.merchant_catalog.resources.SubscriptionPhase",
    encode(message, writer = _m0.Writer.create()) {
        if (message.uid !== undefined) {
            writer.uint32(18).string(message.uid);
        }
        if (message.cadence !== undefined) {
            writer.uint32(24).int32(message.cadence);
        }
        if (message.periods !== undefined) {
            writer.uint32(32).uint64(message.periods);
        }
        if (message.recurringPriceMoney !== undefined) {
            Money.encode(message.recurringPriceMoney, writer.uint32(42).fork()).ldelim();
        }
        if (message.ordinal !== undefined) {
            writer.uint32(48).int64(message.ordinal);
        }
        if (message.oneTimeFee !== undefined) {
            OneTimeFee.encode(message.oneTimeFee, writer.uint32(58).fork()).ldelim();
        }
        if (message.pricing !== undefined) {
            SubscriptionPricing.encode(message.pricing, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionPhase();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.uid = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.cadence = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.periods = longToNumber(reader.uint64());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.recurringPriceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.ordinal = longToNumber(reader.int64());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.oneTimeFee = OneTimeFee.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.pricing = SubscriptionPricing.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriptionPhase.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionPhase();
        message.uid = object.uid ?? undefined;
        message.cadence = object.cadence ?? undefined;
        message.periods = object.periods ?? undefined;
        message.recurringPriceMoney = (object.recurringPriceMoney !== undefined && object.recurringPriceMoney !== null)
            ? Money.fromPartial(object.recurringPriceMoney)
            : undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.oneTimeFee = (object.oneTimeFee !== undefined && object.oneTimeFee !== null)
            ? OneTimeFee.fromPartial(object.oneTimeFee)
            : undefined;
        message.pricing = (object.pricing !== undefined && object.pricing !== null)
            ? SubscriptionPricing.fromPartial(object.pricing)
            : undefined;
        return message;
    },
};
function createBaseOneTimeFee() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.OneTimeFee",
        priceMoney: undefined,
        description: undefined,
    };
}
export const OneTimeFee = {
    $type: "squareup.connect.v2.merchant_catalog.resources.OneTimeFee",
    encode(message, writer = _m0.Writer.create()) {
        if (message.priceMoney !== undefined) {
            Money.encode(message.priceMoney, writer.uint32(10).fork()).ldelim();
        }
        if (message.description !== undefined) {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOneTimeFee();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.priceMoney = Money.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return OneTimeFee.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOneTimeFee();
        message.priceMoney = (object.priceMoney !== undefined && object.priceMoney !== null)
            ? Money.fromPartial(object.priceMoney)
            : undefined;
        message.description = object.description ?? undefined;
        return message;
    },
};
function createBaseSubscriptionTaxInfo() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.SubscriptionTaxInfo",
        sellerCode: undefined,
        productCode: undefined,
        productClass: undefined,
    };
}
export const SubscriptionTaxInfo = {
    $type: "squareup.connect.v2.merchant_catalog.resources.SubscriptionTaxInfo",
    encode(message, writer = _m0.Writer.create()) {
        if (message.sellerCode !== undefined) {
            writer.uint32(10).string(message.sellerCode);
        }
        if (message.productCode !== undefined) {
            writer.uint32(18).string(message.productCode);
        }
        if (message.productClass !== undefined) {
            writer.uint32(26).string(message.productClass);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionTaxInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sellerCode = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.productCode = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.productClass = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriptionTaxInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionTaxInfo();
        message.sellerCode = object.sellerCode ?? undefined;
        message.productCode = object.productCode ?? undefined;
        message.productClass = object.productClass ?? undefined;
        return message;
    },
};
function createBaseSubscriptionConfiguration() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.SubscriptionConfiguration",
        buyerAllowIndefinitePausing: undefined,
        buyerMaxCyclesToSkip: undefined,
    };
}
export const SubscriptionConfiguration = {
    $type: "squareup.connect.v2.merchant_catalog.resources.SubscriptionConfiguration",
    encode(message, writer = _m0.Writer.create()) {
        if (message.buyerAllowIndefinitePausing !== undefined) {
            writer.uint32(8).bool(message.buyerAllowIndefinitePausing);
        }
        if (message.buyerMaxCyclesToSkip !== undefined) {
            writer.uint32(16).int64(message.buyerMaxCyclesToSkip);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionConfiguration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.buyerAllowIndefinitePausing = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.buyerMaxCyclesToSkip = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriptionConfiguration.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionConfiguration();
        message.buyerAllowIndefinitePausing = object.buyerAllowIndefinitePausing ?? undefined;
        message.buyerMaxCyclesToSkip = object.buyerMaxCyclesToSkip ?? undefined;
        return message;
    },
};
function createBaseSubscriptionPricing() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.SubscriptionPricing",
        type: undefined,
        price: undefined,
        discountIds: [],
        priceMoney: undefined,
    };
}
export const SubscriptionPricing = {
    $type: "squareup.connect.v2.merchant_catalog.resources.SubscriptionPricing",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.price !== undefined) {
            Money.encode(message.price, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.discountIds) {
            writer.uint32(26).string(v);
        }
        if (message.priceMoney !== undefined) {
            Money.encode(message.priceMoney, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionPricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.price = Money.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.discountIds.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.priceMoney = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriptionPricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionPricing();
        message.type = object.type ?? undefined;
        message.price = (object.price !== undefined && object.price !== null) ? Money.fromPartial(object.price) : undefined;
        message.discountIds = object.discountIds?.map((e) => e) || [];
        message.priceMoney = (object.priceMoney !== undefined && object.priceMoney !== null)
            ? Money.fromPartial(object.priceMoney)
            : undefined;
        return message;
    },
};
function createBaseCatalogTicketTemplate() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTicketTemplate",
        name: undefined,
        ticketGroupId: undefined,
        ordinal: undefined,
    };
}
export const CatalogTicketTemplate = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTicketTemplate",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.ticketGroupId !== undefined) {
            writer.uint32(18).string(message.ticketGroupId);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(24).int32(message.ordinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogTicketTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.ticketGroupId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogTicketTemplate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogTicketTemplate();
        message.name = object.name ?? undefined;
        message.ticketGroupId = object.ticketGroupId ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseCatalogTicketGroup() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTicketGroup",
        name: undefined,
        ordinal: undefined,
        namingMethod: undefined,
        label: undefined,
        numberingStartsAt: undefined,
        prefixTableNames: undefined,
    };
}
export const CatalogTicketGroup = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTicketGroup",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int32(message.ordinal);
        }
        if (message.namingMethod !== undefined) {
            writer.uint32(24).int32(message.namingMethod);
        }
        if (message.label !== undefined) {
            writer.uint32(34).string(message.label);
        }
        if (message.numberingStartsAt !== undefined) {
            writer.uint32(40).int32(message.numberingStartsAt);
        }
        if (message.prefixTableNames !== undefined) {
            writer.uint32(48).int32(message.prefixTableNames);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogTicketGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.namingMethod = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.label = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.numberingStartsAt = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.prefixTableNames = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogTicketGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogTicketGroup();
        message.name = object.name ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.namingMethod = object.namingMethod ?? undefined;
        message.label = object.label ?? undefined;
        message.numberingStartsAt = object.numberingStartsAt ?? undefined;
        message.prefixTableNames = object.prefixTableNames ?? undefined;
        return message;
    },
};
function createBaseCatalogFloorPlan() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlan",
        name: undefined,
        height: undefined,
        width: undefined,
        ordinal: undefined,
    };
}
export const CatalogFloorPlan = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlan",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.height !== undefined) {
            writer.uint32(16).int32(message.height);
        }
        if (message.width !== undefined) {
            writer.uint32(24).int32(message.width);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(32).int32(message.ordinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogFloorPlan();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogFloorPlan.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogFloorPlan();
        message.name = object.name ?? undefined;
        message.height = object.height ?? undefined;
        message.width = object.width ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseCatalogFloorPlanTile() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlanTile",
        floorPlanId: undefined,
        placeholderId: undefined,
        ticketTemplateId: undefined,
        shape: undefined,
        height: undefined,
        width: undefined,
        xPosition: undefined,
        yPosition: undefined,
        zOrder: undefined,
        rotationAngle: undefined,
        color: undefined,
    };
}
export const CatalogFloorPlanTile = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlanTile",
    encode(message, writer = _m0.Writer.create()) {
        if (message.floorPlanId !== undefined) {
            writer.uint32(10).string(message.floorPlanId);
        }
        if (message.placeholderId !== undefined) {
            writer.uint32(18).string(message.placeholderId);
        }
        if (message.ticketTemplateId !== undefined) {
            writer.uint32(26).string(message.ticketTemplateId);
        }
        if (message.shape !== undefined) {
            writer.uint32(32).int32(message.shape);
        }
        if (message.height !== undefined) {
            writer.uint32(40).int32(message.height);
        }
        if (message.width !== undefined) {
            writer.uint32(48).int32(message.width);
        }
        if (message.xPosition !== undefined) {
            writer.uint32(56).int32(message.xPosition);
        }
        if (message.yPosition !== undefined) {
            writer.uint32(64).int32(message.yPosition);
        }
        if (message.zOrder !== undefined) {
            writer.uint32(72).int32(message.zOrder);
        }
        if (message.rotationAngle !== undefined) {
            writer.uint32(82).string(message.rotationAngle);
        }
        if (message.color !== undefined) {
            writer.uint32(90).string(message.color);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogFloorPlanTile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.floorPlanId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.placeholderId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.ticketTemplateId = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.shape = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.xPosition = reader.int32();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.yPosition = reader.int32();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.zOrder = reader.int32();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.rotationAngle = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogFloorPlanTile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogFloorPlanTile();
        message.floorPlanId = object.floorPlanId ?? undefined;
        message.placeholderId = object.placeholderId ?? undefined;
        message.ticketTemplateId = object.ticketTemplateId ?? undefined;
        message.shape = object.shape ?? undefined;
        message.height = object.height ?? undefined;
        message.width = object.width ?? undefined;
        message.xPosition = object.xPosition ?? undefined;
        message.yPosition = object.yPosition ?? undefined;
        message.zOrder = object.zOrder ?? undefined;
        message.rotationAngle = object.rotationAngle ?? undefined;
        message.color = object.color ?? undefined;
        return message;
    },
};
function createBaseCatalogMeasurementUnit() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogMeasurementUnit",
        measurementUnit: undefined,
        precision: undefined,
    };
}
export const CatalogMeasurementUnit = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogMeasurementUnit",
    encode(message, writer = _m0.Writer.create()) {
        if (message.measurementUnit !== undefined) {
            MeasurementUnit.encode(message.measurementUnit, writer.uint32(10).fork()).ldelim();
        }
        if (message.precision !== undefined) {
            writer.uint32(16).int32(message.precision);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogMeasurementUnit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.measurementUnit = MeasurementUnit.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.precision = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogMeasurementUnit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogMeasurementUnit();
        message.measurementUnit = (object.measurementUnit !== undefined && object.measurementUnit !== null)
            ? MeasurementUnit.fromPartial(object.measurementUnit)
            : undefined;
        message.precision = object.precision ?? undefined;
        return message;
    },
};
function createBaseCatalogQuickAmount() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmount",
        type: undefined,
        amount: undefined,
        score: undefined,
        ordinal: undefined,
    };
}
export const CatalogQuickAmount = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmount",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.amount !== undefined) {
            Money.encode(message.amount, writer.uint32(18).fork()).ldelim();
        }
        if (message.score !== undefined) {
            writer.uint32(24).int64(message.score);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(32).int64(message.ordinal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuickAmount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.amount = Money.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.score = longToNumber(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.ordinal = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuickAmount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuickAmount();
        message.type = object.type ?? undefined;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? Money.fromPartial(object.amount)
            : undefined;
        message.score = object.score ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseCatalogQuickAmountsSettings() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmountsSettings",
        option: undefined,
        eligibleForAutoAmounts: undefined,
        amounts: [],
    };
}
export const CatalogQuickAmountsSettings = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmountsSettings",
    encode(message, writer = _m0.Writer.create()) {
        if (message.option !== undefined) {
            writer.uint32(8).int32(message.option);
        }
        if (message.eligibleForAutoAmounts !== undefined) {
            writer.uint32(16).bool(message.eligibleForAutoAmounts);
        }
        for (const v of message.amounts) {
            CatalogQuickAmount.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogQuickAmountsSettings();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.option = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.eligibleForAutoAmounts = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.amounts.push(CatalogQuickAmount.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogQuickAmountsSettings.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogQuickAmountsSettings();
        message.option = object.option ?? undefined;
        message.eligibleForAutoAmounts = object.eligibleForAutoAmounts ?? undefined;
        message.amounts = object.amounts?.map((e) => CatalogQuickAmount.fromPartial(e)) || [];
        return message;
    },
};
function createBaseResource() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.Resource", name: undefined, description: undefined };
}
export const Resource = {
    $type: "squareup.connect.v2.merchant_catalog.resources.Resource",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.description !== undefined) {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResource();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Resource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseResource();
        message.name = object.name ?? undefined;
        message.description = object.description ?? undefined;
        return message;
    },
};
function createBaseCatalogCheckoutLink() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCheckoutLink",
        name: undefined,
        description: undefined,
        linkType: undefined,
        enabled: undefined,
        source: undefined,
        referenceId: undefined,
        checkoutButton: undefined,
        orderDetails: undefined,
        subscriptionPlanIds: [],
        allowTipping: undefined,
        donationGoal: undefined,
        subscriptionOnly: undefined,
        shortUrl: undefined,
        longUrl: undefined,
        url: undefined,
        customFields: [],
        imageIds: [],
        redirectUrl: undefined,
        paymentNote: undefined,
    };
}
export const CatalogCheckoutLink = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCheckoutLink",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.description !== undefined) {
            writer.uint32(18).string(message.description);
        }
        if (message.linkType !== undefined) {
            writer.uint32(24).int32(message.linkType);
        }
        if (message.enabled !== undefined) {
            writer.uint32(32).bool(message.enabled);
        }
        if (message.source !== undefined) {
            writer.uint32(58).string(message.source);
        }
        if (message.referenceId !== undefined) {
            writer.uint32(66).string(message.referenceId);
        }
        if (message.checkoutButton !== undefined) {
            CheckoutLinkButtonSettings.encode(message.checkoutButton, writer.uint32(74).fork()).ldelim();
        }
        if (message.orderDetails !== undefined) {
            CheckoutLinkOrderDetails.encode(message.orderDetails, writer.uint32(82).fork()).ldelim();
        }
        for (const v of message.subscriptionPlanIds) {
            writer.uint32(90).string(v);
        }
        if (message.allowTipping !== undefined) {
            writer.uint32(96).bool(message.allowTipping);
        }
        if (message.donationGoal !== undefined) {
            CheckoutLinkDonationGoal.encode(message.donationGoal, writer.uint32(106).fork()).ldelim();
        }
        if (message.subscriptionOnly !== undefined) {
            writer.uint32(112).bool(message.subscriptionOnly);
        }
        if (message.shortUrl !== undefined) {
            writer.uint32(122).string(message.shortUrl);
        }
        if (message.longUrl !== undefined) {
            writer.uint32(130).string(message.longUrl);
        }
        if (message.url !== undefined) {
            writer.uint32(138).string(message.url);
        }
        for (const v of message.customFields) {
            CheckoutLinkCustomField.encode(v, writer.uint32(146).fork()).ldelim();
        }
        for (const v of message.imageIds) {
            writer.uint32(154).string(v);
        }
        if (message.redirectUrl !== undefined) {
            writer.uint32(162).string(message.redirectUrl);
        }
        if (message.paymentNote !== undefined) {
            writer.uint32(170).string(message.paymentNote);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCheckoutLink();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.linkType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.source = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.referenceId = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.checkoutButton = CheckoutLinkButtonSettings.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.orderDetails = CheckoutLinkOrderDetails.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.subscriptionPlanIds.push(reader.string());
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.allowTipping = reader.bool();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.donationGoal = CheckoutLinkDonationGoal.decode(reader, reader.uint32());
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.subscriptionOnly = reader.bool();
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.shortUrl = reader.string();
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.longUrl = reader.string();
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.customFields.push(CheckoutLinkCustomField.decode(reader, reader.uint32()));
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.imageIds.push(reader.string());
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.redirectUrl = reader.string();
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.paymentNote = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCheckoutLink.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCheckoutLink();
        message.name = object.name ?? undefined;
        message.description = object.description ?? undefined;
        message.linkType = object.linkType ?? undefined;
        message.enabled = object.enabled ?? undefined;
        message.source = object.source ?? undefined;
        message.referenceId = object.referenceId ?? undefined;
        message.checkoutButton = (object.checkoutButton !== undefined && object.checkoutButton !== null)
            ? CheckoutLinkButtonSettings.fromPartial(object.checkoutButton)
            : undefined;
        message.orderDetails = (object.orderDetails !== undefined && object.orderDetails !== null)
            ? CheckoutLinkOrderDetails.fromPartial(object.orderDetails)
            : undefined;
        message.subscriptionPlanIds = object.subscriptionPlanIds?.map((e) => e) || [];
        message.allowTipping = object.allowTipping ?? undefined;
        message.donationGoal = (object.donationGoal !== undefined && object.donationGoal !== null)
            ? CheckoutLinkDonationGoal.fromPartial(object.donationGoal)
            : undefined;
        message.subscriptionOnly = object.subscriptionOnly ?? undefined;
        message.shortUrl = object.shortUrl ?? undefined;
        message.longUrl = object.longUrl ?? undefined;
        message.url = object.url ?? undefined;
        message.customFields = object.customFields?.map((e) => CheckoutLinkCustomField.fromPartial(e)) || [];
        message.imageIds = object.imageIds?.map((e) => e) || [];
        message.redirectUrl = object.redirectUrl ?? undefined;
        message.paymentNote = object.paymentNote ?? undefined;
        return message;
    },
};
function createBaseCheckoutLinkButtonSettings() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkButtonSettings",
        text: undefined,
        color: undefined,
        showTitle: undefined,
        showPrice: undefined,
    };
}
export const CheckoutLinkButtonSettings = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkButtonSettings",
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== undefined) {
            writer.uint32(10).string(message.text);
        }
        if (message.color !== undefined) {
            writer.uint32(18).string(message.color);
        }
        if (message.showTitle !== undefined) {
            writer.uint32(24).bool(message.showTitle);
        }
        if (message.showPrice !== undefined) {
            writer.uint32(32).bool(message.showPrice);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCheckoutLinkButtonSettings();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.showTitle = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.showPrice = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CheckoutLinkButtonSettings.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckoutLinkButtonSettings();
        message.text = object.text ?? undefined;
        message.color = object.color ?? undefined;
        message.showTitle = object.showTitle ?? undefined;
        message.showPrice = object.showPrice ?? undefined;
        return message;
    },
};
function createBaseCheckoutLinkDonationGoal() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkDonationGoal",
        beginTime: undefined,
        endTime: undefined,
        target: undefined,
    };
}
export const CheckoutLinkDonationGoal = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkDonationGoal",
    encode(message, writer = _m0.Writer.create()) {
        if (message.beginTime !== undefined) {
            writer.uint32(10).string(message.beginTime);
        }
        if (message.endTime !== undefined) {
            writer.uint32(18).string(message.endTime);
        }
        if (message.target !== undefined) {
            Money.encode(message.target, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCheckoutLinkDonationGoal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.beginTime = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.endTime = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.target = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CheckoutLinkDonationGoal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckoutLinkDonationGoal();
        message.beginTime = object.beginTime ?? undefined;
        message.endTime = object.endTime ?? undefined;
        message.target = (object.target !== undefined && object.target !== null)
            ? Money.fromPartial(object.target)
            : undefined;
        return message;
    },
};
function createBaseCheckoutLinkCustomField() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkCustomField",
        uid: undefined,
        ordinal: undefined,
        name: undefined,
    };
}
export const CheckoutLinkCustomField = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkCustomField",
    encode(message, writer = _m0.Writer.create()) {
        if (message.uid !== undefined) {
            writer.uint32(10).string(message.uid);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int64(message.ordinal);
        }
        if (message.name !== undefined) {
            writer.uint32(26).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCheckoutLinkCustomField();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.uid = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CheckoutLinkCustomField.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckoutLinkCustomField();
        message.uid = object.uid ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.name = object.name ?? undefined;
        return message;
    },
};
function createBaseCheckoutLinkOrderDetails() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkOrderDetails", lineItems: [] };
}
export const CheckoutLinkOrderDetails = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkOrderDetails",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.lineItems) {
            CheckoutLinkOrderDetailsLineItem.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCheckoutLinkOrderDetails();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.lineItems.push(CheckoutLinkOrderDetailsLineItem.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CheckoutLinkOrderDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckoutLinkOrderDetails();
        message.lineItems = object.lineItems?.map((e) => CheckoutLinkOrderDetailsLineItem.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCheckoutLinkOrderDetailsLineItem() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkOrderDetailsLineItem",
        uid: undefined,
        ordinal: undefined,
        quantity: undefined,
        itemId: undefined,
        name: undefined,
        priceMoney: undefined,
    };
}
export const CheckoutLinkOrderDetailsLineItem = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkOrderDetailsLineItem",
    encode(message, writer = _m0.Writer.create()) {
        if (message.uid !== undefined) {
            writer.uint32(10).string(message.uid);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int64(message.ordinal);
        }
        if (message.quantity !== undefined) {
            QuantityRatio.encode(message.quantity, writer.uint32(26).fork()).ldelim();
        }
        if (message.itemId !== undefined) {
            writer.uint32(34).string(message.itemId);
        }
        if (message.name !== undefined) {
            writer.uint32(42).string(message.name);
        }
        if (message.priceMoney !== undefined) {
            Money.encode(message.priceMoney, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCheckoutLinkOrderDetailsLineItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.uid = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.quantity = QuantityRatio.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.priceMoney = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CheckoutLinkOrderDetailsLineItem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckoutLinkOrderDetailsLineItem();
        message.uid = object.uid ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.quantity = (object.quantity !== undefined && object.quantity !== null)
            ? QuantityRatio.fromPartial(object.quantity)
            : undefined;
        message.itemId = object.itemId ?? undefined;
        message.name = object.name ?? undefined;
        message.priceMoney = (object.priceMoney !== undefined && object.priceMoney !== null)
            ? Money.fromPartial(object.priceMoney)
            : undefined;
        return message;
    },
};
function createBaseCatalogObject() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
        type: undefined,
        id: undefined,
        updatedAt: undefined,
        createdAt: undefined,
        version: undefined,
        isDeleted: undefined,
        DEPRECATEDCustomAttributes: [],
        customAttributeValues: {},
        catalogV1Ids: [],
        presentAtAllLocations: undefined,
        presentAtLocationIds: [],
        absentAtLocationIds: [],
        imageId: undefined,
        itemData: undefined,
        categoryData: undefined,
        itemVariationData: undefined,
        taxData: undefined,
        discountData: undefined,
        modifierListData: undefined,
        modifierData: undefined,
        timePeriodData: undefined,
        productSetData: undefined,
        pricingRuleData: undefined,
        imageData: undefined,
        measurementUnitData: undefined,
        subscriptionPlanData: undefined,
        itemOptionData: undefined,
        itemOptionValueData: undefined,
        customAttributeDefinitionData: undefined,
        quickAmountsSettingsData: undefined,
        taxExemptionData: undefined,
        diningOptionData: undefined,
        resourceData: undefined,
        compositionData: undefined,
        componentData: undefined,
        serviceChargeData: undefined,
        checkoutLinkData: undefined,
        addressData: undefined,
        ticketTemplateData: undefined,
        voidReasonData: undefined,
        menuData: undefined,
        menuGroupData: undefined,
        pageData: undefined,
        pageTileData: undefined,
        placeholderData: undefined,
        tagData: undefined,
        itemVariationVendorInfoData: undefined,
        configurationData: undefined,
        subscriptionPlanVariationData: undefined,
        availabilityPeriodData: undefined,
        ticketGroupData: undefined,
        floorPlanData: undefined,
        floorPlanTileData: undefined,
        creditRedemptionPolicyData: undefined,
        ageRestrictionData: undefined,
        favoritesListPositionData: undefined,
        salePriceData: undefined,
        taxCategoryData: undefined,
    };
}
export const CatalogObject = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.id !== undefined) {
            writer.uint32(18).string(message.id);
        }
        if (message.updatedAt !== undefined) {
            writer.uint32(26).string(message.updatedAt);
        }
        if (message.createdAt !== undefined) {
            writer.uint32(1058).string(message.createdAt);
        }
        if (message.version !== undefined) {
            writer.uint32(32).int64(message.version);
        }
        if (message.isDeleted !== undefined) {
            writer.uint32(40).bool(message.isDeleted);
        }
        for (const v of message.DEPRECATEDCustomAttributes) {
            CatalogCustomAttributeValue.encode(v, writer.uint32(114).fork()).ldelim();
        }
        Object.entries(message.customAttributeValues).forEach(([key, value]) => {
            CatalogObject_CustomAttributeValuesEntry.encode({
                $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObject.CustomAttributeValuesEntry",
                key: key,
                value,
            }, writer.uint32(122).fork()).ldelim();
        });
        for (const v of message.catalogV1Ids) {
            CatalogV1Id.encode(v, writer.uint32(66).fork()).ldelim();
        }
        if (message.presentAtAllLocations !== undefined) {
            writer.uint32(72).bool(message.presentAtAllLocations);
        }
        for (const v of message.presentAtLocationIds) {
            writer.uint32(82).string(v);
        }
        for (const v of message.absentAtLocationIds) {
            writer.uint32(90).string(v);
        }
        if (message.imageId !== undefined) {
            writer.uint32(98).string(message.imageId);
        }
        if (message.itemData !== undefined) {
            CatalogItem.encode(message.itemData, writer.uint32(810).fork()).ldelim();
        }
        if (message.categoryData !== undefined) {
            CatalogCategory.encode(message.categoryData, writer.uint32(834).fork()).ldelim();
        }
        if (message.itemVariationData !== undefined) {
            CatalogItemVariation.encode(message.itemVariationData, writer.uint32(842).fork()).ldelim();
        }
        if (message.taxData !== undefined) {
            CatalogTax.encode(message.taxData, writer.uint32(850).fork()).ldelim();
        }
        if (message.discountData !== undefined) {
            CatalogDiscount.encode(message.discountData, writer.uint32(866).fork()).ldelim();
        }
        if (message.modifierListData !== undefined) {
            CatalogModifierList.encode(message.modifierListData, writer.uint32(882).fork()).ldelim();
        }
        if (message.modifierData !== undefined) {
            CatalogModifier.encode(message.modifierData, writer.uint32(898).fork()).ldelim();
        }
        if (message.timePeriodData !== undefined) {
            CatalogTimePeriod.encode(message.timePeriodData, writer.uint32(906).fork()).ldelim();
        }
        if (message.productSetData !== undefined) {
            CatalogProductSet.encode(message.productSetData, writer.uint32(914).fork()).ldelim();
        }
        if (message.pricingRuleData !== undefined) {
            CatalogPricingRule.encode(message.pricingRuleData, writer.uint32(922).fork()).ldelim();
        }
        if (message.imageData !== undefined) {
            CatalogImage.encode(message.imageData, writer.uint32(930).fork()).ldelim();
        }
        if (message.measurementUnitData !== undefined) {
            CatalogMeasurementUnit.encode(message.measurementUnitData, writer.uint32(938).fork()).ldelim();
        }
        if (message.subscriptionPlanData !== undefined) {
            CatalogSubscriptionPlan.encode(message.subscriptionPlanData, writer.uint32(946).fork()).ldelim();
        }
        if (message.itemOptionData !== undefined) {
            CatalogItemOption.encode(message.itemOptionData, writer.uint32(954).fork()).ldelim();
        }
        if (message.itemOptionValueData !== undefined) {
            CatalogItemOptionValue.encode(message.itemOptionValueData, writer.uint32(962).fork()).ldelim();
        }
        if (message.customAttributeDefinitionData !== undefined) {
            CatalogCustomAttributeDefinition.encode(message.customAttributeDefinitionData, writer.uint32(970).fork())
                .ldelim();
        }
        if (message.quickAmountsSettingsData !== undefined) {
            CatalogQuickAmountsSettings.encode(message.quickAmountsSettingsData, writer.uint32(978).fork()).ldelim();
        }
        if (message.taxExemptionData !== undefined) {
            CatalogTaxExemption.encode(message.taxExemptionData, writer.uint32(986).fork()).ldelim();
        }
        if (message.diningOptionData !== undefined) {
            CatalogDiningOption.encode(message.diningOptionData, writer.uint32(994).fork()).ldelim();
        }
        if (message.resourceData !== undefined) {
            Resource.encode(message.resourceData, writer.uint32(1002).fork()).ldelim();
        }
        if (message.compositionData !== undefined) {
            CatalogComposition.encode(message.compositionData, writer.uint32(1018).fork()).ldelim();
        }
        if (message.componentData !== undefined) {
            CatalogComponent.encode(message.componentData, writer.uint32(1026).fork()).ldelim();
        }
        if (message.serviceChargeData !== undefined) {
            CatalogServiceCharge.encode(message.serviceChargeData, writer.uint32(1034).fork()).ldelim();
        }
        if (message.checkoutLinkData !== undefined) {
            CatalogCheckoutLink.encode(message.checkoutLinkData, writer.uint32(1042).fork()).ldelim();
        }
        if (message.addressData !== undefined) {
            CatalogAddress.encode(message.addressData, writer.uint32(1050).fork()).ldelim();
        }
        if (message.ticketTemplateData !== undefined) {
            CatalogTicketTemplate.encode(message.ticketTemplateData, writer.uint32(1074).fork()).ldelim();
        }
        if (message.voidReasonData !== undefined) {
            CatalogVoidReason.encode(message.voidReasonData, writer.uint32(1082).fork()).ldelim();
        }
        if (message.menuData !== undefined) {
            CatalogMenu.encode(message.menuData, writer.uint32(1098).fork()).ldelim();
        }
        if (message.menuGroupData !== undefined) {
            CatalogMenuGroup.encode(message.menuGroupData, writer.uint32(1106).fork()).ldelim();
        }
        if (message.pageData !== undefined) {
            CatalogPage.encode(message.pageData, writer.uint32(1114).fork()).ldelim();
        }
        if (message.pageTileData !== undefined) {
            CatalogPageTile.encode(message.pageTileData, writer.uint32(1122).fork()).ldelim();
        }
        if (message.placeholderData !== undefined) {
            CatalogPlaceholder.encode(message.placeholderData, writer.uint32(1130).fork()).ldelim();
        }
        if (message.tagData !== undefined) {
            CatalogTag.encode(message.tagData, writer.uint32(1138).fork()).ldelim();
        }
        if (message.itemVariationVendorInfoData !== undefined) {
            CatalogItemVariationVendorInfo.encode(message.itemVariationVendorInfoData, writer.uint32(1146).fork()).ldelim();
        }
        if (message.configurationData !== undefined) {
            CatalogConfiguration.encode(message.configurationData, writer.uint32(1154).fork()).ldelim();
        }
        if (message.subscriptionPlanVariationData !== undefined) {
            CatalogSubscriptionPlanVariation.encode(message.subscriptionPlanVariationData, writer.uint32(1162).fork())
                .ldelim();
        }
        if (message.availabilityPeriodData !== undefined) {
            CatalogAvailabilityPeriod.encode(message.availabilityPeriodData, writer.uint32(1170).fork()).ldelim();
        }
        if (message.ticketGroupData !== undefined) {
            CatalogTicketGroup.encode(message.ticketGroupData, writer.uint32(1178).fork()).ldelim();
        }
        if (message.floorPlanData !== undefined) {
            CatalogFloorPlan.encode(message.floorPlanData, writer.uint32(1186).fork()).ldelim();
        }
        if (message.floorPlanTileData !== undefined) {
            CatalogFloorPlanTile.encode(message.floorPlanTileData, writer.uint32(1194).fork()).ldelim();
        }
        if (message.creditRedemptionPolicyData !== undefined) {
            CatalogCreditRedemptionPolicy.encode(message.creditRedemptionPolicyData, writer.uint32(1210).fork()).ldelim();
        }
        if (message.ageRestrictionData !== undefined) {
            CatalogAgeRestriction.encode(message.ageRestrictionData, writer.uint32(1218).fork()).ldelim();
        }
        if (message.favoritesListPositionData !== undefined) {
            CatalogFavoritesListPosition.encode(message.favoritesListPositionData, writer.uint32(1226).fork()).ldelim();
        }
        if (message.salePriceData !== undefined) {
            CatalogSalePrice.encode(message.salePriceData, writer.uint32(1234).fork()).ldelim();
        }
        if (message.taxCategoryData !== undefined) {
            CatalogTaxCategory.encode(message.taxCategoryData, writer.uint32(1242).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.updatedAt = reader.string();
                    continue;
                case 132:
                    if (tag !== 1058) {
                        break;
                    }
                    message.createdAt = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.version = longToNumber(reader.int64());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.isDeleted = reader.bool();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.DEPRECATEDCustomAttributes.push(CatalogCustomAttributeValue.decode(reader, reader.uint32()));
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    const entry15 = CatalogObject_CustomAttributeValuesEntry.decode(reader, reader.uint32());
                    if (entry15.value !== undefined && entry15.key !== undefined) {
                        message.customAttributeValues[entry15.key] = entry15.value;
                    }
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.catalogV1Ids.push(CatalogV1Id.decode(reader, reader.uint32()));
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.presentAtAllLocations = reader.bool();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.presentAtLocationIds.push(reader.string());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.absentAtLocationIds.push(reader.string());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.imageId = reader.string();
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.itemData = CatalogItem.decode(reader, reader.uint32());
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.categoryData = CatalogCategory.decode(reader, reader.uint32());
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.itemVariationData = CatalogItemVariation.decode(reader, reader.uint32());
                    continue;
                case 106:
                    if (tag !== 850) {
                        break;
                    }
                    message.taxData = CatalogTax.decode(reader, reader.uint32());
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.discountData = CatalogDiscount.decode(reader, reader.uint32());
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.modifierListData = CatalogModifierList.decode(reader, reader.uint32());
                    continue;
                case 112:
                    if (tag !== 898) {
                        break;
                    }
                    message.modifierData = CatalogModifier.decode(reader, reader.uint32());
                    continue;
                case 113:
                    if (tag !== 906) {
                        break;
                    }
                    message.timePeriodData = CatalogTimePeriod.decode(reader, reader.uint32());
                    continue;
                case 114:
                    if (tag !== 914) {
                        break;
                    }
                    message.productSetData = CatalogProductSet.decode(reader, reader.uint32());
                    continue;
                case 115:
                    if (tag !== 922) {
                        break;
                    }
                    message.pricingRuleData = CatalogPricingRule.decode(reader, reader.uint32());
                    continue;
                case 116:
                    if (tag !== 930) {
                        break;
                    }
                    message.imageData = CatalogImage.decode(reader, reader.uint32());
                    continue;
                case 117:
                    if (tag !== 938) {
                        break;
                    }
                    message.measurementUnitData = CatalogMeasurementUnit.decode(reader, reader.uint32());
                    continue;
                case 118:
                    if (tag !== 946) {
                        break;
                    }
                    message.subscriptionPlanData = CatalogSubscriptionPlan.decode(reader, reader.uint32());
                    continue;
                case 119:
                    if (tag !== 954) {
                        break;
                    }
                    message.itemOptionData = CatalogItemOption.decode(reader, reader.uint32());
                    continue;
                case 120:
                    if (tag !== 962) {
                        break;
                    }
                    message.itemOptionValueData = CatalogItemOptionValue.decode(reader, reader.uint32());
                    continue;
                case 121:
                    if (tag !== 970) {
                        break;
                    }
                    message.customAttributeDefinitionData = CatalogCustomAttributeDefinition.decode(reader, reader.uint32());
                    continue;
                case 122:
                    if (tag !== 978) {
                        break;
                    }
                    message.quickAmountsSettingsData = CatalogQuickAmountsSettings.decode(reader, reader.uint32());
                    continue;
                case 123:
                    if (tag !== 986) {
                        break;
                    }
                    message.taxExemptionData = CatalogTaxExemption.decode(reader, reader.uint32());
                    continue;
                case 124:
                    if (tag !== 994) {
                        break;
                    }
                    message.diningOptionData = CatalogDiningOption.decode(reader, reader.uint32());
                    continue;
                case 125:
                    if (tag !== 1002) {
                        break;
                    }
                    message.resourceData = Resource.decode(reader, reader.uint32());
                    continue;
                case 127:
                    if (tag !== 1018) {
                        break;
                    }
                    message.compositionData = CatalogComposition.decode(reader, reader.uint32());
                    continue;
                case 128:
                    if (tag !== 1026) {
                        break;
                    }
                    message.componentData = CatalogComponent.decode(reader, reader.uint32());
                    continue;
                case 129:
                    if (tag !== 1034) {
                        break;
                    }
                    message.serviceChargeData = CatalogServiceCharge.decode(reader, reader.uint32());
                    continue;
                case 130:
                    if (tag !== 1042) {
                        break;
                    }
                    message.checkoutLinkData = CatalogCheckoutLink.decode(reader, reader.uint32());
                    continue;
                case 131:
                    if (tag !== 1050) {
                        break;
                    }
                    message.addressData = CatalogAddress.decode(reader, reader.uint32());
                    continue;
                case 134:
                    if (tag !== 1074) {
                        break;
                    }
                    message.ticketTemplateData = CatalogTicketTemplate.decode(reader, reader.uint32());
                    continue;
                case 135:
                    if (tag !== 1082) {
                        break;
                    }
                    message.voidReasonData = CatalogVoidReason.decode(reader, reader.uint32());
                    continue;
                case 137:
                    if (tag !== 1098) {
                        break;
                    }
                    message.menuData = CatalogMenu.decode(reader, reader.uint32());
                    continue;
                case 138:
                    if (tag !== 1106) {
                        break;
                    }
                    message.menuGroupData = CatalogMenuGroup.decode(reader, reader.uint32());
                    continue;
                case 139:
                    if (tag !== 1114) {
                        break;
                    }
                    message.pageData = CatalogPage.decode(reader, reader.uint32());
                    continue;
                case 140:
                    if (tag !== 1122) {
                        break;
                    }
                    message.pageTileData = CatalogPageTile.decode(reader, reader.uint32());
                    continue;
                case 141:
                    if (tag !== 1130) {
                        break;
                    }
                    message.placeholderData = CatalogPlaceholder.decode(reader, reader.uint32());
                    continue;
                case 142:
                    if (tag !== 1138) {
                        break;
                    }
                    message.tagData = CatalogTag.decode(reader, reader.uint32());
                    continue;
                case 143:
                    if (tag !== 1146) {
                        break;
                    }
                    message.itemVariationVendorInfoData = CatalogItemVariationVendorInfo.decode(reader, reader.uint32());
                    continue;
                case 144:
                    if (tag !== 1154) {
                        break;
                    }
                    message.configurationData = CatalogConfiguration.decode(reader, reader.uint32());
                    continue;
                case 145:
                    if (tag !== 1162) {
                        break;
                    }
                    message.subscriptionPlanVariationData = CatalogSubscriptionPlanVariation.decode(reader, reader.uint32());
                    continue;
                case 146:
                    if (tag !== 1170) {
                        break;
                    }
                    message.availabilityPeriodData = CatalogAvailabilityPeriod.decode(reader, reader.uint32());
                    continue;
                case 147:
                    if (tag !== 1178) {
                        break;
                    }
                    message.ticketGroupData = CatalogTicketGroup.decode(reader, reader.uint32());
                    continue;
                case 148:
                    if (tag !== 1186) {
                        break;
                    }
                    message.floorPlanData = CatalogFloorPlan.decode(reader, reader.uint32());
                    continue;
                case 149:
                    if (tag !== 1194) {
                        break;
                    }
                    message.floorPlanTileData = CatalogFloorPlanTile.decode(reader, reader.uint32());
                    continue;
                case 151:
                    if (tag !== 1210) {
                        break;
                    }
                    message.creditRedemptionPolicyData = CatalogCreditRedemptionPolicy.decode(reader, reader.uint32());
                    continue;
                case 152:
                    if (tag !== 1218) {
                        break;
                    }
                    message.ageRestrictionData = CatalogAgeRestriction.decode(reader, reader.uint32());
                    continue;
                case 153:
                    if (tag !== 1226) {
                        break;
                    }
                    message.favoritesListPositionData = CatalogFavoritesListPosition.decode(reader, reader.uint32());
                    continue;
                case 154:
                    if (tag !== 1234) {
                        break;
                    }
                    message.salePriceData = CatalogSalePrice.decode(reader, reader.uint32());
                    continue;
                case 155:
                    if (tag !== 1242) {
                        break;
                    }
                    message.taxCategoryData = CatalogTaxCategory.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogObject.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogObject();
        message.type = object.type ?? undefined;
        message.id = object.id ?? undefined;
        message.updatedAt = object.updatedAt ?? undefined;
        message.createdAt = object.createdAt ?? undefined;
        message.version = object.version ?? undefined;
        message.isDeleted = object.isDeleted ?? undefined;
        message.DEPRECATEDCustomAttributes =
            object.DEPRECATEDCustomAttributes?.map((e) => CatalogCustomAttributeValue.fromPartial(e)) || [];
        message.customAttributeValues = Object.entries(object.customAttributeValues ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = CatalogCustomAttributeValue.fromPartial(value);
            }
            return acc;
        }, {});
        message.catalogV1Ids = object.catalogV1Ids?.map((e) => CatalogV1Id.fromPartial(e)) || [];
        message.presentAtAllLocations = object.presentAtAllLocations ?? undefined;
        message.presentAtLocationIds = object.presentAtLocationIds?.map((e) => e) || [];
        message.absentAtLocationIds = object.absentAtLocationIds?.map((e) => e) || [];
        message.imageId = object.imageId ?? undefined;
        message.itemData = (object.itemData !== undefined && object.itemData !== null)
            ? CatalogItem.fromPartial(object.itemData)
            : undefined;
        message.categoryData = (object.categoryData !== undefined && object.categoryData !== null)
            ? CatalogCategory.fromPartial(object.categoryData)
            : undefined;
        message.itemVariationData = (object.itemVariationData !== undefined && object.itemVariationData !== null)
            ? CatalogItemVariation.fromPartial(object.itemVariationData)
            : undefined;
        message.taxData = (object.taxData !== undefined && object.taxData !== null)
            ? CatalogTax.fromPartial(object.taxData)
            : undefined;
        message.discountData = (object.discountData !== undefined && object.discountData !== null)
            ? CatalogDiscount.fromPartial(object.discountData)
            : undefined;
        message.modifierListData = (object.modifierListData !== undefined && object.modifierListData !== null)
            ? CatalogModifierList.fromPartial(object.modifierListData)
            : undefined;
        message.modifierData = (object.modifierData !== undefined && object.modifierData !== null)
            ? CatalogModifier.fromPartial(object.modifierData)
            : undefined;
        message.timePeriodData = (object.timePeriodData !== undefined && object.timePeriodData !== null)
            ? CatalogTimePeriod.fromPartial(object.timePeriodData)
            : undefined;
        message.productSetData = (object.productSetData !== undefined && object.productSetData !== null)
            ? CatalogProductSet.fromPartial(object.productSetData)
            : undefined;
        message.pricingRuleData = (object.pricingRuleData !== undefined && object.pricingRuleData !== null)
            ? CatalogPricingRule.fromPartial(object.pricingRuleData)
            : undefined;
        message.imageData = (object.imageData !== undefined && object.imageData !== null)
            ? CatalogImage.fromPartial(object.imageData)
            : undefined;
        message.measurementUnitData = (object.measurementUnitData !== undefined && object.measurementUnitData !== null)
            ? CatalogMeasurementUnit.fromPartial(object.measurementUnitData)
            : undefined;
        message.subscriptionPlanData = (object.subscriptionPlanData !== undefined && object.subscriptionPlanData !== null)
            ? CatalogSubscriptionPlan.fromPartial(object.subscriptionPlanData)
            : undefined;
        message.itemOptionData = (object.itemOptionData !== undefined && object.itemOptionData !== null)
            ? CatalogItemOption.fromPartial(object.itemOptionData)
            : undefined;
        message.itemOptionValueData = (object.itemOptionValueData !== undefined && object.itemOptionValueData !== null)
            ? CatalogItemOptionValue.fromPartial(object.itemOptionValueData)
            : undefined;
        message.customAttributeDefinitionData =
            (object.customAttributeDefinitionData !== undefined && object.customAttributeDefinitionData !== null)
                ? CatalogCustomAttributeDefinition.fromPartial(object.customAttributeDefinitionData)
                : undefined;
        message.quickAmountsSettingsData =
            (object.quickAmountsSettingsData !== undefined && object.quickAmountsSettingsData !== null)
                ? CatalogQuickAmountsSettings.fromPartial(object.quickAmountsSettingsData)
                : undefined;
        message.taxExemptionData = (object.taxExemptionData !== undefined && object.taxExemptionData !== null)
            ? CatalogTaxExemption.fromPartial(object.taxExemptionData)
            : undefined;
        message.diningOptionData = (object.diningOptionData !== undefined && object.diningOptionData !== null)
            ? CatalogDiningOption.fromPartial(object.diningOptionData)
            : undefined;
        message.resourceData = (object.resourceData !== undefined && object.resourceData !== null)
            ? Resource.fromPartial(object.resourceData)
            : undefined;
        message.compositionData = (object.compositionData !== undefined && object.compositionData !== null)
            ? CatalogComposition.fromPartial(object.compositionData)
            : undefined;
        message.componentData = (object.componentData !== undefined && object.componentData !== null)
            ? CatalogComponent.fromPartial(object.componentData)
            : undefined;
        message.serviceChargeData = (object.serviceChargeData !== undefined && object.serviceChargeData !== null)
            ? CatalogServiceCharge.fromPartial(object.serviceChargeData)
            : undefined;
        message.checkoutLinkData = (object.checkoutLinkData !== undefined && object.checkoutLinkData !== null)
            ? CatalogCheckoutLink.fromPartial(object.checkoutLinkData)
            : undefined;
        message.addressData = (object.addressData !== undefined && object.addressData !== null)
            ? CatalogAddress.fromPartial(object.addressData)
            : undefined;
        message.ticketTemplateData = (object.ticketTemplateData !== undefined && object.ticketTemplateData !== null)
            ? CatalogTicketTemplate.fromPartial(object.ticketTemplateData)
            : undefined;
        message.voidReasonData = (object.voidReasonData !== undefined && object.voidReasonData !== null)
            ? CatalogVoidReason.fromPartial(object.voidReasonData)
            : undefined;
        message.menuData = (object.menuData !== undefined && object.menuData !== null)
            ? CatalogMenu.fromPartial(object.menuData)
            : undefined;
        message.menuGroupData = (object.menuGroupData !== undefined && object.menuGroupData !== null)
            ? CatalogMenuGroup.fromPartial(object.menuGroupData)
            : undefined;
        message.pageData = (object.pageData !== undefined && object.pageData !== null)
            ? CatalogPage.fromPartial(object.pageData)
            : undefined;
        message.pageTileData = (object.pageTileData !== undefined && object.pageTileData !== null)
            ? CatalogPageTile.fromPartial(object.pageTileData)
            : undefined;
        message.placeholderData = (object.placeholderData !== undefined && object.placeholderData !== null)
            ? CatalogPlaceholder.fromPartial(object.placeholderData)
            : undefined;
        message.tagData = (object.tagData !== undefined && object.tagData !== null)
            ? CatalogTag.fromPartial(object.tagData)
            : undefined;
        message.itemVariationVendorInfoData =
            (object.itemVariationVendorInfoData !== undefined && object.itemVariationVendorInfoData !== null)
                ? CatalogItemVariationVendorInfo.fromPartial(object.itemVariationVendorInfoData)
                : undefined;
        message.configurationData = (object.configurationData !== undefined && object.configurationData !== null)
            ? CatalogConfiguration.fromPartial(object.configurationData)
            : undefined;
        message.subscriptionPlanVariationData =
            (object.subscriptionPlanVariationData !== undefined && object.subscriptionPlanVariationData !== null)
                ? CatalogSubscriptionPlanVariation.fromPartial(object.subscriptionPlanVariationData)
                : undefined;
        message.availabilityPeriodData =
            (object.availabilityPeriodData !== undefined && object.availabilityPeriodData !== null)
                ? CatalogAvailabilityPeriod.fromPartial(object.availabilityPeriodData)
                : undefined;
        message.ticketGroupData = (object.ticketGroupData !== undefined && object.ticketGroupData !== null)
            ? CatalogTicketGroup.fromPartial(object.ticketGroupData)
            : undefined;
        message.floorPlanData = (object.floorPlanData !== undefined && object.floorPlanData !== null)
            ? CatalogFloorPlan.fromPartial(object.floorPlanData)
            : undefined;
        message.floorPlanTileData = (object.floorPlanTileData !== undefined && object.floorPlanTileData !== null)
            ? CatalogFloorPlanTile.fromPartial(object.floorPlanTileData)
            : undefined;
        message.creditRedemptionPolicyData =
            (object.creditRedemptionPolicyData !== undefined && object.creditRedemptionPolicyData !== null)
                ? CatalogCreditRedemptionPolicy.fromPartial(object.creditRedemptionPolicyData)
                : undefined;
        message.ageRestrictionData = (object.ageRestrictionData !== undefined && object.ageRestrictionData !== null)
            ? CatalogAgeRestriction.fromPartial(object.ageRestrictionData)
            : undefined;
        message.favoritesListPositionData =
            (object.favoritesListPositionData !== undefined && object.favoritesListPositionData !== null)
                ? CatalogFavoritesListPosition.fromPartial(object.favoritesListPositionData)
                : undefined;
        message.salePriceData = (object.salePriceData !== undefined && object.salePriceData !== null)
            ? CatalogSalePrice.fromPartial(object.salePriceData)
            : undefined;
        message.taxCategoryData = (object.taxCategoryData !== undefined && object.taxCategoryData !== null)
            ? CatalogTaxCategory.fromPartial(object.taxCategoryData)
            : undefined;
        return message;
    },
};
function createBaseCatalogObject_CustomAttributeValuesEntry() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObject.CustomAttributeValuesEntry",
        key: undefined,
        value: undefined,
    };
}
export const CatalogObject_CustomAttributeValuesEntry = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObject.CustomAttributeValuesEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== undefined) {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            CatalogCustomAttributeValue.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogObject_CustomAttributeValuesEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = CatalogCustomAttributeValue.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogObject_CustomAttributeValuesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogObject_CustomAttributeValuesEntry();
        message.key = object.key ?? undefined;
        message.value = (object.value !== undefined && object.value !== null)
            ? CatalogCustomAttributeValue.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseCatalogObjectReference() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObjectReference",
        objectId: undefined,
        catalogVersion: undefined,
    };
}
export const CatalogObjectReference = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObjectReference",
    encode(message, writer = _m0.Writer.create()) {
        if (message.objectId !== undefined) {
            writer.uint32(10).string(message.objectId);
        }
        if (message.catalogVersion !== undefined) {
            writer.uint32(16).int64(message.catalogVersion);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogObjectReference();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.objectId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.catalogVersion = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogObjectReference.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogObjectReference();
        message.objectId = object.objectId ?? undefined;
        message.catalogVersion = object.catalogVersion ?? undefined;
        return message;
    },
};
function createBaseCatalogCustomAttributeDefinition() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition",
        type: undefined,
        name: undefined,
        description: undefined,
        sourceApplication: undefined,
        allowedObjectTypes: [],
        sellerVisibility: undefined,
        appVisibility: undefined,
        stringConfig: undefined,
        numberConfig: undefined,
        selectionConfig: undefined,
        customAttributeUsageCount: undefined,
        key: undefined,
    };
}
export const CatalogCustomAttributeDefinition = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.name !== undefined) {
            writer.uint32(18).string(message.name);
        }
        if (message.description !== undefined) {
            writer.uint32(26).string(message.description);
        }
        if (message.sourceApplication !== undefined) {
            SourceApplication.encode(message.sourceApplication, writer.uint32(34).fork()).ldelim();
        }
        writer.uint32(42).fork();
        for (const v of message.allowedObjectTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.sellerVisibility !== undefined) {
            writer.uint32(56).int32(message.sellerVisibility);
        }
        if (message.appVisibility !== undefined) {
            writer.uint32(64).int32(message.appVisibility);
        }
        if (message.stringConfig !== undefined) {
            CatalogCustomAttributeDefinition_StringConfig.encode(message.stringConfig, writer.uint32(74).fork()).ldelim();
        }
        if (message.numberConfig !== undefined) {
            CatalogCustomAttributeDefinition_NumberConfig.encode(message.numberConfig, writer.uint32(106).fork()).ldelim();
        }
        if (message.selectionConfig !== undefined) {
            CatalogCustomAttributeDefinition_SelectionConfig.encode(message.selectionConfig, writer.uint32(82).fork())
                .ldelim();
        }
        if (message.customAttributeUsageCount !== undefined) {
            writer.uint32(88).int32(message.customAttributeUsageCount);
        }
        if (message.key !== undefined) {
            writer.uint32(98).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCustomAttributeDefinition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.sourceApplication = SourceApplication.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag === 40) {
                        message.allowedObjectTypes.push(reader.int32());
                        continue;
                    }
                    if (tag === 42) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.allowedObjectTypes.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.sellerVisibility = reader.int32();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.appVisibility = reader.int32();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.stringConfig = CatalogCustomAttributeDefinition_StringConfig.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.numberConfig = CatalogCustomAttributeDefinition_NumberConfig.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.selectionConfig = CatalogCustomAttributeDefinition_SelectionConfig.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.customAttributeUsageCount = reader.int32();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCustomAttributeDefinition.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCustomAttributeDefinition();
        message.type = object.type ?? undefined;
        message.name = object.name ?? undefined;
        message.description = object.description ?? undefined;
        message.sourceApplication = (object.sourceApplication !== undefined && object.sourceApplication !== null)
            ? SourceApplication.fromPartial(object.sourceApplication)
            : undefined;
        message.allowedObjectTypes = object.allowedObjectTypes?.map((e) => e) || [];
        message.sellerVisibility = object.sellerVisibility ?? undefined;
        message.appVisibility = object.appVisibility ?? undefined;
        message.stringConfig = (object.stringConfig !== undefined && object.stringConfig !== null)
            ? CatalogCustomAttributeDefinition_StringConfig.fromPartial(object.stringConfig)
            : undefined;
        message.numberConfig = (object.numberConfig !== undefined && object.numberConfig !== null)
            ? CatalogCustomAttributeDefinition_NumberConfig.fromPartial(object.numberConfig)
            : undefined;
        message.selectionConfig = (object.selectionConfig !== undefined && object.selectionConfig !== null)
            ? CatalogCustomAttributeDefinition_SelectionConfig.fromPartial(object.selectionConfig)
            : undefined;
        message.customAttributeUsageCount = object.customAttributeUsageCount ?? undefined;
        message.key = object.key ?? undefined;
        return message;
    },
};
function createBaseCatalogCustomAttributeDefinition_StringConfig() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.StringConfig",
        enforceUniqueness: undefined,
    };
}
export const CatalogCustomAttributeDefinition_StringConfig = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.StringConfig",
    encode(message, writer = _m0.Writer.create()) {
        if (message.enforceUniqueness !== undefined) {
            writer.uint32(8).bool(message.enforceUniqueness);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCustomAttributeDefinition_StringConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.enforceUniqueness = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCustomAttributeDefinition_StringConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCustomAttributeDefinition_StringConfig();
        message.enforceUniqueness = object.enforceUniqueness ?? undefined;
        return message;
    },
};
function createBaseCatalogCustomAttributeDefinition_NumberConfig() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.NumberConfig",
        precision: undefined,
    };
}
export const CatalogCustomAttributeDefinition_NumberConfig = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.NumberConfig",
    encode(message, writer = _m0.Writer.create()) {
        if (message.precision !== undefined) {
            writer.uint32(8).int32(message.precision);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCustomAttributeDefinition_NumberConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.precision = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCustomAttributeDefinition_NumberConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCustomAttributeDefinition_NumberConfig();
        message.precision = object.precision ?? undefined;
        return message;
    },
};
function createBaseCatalogCustomAttributeDefinition_SelectionConfig() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SelectionConfig",
        maxAllowedSelections: undefined,
        allowedSelections: [],
    };
}
export const CatalogCustomAttributeDefinition_SelectionConfig = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SelectionConfig",
    encode(message, writer = _m0.Writer.create()) {
        if (message.maxAllowedSelections !== undefined) {
            writer.uint32(8).int32(message.maxAllowedSelections);
        }
        for (const v of message.allowedSelections) {
            CatalogCustomAttributeDefinition_SelectionConfig_CustomAttributeSelection.encode(v, writer.uint32(18).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCustomAttributeDefinition_SelectionConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.maxAllowedSelections = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.allowedSelections.push(CatalogCustomAttributeDefinition_SelectionConfig_CustomAttributeSelection.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCustomAttributeDefinition_SelectionConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCustomAttributeDefinition_SelectionConfig();
        message.maxAllowedSelections = object.maxAllowedSelections ?? undefined;
        message.allowedSelections =
            object.allowedSelections?.map((e) => CatalogCustomAttributeDefinition_SelectionConfig_CustomAttributeSelection.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogCustomAttributeDefinition_SelectionConfig_CustomAttributeSelection() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SelectionConfig.CustomAttributeSelection",
        uid: undefined,
        name: undefined,
    };
}
export const CatalogCustomAttributeDefinition_SelectionConfig_CustomAttributeSelection = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SelectionConfig.CustomAttributeSelection",
    encode(message, writer = _m0.Writer.create()) {
        if (message.uid !== undefined) {
            writer.uint32(10).string(message.uid);
        }
        if (message.name !== undefined) {
            writer.uint32(18).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCustomAttributeDefinition_SelectionConfig_CustomAttributeSelection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.uid = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCustomAttributeDefinition_SelectionConfig_CustomAttributeSelection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCustomAttributeDefinition_SelectionConfig_CustomAttributeSelection();
        message.uid = object.uid ?? undefined;
        message.name = object.name ?? undefined;
        return message;
    },
};
function createBaseCatalogItemOption() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemOption",
        name: undefined,
        displayName: undefined,
        description: undefined,
        showColors: undefined,
        values: [],
        itemCount: undefined,
    };
}
export const CatalogItemOption = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemOption",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.displayName !== undefined) {
            writer.uint32(18).string(message.displayName);
        }
        if (message.description !== undefined) {
            writer.uint32(26).string(message.description);
        }
        if (message.showColors !== undefined) {
            writer.uint32(32).bool(message.showColors);
        }
        for (const v of message.values) {
            CatalogObject.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.itemCount !== undefined) {
            writer.uint32(48).int64(message.itemCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItemOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.displayName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.showColors = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.values.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.itemCount = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItemOption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItemOption();
        message.name = object.name ?? undefined;
        message.displayName = object.displayName ?? undefined;
        message.description = object.description ?? undefined;
        message.showColors = object.showColors ?? undefined;
        message.values = object.values?.map((e) => CatalogObject.fromPartial(e)) || [];
        message.itemCount = object.itemCount ?? undefined;
        return message;
    },
};
function createBaseCatalogItemOptionValue() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionValue",
        itemOptionId: undefined,
        name: undefined,
        description: undefined,
        color: undefined,
        ordinal: undefined,
        itemVariationCount: undefined,
    };
}
export const CatalogItemOptionValue = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionValue",
    encode(message, writer = _m0.Writer.create()) {
        if (message.itemOptionId !== undefined) {
            writer.uint32(10).string(message.itemOptionId);
        }
        if (message.name !== undefined) {
            writer.uint32(18).string(message.name);
        }
        if (message.description !== undefined) {
            writer.uint32(26).string(message.description);
        }
        if (message.color !== undefined) {
            writer.uint32(34).string(message.color);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(40).int32(message.ordinal);
        }
        if (message.itemVariationCount !== undefined) {
            writer.uint32(48).int64(message.itemVariationCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogItemOptionValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemOptionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.itemVariationCount = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogItemOptionValue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogItemOptionValue();
        message.itemOptionId = object.itemOptionId ?? undefined;
        message.name = object.name ?? undefined;
        message.description = object.description ?? undefined;
        message.color = object.color ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.itemVariationCount = object.itemVariationCount ?? undefined;
        return message;
    },
};
function createBaseCatalogMenu() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogMenu",
        name: undefined,
        ordinal: undefined,
        productName: undefined,
        tagId: undefined,
        multiUnitMode: undefined,
    };
}
export const CatalogMenu = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogMenu",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int32(message.ordinal);
        }
        if (message.productName !== undefined) {
            writer.uint32(24).int32(message.productName);
        }
        if (message.tagId !== undefined) {
            writer.uint32(34).string(message.tagId);
        }
        if (message.multiUnitMode !== undefined) {
            writer.uint32(40).bool(message.multiUnitMode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogMenu();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.productName = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.tagId = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.multiUnitMode = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogMenu.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogMenu();
        message.name = object.name ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.productName = object.productName ?? undefined;
        message.tagId = object.tagId ?? undefined;
        message.multiUnitMode = object.multiUnitMode ?? undefined;
        return message;
    },
};
function createBaseCatalogMenuGroup() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogMenuGroup",
        itemId: undefined,
        tagId: undefined,
        parentMenuGroupId: undefined,
        itemOrdinal: undefined,
        menuGroupOrdinal: undefined,
        productName: undefined,
        isSyncedMenuGroupMembership: undefined,
    };
}
export const CatalogMenuGroup = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogMenuGroup",
    encode(message, writer = _m0.Writer.create()) {
        if (message.itemId !== undefined) {
            writer.uint32(10).string(message.itemId);
        }
        if (message.tagId !== undefined) {
            writer.uint32(18).string(message.tagId);
        }
        if (message.parentMenuGroupId !== undefined) {
            writer.uint32(26).string(message.parentMenuGroupId);
        }
        if (message.itemOrdinal !== undefined) {
            writer.uint32(32).int32(message.itemOrdinal);
        }
        if (message.menuGroupOrdinal !== undefined) {
            writer.uint32(40).int32(message.menuGroupOrdinal);
        }
        if (message.productName !== undefined) {
            writer.uint32(48).int32(message.productName);
        }
        if (message.isSyncedMenuGroupMembership !== undefined) {
            writer.uint32(56).bool(message.isSyncedMenuGroupMembership);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogMenuGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tagId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.parentMenuGroupId = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.itemOrdinal = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.menuGroupOrdinal = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.productName = reader.int32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.isSyncedMenuGroupMembership = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogMenuGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogMenuGroup();
        message.itemId = object.itemId ?? undefined;
        message.tagId = object.tagId ?? undefined;
        message.parentMenuGroupId = object.parentMenuGroupId ?? undefined;
        message.itemOrdinal = object.itemOrdinal ?? undefined;
        message.menuGroupOrdinal = object.menuGroupOrdinal ?? undefined;
        message.productName = object.productName ?? undefined;
        message.isSyncedMenuGroupMembership = object.isSyncedMenuGroupMembership ?? undefined;
        return message;
    },
};
function createBaseCatalogPage() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogPage",
        name: undefined,
        tagId: undefined,
        pageLayout: undefined,
        pageIndex: undefined,
        multiUnitMode: undefined,
    };
}
export const CatalogPage = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogPage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.tagId !== undefined) {
            writer.uint32(18).string(message.tagId);
        }
        if (message.pageLayout !== undefined) {
            writer.uint32(24).int32(message.pageLayout);
        }
        if (message.pageIndex !== undefined) {
            writer.uint32(32).int32(message.pageIndex);
        }
        if (message.multiUnitMode !== undefined) {
            writer.uint32(40).bool(message.multiUnitMode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogPage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tagId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.pageLayout = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.pageIndex = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.multiUnitMode = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogPage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogPage();
        message.name = object.name ?? undefined;
        message.tagId = object.tagId ?? undefined;
        message.pageLayout = object.pageLayout ?? undefined;
        message.pageIndex = object.pageIndex ?? undefined;
        message.multiUnitMode = object.multiUnitMode ?? undefined;
        return message;
    },
};
function createBaseCatalogPageTile() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogPageTile",
        diningOptionId: undefined,
        discountId: undefined,
        itemId: undefined,
        categoryId: undefined,
        menuGroupId: undefined,
        pageId: undefined,
        placeholderId: undefined,
        surchargeId: undefined,
        tagId: undefined,
        row: undefined,
        column: undefined,
        position: undefined,
        width: undefined,
        height: undefined,
        color: undefined,
        posDisplayName: undefined,
        imageId: undefined,
        showTileLabel: undefined,
        useColorBackground: undefined,
    };
}
export const CatalogPageTile = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogPageTile",
    encode(message, writer = _m0.Writer.create()) {
        if (message.diningOptionId !== undefined) {
            writer.uint32(10).string(message.diningOptionId);
        }
        if (message.discountId !== undefined) {
            writer.uint32(18).string(message.discountId);
        }
        if (message.itemId !== undefined) {
            writer.uint32(26).string(message.itemId);
        }
        if (message.categoryId !== undefined) {
            writer.uint32(34).string(message.categoryId);
        }
        if (message.menuGroupId !== undefined) {
            writer.uint32(42).string(message.menuGroupId);
        }
        if (message.pageId !== undefined) {
            writer.uint32(50).string(message.pageId);
        }
        if (message.placeholderId !== undefined) {
            writer.uint32(58).string(message.placeholderId);
        }
        if (message.surchargeId !== undefined) {
            writer.uint32(66).string(message.surchargeId);
        }
        if (message.tagId !== undefined) {
            writer.uint32(74).string(message.tagId);
        }
        if (message.row !== undefined) {
            writer.uint32(80).int32(message.row);
        }
        if (message.column !== undefined) {
            writer.uint32(88).int32(message.column);
        }
        if (message.position !== undefined) {
            writer.uint32(96).int32(message.position);
        }
        if (message.width !== undefined) {
            writer.uint32(104).int32(message.width);
        }
        if (message.height !== undefined) {
            writer.uint32(112).int32(message.height);
        }
        if (message.color !== undefined) {
            writer.uint32(122).string(message.color);
        }
        if (message.posDisplayName !== undefined) {
            writer.uint32(130).string(message.posDisplayName);
        }
        if (message.imageId !== undefined) {
            writer.uint32(138).string(message.imageId);
        }
        if (message.showTileLabel !== undefined) {
            writer.uint32(144).bool(message.showTileLabel);
        }
        if (message.useColorBackground !== undefined) {
            writer.uint32(152).bool(message.useColorBackground);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogPageTile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.diningOptionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.discountId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.categoryId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.menuGroupId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.pageId = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.placeholderId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.surchargeId = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.tagId = reader.string();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.row = reader.int32();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.column = reader.int32();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.position = reader.int32();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.posDisplayName = reader.string();
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.imageId = reader.string();
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.showTileLabel = reader.bool();
                    continue;
                case 19:
                    if (tag !== 152) {
                        break;
                    }
                    message.useColorBackground = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogPageTile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogPageTile();
        message.diningOptionId = object.diningOptionId ?? undefined;
        message.discountId = object.discountId ?? undefined;
        message.itemId = object.itemId ?? undefined;
        message.categoryId = object.categoryId ?? undefined;
        message.menuGroupId = object.menuGroupId ?? undefined;
        message.pageId = object.pageId ?? undefined;
        message.placeholderId = object.placeholderId ?? undefined;
        message.surchargeId = object.surchargeId ?? undefined;
        message.tagId = object.tagId ?? undefined;
        message.row = object.row ?? undefined;
        message.column = object.column ?? undefined;
        message.position = object.position ?? undefined;
        message.width = object.width ?? undefined;
        message.height = object.height ?? undefined;
        message.color = object.color ?? undefined;
        message.posDisplayName = object.posDisplayName ?? undefined;
        message.imageId = object.imageId ?? undefined;
        message.showTileLabel = object.showTileLabel ?? undefined;
        message.useColorBackground = object.useColorBackground ?? undefined;
        return message;
    },
};
function createBaseCatalogPlaceholder() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogPlaceholder",
        name: undefined,
        placeholderType: undefined,
        multiUnitMode: undefined,
    };
}
export const CatalogPlaceholder = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogPlaceholder",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.placeholderType !== undefined) {
            writer.uint32(16).int32(message.placeholderType);
        }
        if (message.multiUnitMode !== undefined) {
            writer.uint32(24).bool(message.multiUnitMode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogPlaceholder();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.placeholderType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.multiUnitMode = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogPlaceholder.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogPlaceholder();
        message.name = object.name ?? undefined;
        message.placeholderType = object.placeholderType ?? undefined;
        message.multiUnitMode = object.multiUnitMode ?? undefined;
        return message;
    },
};
function createBaseCatalogTag() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTag",
        name: undefined,
        productName: undefined,
        tagType: undefined,
        color: undefined,
        categoryId: undefined,
        multiUnitMode: undefined,
        imageId: undefined,
    };
}
export const CatalogTag = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogTag",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.productName !== undefined) {
            writer.uint32(16).int32(message.productName);
        }
        if (message.tagType !== undefined) {
            writer.uint32(24).int32(message.tagType);
        }
        if (message.color !== undefined) {
            writer.uint32(34).string(message.color);
        }
        if (message.categoryId !== undefined) {
            writer.uint32(42).string(message.categoryId);
        }
        if (message.multiUnitMode !== undefined) {
            writer.uint32(48).bool(message.multiUnitMode);
        }
        if (message.imageId !== undefined) {
            writer.uint32(138).string(message.imageId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogTag();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.productName = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.tagType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.categoryId = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.multiUnitMode = reader.bool();
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.imageId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogTag.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogTag();
        message.name = object.name ?? undefined;
        message.productName = object.productName ?? undefined;
        message.tagType = object.tagType ?? undefined;
        message.color = object.color ?? undefined;
        message.categoryId = object.categoryId ?? undefined;
        message.multiUnitMode = object.multiUnitMode ?? undefined;
        message.imageId = object.imageId ?? undefined;
        return message;
    },
};
function createBaseCatalogObjectChange() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObjectChange",
        objectId: undefined,
        latestName: undefined,
        objectType: undefined,
        parentId: undefined,
        parentLatestName: undefined,
        createdByUpdate: undefined,
        deletedByUpdate: undefined,
        attributeChanges: [],
    };
}
export const CatalogObjectChange = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogObjectChange",
    encode(message, writer = _m0.Writer.create()) {
        if (message.objectId !== undefined) {
            writer.uint32(10).string(message.objectId);
        }
        if (message.latestName !== undefined) {
            writer.uint32(18).string(message.latestName);
        }
        if (message.objectType !== undefined) {
            writer.uint32(24).int32(message.objectType);
        }
        if (message.parentId !== undefined) {
            writer.uint32(34).string(message.parentId);
        }
        if (message.parentLatestName !== undefined) {
            writer.uint32(42).string(message.parentLatestName);
        }
        if (message.createdByUpdate !== undefined) {
            writer.uint32(48).bool(message.createdByUpdate);
        }
        if (message.deletedByUpdate !== undefined) {
            writer.uint32(56).bool(message.deletedByUpdate);
        }
        for (const v of message.attributeChanges) {
            CatalogAttributeChange.encode(v, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogObjectChange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.objectId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.latestName = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.objectType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.parentId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.parentLatestName = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.createdByUpdate = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.deletedByUpdate = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.attributeChanges.push(CatalogAttributeChange.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogObjectChange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogObjectChange();
        message.objectId = object.objectId ?? undefined;
        message.latestName = object.latestName ?? undefined;
        message.objectType = object.objectType ?? undefined;
        message.parentId = object.parentId ?? undefined;
        message.parentLatestName = object.parentLatestName ?? undefined;
        message.createdByUpdate = object.createdByUpdate ?? undefined;
        message.deletedByUpdate = object.deletedByUpdate ?? undefined;
        message.attributeChanges = object.attributeChanges?.map((e) => CatalogAttributeChange.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogAttributeValue() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAttributeValue",
        stringValue: undefined,
        intValue: undefined,
        boolValue: undefined,
        moneyValue: undefined,
    };
}
export const CatalogAttributeValue = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAttributeValue",
    encode(message, writer = _m0.Writer.create()) {
        if (message.stringValue !== undefined) {
            writer.uint32(10).string(message.stringValue);
        }
        if (message.intValue !== undefined) {
            writer.uint32(16).int64(message.intValue);
        }
        if (message.boolValue !== undefined) {
            writer.uint32(24).bool(message.boolValue);
        }
        if (message.moneyValue !== undefined) {
            Money.encode(message.moneyValue, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogAttributeValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.stringValue = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.intValue = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.boolValue = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.moneyValue = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogAttributeValue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogAttributeValue();
        message.stringValue = object.stringValue ?? undefined;
        message.intValue = object.intValue ?? undefined;
        message.boolValue = object.boolValue ?? undefined;
        message.moneyValue = (object.moneyValue !== undefined && object.moneyValue !== null)
            ? Money.fromPartial(object.moneyValue)
            : undefined;
        return message;
    },
};
function createBaseCatalogNestedChange() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogNestedChange",
        id: undefined,
        createdByUpdate: undefined,
        deletedByUpdate: undefined,
        attributeChanges: [],
        latestName: undefined,
    };
}
export const CatalogNestedChange = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogNestedChange",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== undefined) {
            writer.uint32(10).string(message.id);
        }
        if (message.createdByUpdate !== undefined) {
            writer.uint32(16).bool(message.createdByUpdate);
        }
        if (message.deletedByUpdate !== undefined) {
            writer.uint32(24).bool(message.deletedByUpdate);
        }
        for (const v of message.attributeChanges) {
            CatalogAttributeChange.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.latestName !== undefined) {
            writer.uint32(42).string(message.latestName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogNestedChange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.createdByUpdate = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.deletedByUpdate = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.attributeChanges.push(CatalogAttributeChange.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.latestName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogNestedChange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogNestedChange();
        message.id = object.id ?? undefined;
        message.createdByUpdate = object.createdByUpdate ?? undefined;
        message.deletedByUpdate = object.deletedByUpdate ?? undefined;
        message.attributeChanges = object.attributeChanges?.map((e) => CatalogAttributeChange.fromPartial(e)) || [];
        message.latestName = object.latestName ?? undefined;
        return message;
    },
};
function createBaseCatalogAttributeChange() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAttributeChange",
        attributeField: undefined,
        customAttributeId: undefined,
        attributeDisplayName: undefined,
        attributeType: undefined,
        previousValue: undefined,
        newValue: undefined,
        nestedChanges: [],
    };
}
export const CatalogAttributeChange = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAttributeChange",
    encode(message, writer = _m0.Writer.create()) {
        if (message.attributeField !== undefined) {
            writer.uint32(10).string(message.attributeField);
        }
        if (message.customAttributeId !== undefined) {
            writer.uint32(18).string(message.customAttributeId);
        }
        if (message.attributeDisplayName !== undefined) {
            writer.uint32(26).string(message.attributeDisplayName);
        }
        if (message.attributeType !== undefined) {
            writer.uint32(32).int32(message.attributeType);
        }
        if (message.previousValue !== undefined) {
            CatalogAttributeValue.encode(message.previousValue, writer.uint32(42).fork()).ldelim();
        }
        if (message.newValue !== undefined) {
            CatalogAttributeValue.encode(message.newValue, writer.uint32(50).fork()).ldelim();
        }
        for (const v of message.nestedChanges) {
            CatalogNestedChange.encode(v, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogAttributeChange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.attributeField = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.customAttributeId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.attributeDisplayName = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.attributeType = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.previousValue = CatalogAttributeValue.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.newValue = CatalogAttributeValue.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.nestedChanges.push(CatalogNestedChange.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogAttributeChange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogAttributeChange();
        message.attributeField = object.attributeField ?? undefined;
        message.customAttributeId = object.customAttributeId ?? undefined;
        message.attributeDisplayName = object.attributeDisplayName ?? undefined;
        message.attributeType = object.attributeType ?? undefined;
        message.previousValue = (object.previousValue !== undefined && object.previousValue !== null)
            ? CatalogAttributeValue.fromPartial(object.previousValue)
            : undefined;
        message.newValue = (object.newValue !== undefined && object.newValue !== null)
            ? CatalogAttributeValue.fromPartial(object.newValue)
            : undefined;
        message.nestedChanges = object.nestedChanges?.map((e) => CatalogNestedChange.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogUpdate() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogUpdate",
        occurredAt: undefined,
        source: undefined,
        locationId: undefined,
        fromSquareSupport: undefined,
        employeeId: undefined,
        objectChangesCursor: undefined,
        objectChanges: [],
        id: undefined,
    };
}
export const CatalogUpdate = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogUpdate",
    encode(message, writer = _m0.Writer.create()) {
        if (message.occurredAt !== undefined) {
            writer.uint32(10).string(message.occurredAt);
        }
        if (message.source !== undefined) {
            SourceApplication.encode(message.source, writer.uint32(18).fork()).ldelim();
        }
        if (message.locationId !== undefined) {
            writer.uint32(26).string(message.locationId);
        }
        if (message.fromSquareSupport !== undefined) {
            writer.uint32(32).bool(message.fromSquareSupport);
        }
        if (message.employeeId !== undefined) {
            writer.uint32(42).string(message.employeeId);
        }
        if (message.objectChangesCursor !== undefined) {
            writer.uint32(50).string(message.objectChangesCursor);
        }
        for (const v of message.objectChanges) {
            CatalogObjectChange.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.id !== undefined) {
            writer.uint32(66).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogUpdate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.occurredAt = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.source = SourceApplication.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.fromSquareSupport = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.employeeId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.objectChangesCursor = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.objectChanges.push(CatalogObjectChange.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogUpdate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogUpdate();
        message.occurredAt = object.occurredAt ?? undefined;
        message.source = (object.source !== undefined && object.source !== null)
            ? SourceApplication.fromPartial(object.source)
            : undefined;
        message.locationId = object.locationId ?? undefined;
        message.fromSquareSupport = object.fromSquareSupport ?? undefined;
        message.employeeId = object.employeeId ?? undefined;
        message.objectChangesCursor = object.objectChangesCursor ?? undefined;
        message.objectChanges = object.objectChanges?.map((e) => CatalogObjectChange.fromPartial(e)) || [];
        message.id = object.id ?? undefined;
        return message;
    },
};
function createBaseCatalogVersion() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogVersion", updatedAt: undefined };
}
export const CatalogVersion = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogVersion",
    encode(message, writer = _m0.Writer.create()) {
        if (message.updatedAt !== undefined) {
            writer.uint32(10).string(message.updatedAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogVersion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.updatedAt = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogVersion.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogVersion();
        message.updatedAt = object.updatedAt ?? undefined;
        return message;
    },
};
function createBaseEvent() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.Event",
        uid: undefined,
        startAt: undefined,
        endAt: undefined,
        eventLocationTimeZone: undefined,
        eventLocationName: undefined,
        eventLocationTypes: [],
        onlineUrl: undefined,
        addressId: undefined,
        allDayEvent: undefined,
    };
}
export const Event = {
    $type: "squareup.connect.v2.merchant_catalog.resources.Event",
    encode(message, writer = _m0.Writer.create()) {
        if (message.uid !== undefined) {
            writer.uint32(10).string(message.uid);
        }
        if (message.startAt !== undefined) {
            writer.uint32(18).string(message.startAt);
        }
        if (message.endAt !== undefined) {
            writer.uint32(26).string(message.endAt);
        }
        if (message.eventLocationTimeZone !== undefined) {
            writer.uint32(34).string(message.eventLocationTimeZone);
        }
        if (message.eventLocationName !== undefined) {
            writer.uint32(42).string(message.eventLocationName);
        }
        writer.uint32(50).fork();
        for (const v of message.eventLocationTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.onlineUrl !== undefined) {
            writer.uint32(58).string(message.onlineUrl);
        }
        if (message.addressId !== undefined) {
            writer.uint32(66).string(message.addressId);
        }
        if (message.allDayEvent !== undefined) {
            writer.uint32(72).bool(message.allDayEvent);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.uid = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.startAt = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.endAt = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.eventLocationTimeZone = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.eventLocationName = reader.string();
                    continue;
                case 6:
                    if (tag === 48) {
                        message.eventLocationTypes.push(reader.int32());
                        continue;
                    }
                    if (tag === 50) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.eventLocationTypes.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.onlineUrl = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.addressId = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.allDayEvent = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Event.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvent();
        message.uid = object.uid ?? undefined;
        message.startAt = object.startAt ?? undefined;
        message.endAt = object.endAt ?? undefined;
        message.eventLocationTimeZone = object.eventLocationTimeZone ?? undefined;
        message.eventLocationName = object.eventLocationName ?? undefined;
        message.eventLocationTypes = object.eventLocationTypes?.map((e) => e) || [];
        message.onlineUrl = object.onlineUrl ?? undefined;
        message.addressId = object.addressId ?? undefined;
        message.allDayEvent = object.allDayEvent ?? undefined;
        return message;
    },
};
function createBaseCatalogAddress() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAddress",
        address: undefined,
        coordinates: undefined,
    };
}
export const CatalogAddress = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAddress",
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== undefined) {
            Address.encode(message.address, writer.uint32(10).fork()).ldelim();
        }
        if (message.coordinates !== undefined) {
            Coordinates.encode(message.coordinates, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.address = Address.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.coordinates = Coordinates.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogAddress.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogAddress();
        message.address = (object.address !== undefined && object.address !== null)
            ? Address.fromPartial(object.address)
            : undefined;
        message.coordinates = (object.coordinates !== undefined && object.coordinates !== null)
            ? Coordinates.fromPartial(object.coordinates)
            : undefined;
        return message;
    },
};
function createBaseCatalogVoidReason() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogVoidReason",
        name: undefined,
        ordinal: undefined,
        appointmentsType: undefined,
    };
}
export const CatalogVoidReason = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogVoidReason",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.ordinal !== undefined) {
            writer.uint32(16).int32(message.ordinal);
        }
        if (message.appointmentsType !== undefined) {
            writer.uint32(24).int32(message.appointmentsType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogVoidReason();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ordinal = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.appointmentsType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogVoidReason.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogVoidReason();
        message.name = object.name ?? undefined;
        message.ordinal = object.ordinal ?? undefined;
        message.appointmentsType = object.appointmentsType ?? undefined;
        return message;
    },
};
function createBaseCatalogConfiguration() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CatalogConfiguration", pageLayout: undefined };
}
export const CatalogConfiguration = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogConfiguration",
    encode(message, writer = _m0.Writer.create()) {
        if (message.pageLayout !== undefined) {
            writer.uint32(8).int32(message.pageLayout);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogConfiguration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.pageLayout = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogConfiguration.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogConfiguration();
        message.pageLayout = object.pageLayout ?? undefined;
        return message;
    },
};
function createBaseCatalogAvailabilityPeriod() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAvailabilityPeriod",
        startLocalTime: undefined,
        endLocalTime: undefined,
        dayOfWeek: undefined,
    };
}
export const CatalogAvailabilityPeriod = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAvailabilityPeriod",
    encode(message, writer = _m0.Writer.create()) {
        if (message.startLocalTime !== undefined) {
            writer.uint32(10).string(message.startLocalTime);
        }
        if (message.endLocalTime !== undefined) {
            writer.uint32(18).string(message.endLocalTime);
        }
        if (message.dayOfWeek !== undefined) {
            writer.uint32(24).int32(message.dayOfWeek);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogAvailabilityPeriod();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.startLocalTime = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.endLocalTime = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.dayOfWeek = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogAvailabilityPeriod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogAvailabilityPeriod();
        message.startLocalTime = object.startLocalTime ?? undefined;
        message.endLocalTime = object.endLocalTime ?? undefined;
        message.dayOfWeek = object.dayOfWeek ?? undefined;
        return message;
    },
};
function createBaseCatalogCreditRedemptionPolicy() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCreditRedemptionPolicy",
        quantity: undefined,
        pricingRuleId: undefined,
        itemVariationId: undefined,
    };
}
export const CatalogCreditRedemptionPolicy = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogCreditRedemptionPolicy",
    encode(message, writer = _m0.Writer.create()) {
        if (message.quantity !== undefined) {
            writer.uint32(8).int32(message.quantity);
        }
        if (message.pricingRuleId !== undefined) {
            writer.uint32(18).string(message.pricingRuleId);
        }
        if (message.itemVariationId !== undefined) {
            writer.uint32(26).string(message.itemVariationId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogCreditRedemptionPolicy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.quantity = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.pricingRuleId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.itemVariationId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogCreditRedemptionPolicy.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogCreditRedemptionPolicy();
        message.quantity = object.quantity ?? undefined;
        message.pricingRuleId = object.pricingRuleId ?? undefined;
        message.itemVariationId = object.itemVariationId ?? undefined;
        return message;
    },
};
function createBaseCatalogAgeRestriction() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAgeRestriction",
        name: undefined,
        minimumBuyerAge: undefined,
        minimumBuyerAgeOverrides: [],
    };
}
export const CatalogAgeRestriction = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAgeRestriction",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.minimumBuyerAge !== undefined) {
            writer.uint32(16).int32(message.minimumBuyerAge);
        }
        for (const v of message.minimumBuyerAgeOverrides) {
            CatalogAgeRestrictionLocationOverrides.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogAgeRestriction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.minimumBuyerAge = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.minimumBuyerAgeOverrides.push(CatalogAgeRestrictionLocationOverrides.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogAgeRestriction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogAgeRestriction();
        message.name = object.name ?? undefined;
        message.minimumBuyerAge = object.minimumBuyerAge ?? undefined;
        message.minimumBuyerAgeOverrides =
            object.minimumBuyerAgeOverrides?.map((e) => CatalogAgeRestrictionLocationOverrides.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCatalogAgeRestrictionLocationOverrides() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAgeRestrictionLocationOverrides",
        locationId: undefined,
        minimumBuyerAge: undefined,
    };
}
export const CatalogAgeRestrictionLocationOverrides = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogAgeRestrictionLocationOverrides",
    encode(message, writer = _m0.Writer.create()) {
        if (message.locationId !== undefined) {
            writer.uint32(10).string(message.locationId);
        }
        if (message.minimumBuyerAge !== undefined) {
            writer.uint32(16).int64(message.minimumBuyerAge);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogAgeRestrictionLocationOverrides();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.minimumBuyerAge = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogAgeRestrictionLocationOverrides.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogAgeRestrictionLocationOverrides();
        message.locationId = object.locationId ?? undefined;
        message.minimumBuyerAge = object.minimumBuyerAge ?? undefined;
        return message;
    },
};
function createBaseCatalogFavoritesListPosition() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CatalogFavoritesListPosition",
        position: undefined,
        discountId: undefined,
        itemId: undefined,
    };
}
export const CatalogFavoritesListPosition = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CatalogFavoritesListPosition",
    encode(message, writer = _m0.Writer.create()) {
        if (message.position !== undefined) {
            writer.uint32(8).int32(message.position);
        }
        if (message.discountId !== undefined) {
            writer.uint32(18).string(message.discountId);
        }
        if (message.itemId !== undefined) {
            writer.uint32(26).string(message.itemId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCatalogFavoritesListPosition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.position = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.discountId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CatalogFavoritesListPosition.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCatalogFavoritesListPosition();
        message.position = object.position ?? undefined;
        message.discountId = object.discountId ?? undefined;
        message.itemId = object.itemId ?? undefined;
        return message;
    },
};
function createBaseCreditRedemptionPolicy() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.CreditRedemptionPolicy" };
}
export const CreditRedemptionPolicy = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CreditRedemptionPolicy",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreditRedemptionPolicy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CreditRedemptionPolicy.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCreditRedemptionPolicy();
        return message;
    },
};
function createBaseMultiFieldTextFilter() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter",
        textFilter: undefined,
        fields: undefined,
        matchWholePhrase: undefined,
        enableFuzzySearch: undefined,
    };
}
export const MultiFieldTextFilter = {
    $type: "squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter",
    encode(message, writer = _m0.Writer.create()) {
        if (message.textFilter !== undefined) {
            writer.uint32(10).string(message.textFilter);
        }
        if (message.fields !== undefined) {
            MultiFieldTextFilter_FieldValues.encode(message.fields, writer.uint32(18).fork()).ldelim();
        }
        if (message.matchWholePhrase !== undefined) {
            writer.uint32(32).bool(message.matchWholePhrase);
        }
        if (message.enableFuzzySearch !== undefined) {
            writer.uint32(40).bool(message.enableFuzzySearch);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMultiFieldTextFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.textFilter = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.fields = MultiFieldTextFilter_FieldValues.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.matchWholePhrase = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.enableFuzzySearch = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return MultiFieldTextFilter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMultiFieldTextFilter();
        message.textFilter = object.textFilter ?? undefined;
        message.fields = (object.fields !== undefined && object.fields !== null)
            ? MultiFieldTextFilter_FieldValues.fromPartial(object.fields)
            : undefined;
        message.matchWholePhrase = object.matchWholePhrase ?? undefined;
        message.enableFuzzySearch = object.enableFuzzySearch ?? undefined;
        return message;
    },
};
function createBaseMultiFieldTextFilter_FieldValues() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter.FieldValues",
        any: [],
        all: [],
        none: [],
    };
}
export const MultiFieldTextFilter_FieldValues = {
    $type: "squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter.FieldValues",
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.any) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(18).fork();
        for (const v of message.all) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(26).fork();
        for (const v of message.none) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMultiFieldTextFilter_FieldValues();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag === 8) {
                        message.any.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.any.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 2:
                    if (tag === 16) {
                        message.all.push(reader.int32());
                        continue;
                    }
                    if (tag === 18) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.all.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 3:
                    if (tag === 24) {
                        message.none.push(reader.int32());
                        continue;
                    }
                    if (tag === 26) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.none.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return MultiFieldTextFilter_FieldValues.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMultiFieldTextFilter_FieldValues();
        message.any = object.any?.map((e) => e) || [];
        message.all = object.all?.map((e) => e) || [];
        message.none = object.none?.map((e) => e) || [];
        return message;
    },
};
function createBaseCustomAttributeFilter() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.resources.CustomAttributeFilter",
        customAttributeDefinitionId: undefined,
        key: undefined,
        stringFilter: undefined,
        numberFilter: undefined,
        selectionUidsFilter: [],
        boolFilter: undefined,
    };
}
export const CustomAttributeFilter = {
    $type: "squareup.connect.v2.merchant_catalog.resources.CustomAttributeFilter",
    encode(message, writer = _m0.Writer.create()) {
        if (message.customAttributeDefinitionId !== undefined) {
            writer.uint32(10).string(message.customAttributeDefinitionId);
        }
        if (message.key !== undefined) {
            writer.uint32(18).string(message.key);
        }
        if (message.stringFilter !== undefined) {
            writer.uint32(26).string(message.stringFilter);
        }
        if (message.numberFilter !== undefined) {
            Range.encode(message.numberFilter, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.selectionUidsFilter) {
            writer.uint32(42).string(v);
        }
        if (message.boolFilter !== undefined) {
            writer.uint32(48).bool(message.boolFilter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCustomAttributeFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.customAttributeDefinitionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.stringFilter = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.numberFilter = Range.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.selectionUidsFilter.push(reader.string());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.boolFilter = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return CustomAttributeFilter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCustomAttributeFilter();
        message.customAttributeDefinitionId = object.customAttributeDefinitionId ?? undefined;
        message.key = object.key ?? undefined;
        message.stringFilter = object.stringFilter ?? undefined;
        message.numberFilter = (object.numberFilter !== undefined && object.numberFilter !== null)
            ? Range.fromPartial(object.numberFilter)
            : undefined;
        message.selectionUidsFilter = object.selectionUidsFilter?.map((e) => e) || [];
        message.boolFilter = object.boolFilter ?? undefined;
        return message;
    },
};
function createBaseRange() {
    return { $type: "squareup.connect.v2.merchant_catalog.resources.Range", min: undefined, max: undefined };
}
export const Range = {
    $type: "squareup.connect.v2.merchant_catalog.resources.Range",
    encode(message, writer = _m0.Writer.create()) {
        if (message.min !== undefined) {
            writer.uint32(10).string(message.min);
        }
        if (message.max !== undefined) {
            writer.uint32(18).string(message.max);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.min = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.max = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Range.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRange();
        message.min = object.min ?? undefined;
        message.max = object.max ?? undefined;
        return message;
    },
};
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
